/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */

export var languages = [{
  "key": "de",
  "content": {
    "add": "Hinzufügen",
    "address_book": {
      "address_book": "Adressbuch",
      "address_book_icon_label": "Open Address Book",
      "company": "Firma",
      "contact_type": "Kontakttyp",
      "distribution": "Verteilergruppe",
      "employees": "Mitarbeiter",
      "name": "Name",
      "no_contact": "Keine Kontakte entsprechen Ihrer Suche",
      "personal": "Persönliches Adressbuch",
      "shared": "Freigegebenes Adressbuch"
    },
    "cancel": "Abbrechen",
    "caution": "Achtung!",
    "checkout": {
      "about_to_check_out_expire_message": "Das Auschecken läuft nach 24 Stunden ab. Andere Benutzer können die Datei weiterhin herunterladen und neue Versionen hochladen.",
      "about_to_check_out_filename": "Sie checken '{{itemName}}' aus.",
      "checkedout_multiple_action": "Möchten Sie diese Dateien wirklich {{title}}?",
      "checkedout_multiple_msg": "Mindestens eine Datei wurde ausgecheckt.",
      "checkedout_single_date": "{{userName}} hat diese Datei ausgecheckt. Das Auschecken läuft am {{checkedOutDate}} ab.",
      "checkedout_single_filename": "Möchten Sie '{{fileName}}' wirklich {{title}}?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "Sie verwerfen das Auschecken von"
    },
    "contactSelect": {
      "clearValue": "Wert löschen",
      "noResults": "Keine Ergebnisse gefunden",
      "searching": "Suchen...",
      "select": "Auswählen...",
      "start_typing": "Geben Sie die Anfangsbuchstaben ein, um Benutzer zu suchen"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Weiter",
    "continue_anyway": "Trotzdem fortfahren",
    "copy": {
      "copy": "Kopieren",
      "copy_target_not_allowed": "Das ausgewählte Element kann nicht in diesen Ordner kopiert werden. Wählen Sie einen anderen Ordner.",
      "copying_item_to": "Kopieren von '{{fileName}}' nach '{{destinationFolder}}'",
      "copying_item_to_plural": "Kopieren von {{count}} Elementen nach '{{destinationFolder}}'",
      "need_permission": "Sie haben keine Berechtigung, um Elemente hierhin zu kopieren. Wählen Sie einen anderen Unterordner oder einen anderen Ordner.",
      "title": "Kopieren"
    },
    "create_folder": "Ordner erstellen",
    "done": "Fertig",
    "favorites": "Favoriten",
    "file_list": {
      "view_all": "Alle {{count}} Elemente anzeigen"
    },
    "file_list_modal": {
      "dont_show_again": "Diese Meldung nicht mehr anzeigen",
      "move_away_selections": "Wenn Sie vom aktuellen Ordner weg navigieren, geht Ihre Auswahl verloren."
    },
    "generic_error": "Ein Fehler ist aufgetreten",
    "get_approval": {
      "add_approvers": "Genehmiger hinzufügen",
      "approvers": "Genehmiger",
      "approvers_in_order": "Genehmigungsreihenfolge",
      "approvers_tooltip": " Diese Personen müssen ihre Genehmigung erteilen. Wenn Sie eine Verteilergruppe hinzufügen, werden die Personen einzeln aufgeführt.",
      "due_date": "Fälligkeitsdatum:",
      "edit_approval_settings": "Genehmigungseinstellungen bearbeiten",
      "message": "Nachricht",
      "options": {
        "edit_approval_settings": "Genehmigungseinstellungen bearbeiten",
        "request_for_new_version": "Senden Sie eine Genehmigungsanforderung für jede neu hochgeladene Version",
        "request_for_new_version_help": "Nach jedem Upload einer neuen Version werden alle benachrichtigt, die neue Version zu genehmigen.",
        "require_login": "Teilnehmer müssen sich anmelden"
      },
      "send_for_approval": "Zur Genehmigung senden",
      "title": "Genehmigung einholen",
      "viewers": "Leseberechtigte",
      "viewers_tooltip": " Diese Personen können Informationen anzeigen und Kommentare abgeben, aber keine Genehmigung erteilen."
    },
    "load_more": "Mehr laden",
    "move": {
      "cannot_move_to_current": "Verschieben zum aktuellen Speicherort nicht möglich. Wählen Sie einen anderen Ordner oder Unterordner.",
      "cannot_move_to_selected": "Verschieben in einen der zurzeit ausgewählten Ordner nicht möglich. Wählen Sie einen anderen Ordner oder Unterordner.",
      "move": "Verschieben",
      "move_target_not_allowed": "Das ausgewählte Element kann nicht in diesen Ordner verschoben werden. Wählen Sie einen anderen Ordner.",
      "moving_item_to": "Verschieben von '{{fileName}}' nach '{{destinationFolder}}'",
      "moving_item_to_plural": "Verschieben von {{count}} Elementen nach '{{destinationFolder}}'",
      "need_permission": "Sie haben keine Berechtigung, um Elemente hierher zu verschieben. Wählen Sie einen anderen Ordner oder Unterordner.",
      "title": "Verschieben"
    },
    "no": "Nein",
    "persistent_links": {
      "copy": "Kopieren",
      "copy_to_clipboard": "Link wurde in Zwischenablage kopiert",
      "create_link": "Link erstellen",
      "create_new_link": "Einen weiteren Link erstellen",
      "delete_link": "Link löschen",
      "delete_modal_cancel_text": "Abbrechen",
      "delete_modal_confirm_text": "Link löschen",
      "delete_modal_message": "Wenn Sie diesen Link löschen, ist er nicht mehr zugänglich. Möchten Sie den Zugriff wirklich entfernen?",
      "edit_options": "Optionen bearbeiten",
      "expiry_day": "Läuft in einem Tag ab",
      "expiry_days": "Läuft in {{remainingDays}} Tagen ab",
      "items": "Elemente",
      "links_to_version": "Verknüpfung mit einer Version, die am {{creationDate}} um {{creationTime}} erstellt wurde",
      "notify_link_access": "Mich vom Zugriff auf den Link benachrichtigen",
      "notify_link_access_request": "Mich bei Dateiupload benachrichtigen",
      "replace_link": "Link ersetzen",
      "replace_modal_confirm_text": "Link ersetzen",
      "replace_modal_message": "Wenn Sie diesen Link ersetzen, wird ein neuer Link mit denselben Berechtigungen erstellt. Der alte Link wird unzugänglich. Möchten Sie den Zugriff wirklich entfernen?",
      "toast": {
        "link_created": "Link wurde erstellt und in die Zwischenablage kopiert"
      },
      "view_all_items": "Alle Elemente anzeigen"
    },
    "personal_folders": "Persönliche Ordner",
    "progress": {
      "finalize_upload": "Upload beenden...",
      "hour_remaining": "{{hoursRemaining}} Std. ",
      "less_1_min_remaining": "weniger als eine Minute",
      "minute_remaining": "{{minutesRemaining}} Min. ",
      "remaining": "{{remainingTimeDisplay}} verbleiben ",
      "retrying": "Uploadfehler: erneuter Versuch",
      "second_remaining": "{{secondsRemaining}} Sek. ",
      "shouldnt_take_long": "Das sollte nicht lange dauern...",
      "starting_upload": "Upload wird gestartet...",
      "transfer_progress": "{{progress}} von {{total}}"
    },
    "save": "Speichern",
    "select": "Auswählen",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Signieren nicht möglich",
      "title": "Zur Signatur senden"
    },
    "share": {
      "access_expires": "Ablauf des Zugriffs",
      "add_files_from_device": "Elemente von meinem Gerät hinzufügen",
      "add_files_from_sharefile": "Elemente von ShareFile hinzufügen",
      "add_items": "Elemente hinzufügen",
      "add_more_items": "Weitere Elemente hinzufügen",
      "back": "Zurück",
      "breadcrumbs": "In '{{breadcrumbs}}'",
      "cancel": "Abbrechen",
      "cancel_confirm": "Möchten Sie die Nachricht wirklich abbrechen?",
      "compose": "Erstellen",
      "copy": "Kopieren",
      "copy_success": "In Zwischenablage kopiert.",
      "create_and_copy": "Erstellen und kopieren",
      "default_message_subject": "{{name}} hat Ihnen Dateien gesendet",
      "default_message_subject_request": "{{name}} hat Dateien von Ihnen angefordert",
      "done": "Fertig",
      "download": "Download",
      "edit": "Bearbeiten",
      "edit_link_options": "Linkoptionen bearbeiten",
      "edit_message_options": "Nachrichtenoptionen bearbeiten",
      "edit_options": "Optionen bearbeiten",
      "edit_sign_in": "Bearbeiten (Anmeldung erforderlich)",
      "email_title": "E-Mail mit ShareFile",
      "empty_folder": "Dieser Ordner ist leer",
      "encrypt_message": "Diese E-Mail verschlüsseln",
      "encrypted_message_send_success": "Die verschlüsselte Nachricht wurde gesendet",
      "expiration_changed": "Das Ablaufdatum von mindestens einem der ausgewählten Elemente ist früher als das der ausgewählten Linkoptionen.",
      "file_box": "Dateibox",
      "file_location": "Dateispeicherort",
      "from_my_device": "Von meinem Gerät",
      "get_a_link": "Link anfordern",
      "get_a_link2": "Link anfordern",
      "get_temp_link": "Temporären Link erhalten",
      "groups_not_supported": "Verteilergruppen werden für verschlüsselte Nachrichten nicht unterstützt.",
      "link_options": "Linkoptionen",
      "message": "Nachricht",
      "message_encrypted": "Diese Nachricht ist verschlüsselt.",
      "message_options": "Nachrichtenoptionen",
      "message_send_fail_attachment": "Ihre Nachricht wurde nicht gesendet, weil die Datei {{file}} nicht angehängt werden konnte.",
      "message_send_fail_hard": "Die Nachricht konnte nicht gesendet werden. Versuchen Sie es später erneut.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Empfänger können nach der Anmeldung Dateien herunterladen.",
            "require_user_info": "Jeder kann auf diesen Link zugreifen, wenn er die E-Mail-Adresse eines Empfängers eingeben kann."
          },
          "no_require_login": {
            "view_download": "Dadurch wird ein Link erstellt, über den jeder das, was Sie freigeben, herunterladen kann, ohne sich anzumelden.",
            "view_only": "Dadurch wird ein Link erstellt, über den jeder sehen kann, was Sie freigeben, ohne sich anzumelden."
          },
          "require_login": {
            "view_download": "Empfänger können nach der Anmeldung Dateien herunterladen.",
            "view_download_edit": "Empfänger können nach der Anmeldung Dateien bearbeiten.",
            "view_download_watermark": "Empfänger können nach der Anmeldung Dateien mit einem Wasserzeichen herunterladen.",
            "view_only": "Empfänger können nach der Anmeldung Dateien online anzeigen.",
            "view_watermark": "Empfänger können nach der Anmeldung Dateien mit einem Wasserzeichen online anzeigen."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Jeder kann herunterladen, ohne sich anzumelden.",
            "view_download_watermark": "Jeder kann ohne Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
            "view_only": "Jeder kann anzeigen, ohne sich anzumelden.",
            "view_watermark": "Jeder kann eine Kopie mit Wasserzeichen anzeigen, ohne sich anzumelden."
          },
          "employee_and_client_only": {
            "view_download": "Benutzer können nach der Anmeldung herunterladen.",
            "view_download_edit": "Benutzer können nach der Anmeldung bearbeiten.",
            "view_download_watermark": "Benutzer können nach der Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
            "view_only": "Benutzer können nach der Anmeldung anzeigen.",
            "view_watermark": "Benutzer können nach der Anmeldung eine Kopie mit Wasserzeichen anzeigen."
          },
          "employee_only": {
            "view_download": "Mitarbeiter können nach der Anmeldung Dateien herunterladen.",
            "view_download_edit": "Mitarbeiter können nach der Anmeldung Dateien bearbeiten.",
            "view_download_watermark": "Mitarbeiter können nach der Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
            "view_only": "Mitarbeiter können nach der Anmeldung anzeigen.",
            "view_watermark": "Mitarbeiter können nach der Anmeldung eine Kopie mit Wasserzeichen anzeigen."
          },
          "require_user_info": {
            "view_download": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung herunterladen.",
            "view_download_watermark": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
            "view_only": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung anzeigen.",
            "view_watermark": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung eine Kopie mit Wasserzeichen anzeigen."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Empfänger können hochladen, ohne sich anzumelden.",
            "require_login": "Empfänger können nach der Anmeldung Dateien hochladen."
          },
          "link": {
            "anonymous": "Jeder kann hochladen, ohne sich anzumelden.",
            "employee_and_client_only": "Benutzer können nach der Anmeldung hochladen.",
            "employee_only": "Mitarbeiter können nach der Anmeldung Dateien hochladen.",
            "require_user_info": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung hochladen."
          }
        }
      },
      "no_files_error": "Fügen Sie mindestens eine Datei hinzu.",
      "no_items": "Keine Elemente",
      "options": {
        "access": "Zugriffsoptionen",
        "access_options": {
          "for_tracking_only": "Nur zum Zweck der Nachverfolgung.",
          "label": "Zugriff auf diesen Link:",
          "message_for_hipaa": "Sie können keine Dateien öffentlich freigeben, weil die HIPAA-Unterstützung für Ihr Konto aktiviert ist. Wenden Sie sich an Ihren Administrator.",
          "message_for_hipaa_edit": "Sie können keine Dateien bearbeiten, da die HIPAA-Unterstützung für Ihr Konto aktiviert ist. Wenden Sie sich bitte an Ihren Administrator.",
          "selections": {
            "anyone": "Jeder (öffentlich)",
            "clients_and_employees": "Kunden- und Mitarbeiterbenutzer (nach der Anmeldung)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Mitarbeiterbenutzer (nach der Anmeldung)",
            "name_and_email": "Jeder (öffentlich, muss einen Namen und eine E-Mail eingeben)"
          },
          "set_by_admin": "Ihr Administrator hat diese Option festgelegt.",
          "tooltip": "Dies sind die Empfängeranforderungen für diesen Link. Mitarbeiterbenutzer sind normalerweise Personen in Ihrem Unternehmen."
        },
        "add_watermark": "Wasserzeichen hinzufügen",
        "allow_recipients": {
          "edit_about_link": "Informationen zur Office Online-Bearbeitung",
          "edit_tooltip": "Mit Bearbeitungszugriffsrechten können Benutzer die freigegebenen Dateien online bearbeiten. Einige Dateitypen unterstützen keine Bearbeitung.",
          "select_label": "Empfänger haben folgende Berechtigungen:",
          "tooltip": "Die Option 'Nur Online-Ansicht' verhindert, dass Benutzer die Datei herunterladen. Einige Dateitypen unterstützen keine Nur-Ansicht-Freigabe und keine Wasserzeichen.",
          "tooltip_about_view_only_link": "Info zur Nur-Ansicht-Freigabe",
          "tooltip_about_watermarking_link": "Info über Wasserzeichen"
        },
        "downloads_limits": {
          "unlimited": "Unbegrenzt"
        },
        "downloads_per_user": "Downloads pro Benutzer",
        "edit_disabled_message": "Ihre Freigabeeinstellungen haben sich geändert, weil Sie eine Datei hinzugefügt haben, die keine Bearbeitung unterstützt.",
        "edit_options_access_level_warning": {
          "FullControl": "Jeder kann ohne Anmeldung herunterladen, was Sie freigeben.",
          "ViewOnline": "Jeder kann ohne Anmeldung anzeigen, was Sie freigeben."
        },
        "edit_options_warning": "Die Berechtigungen ändern sich für alle, die diesen Link bereits haben. Sie können einen neuen Link erstellen, wenn Sie diesen Link nicht ändern möchten.",
        "edit_permission_alert_message": "Zum Bearbeiten müssen Empfänger sich anmelden.",
        "email_me_accessed": "Mir bei Dateizugriff E-Mail senden",
        "encrypt_email": "E-Mail verschlüsseln",
        "encrypt_message": "Verschlüsseln Sie Ihre E-Mail-Nachricht, um den Schutz zu verstärken. Hinweis: Ihre Dateien sind bereits verschlüsselt.",
        "encrypted_email_enabled": "Die Zugriffsoptionen wurden angepasst, da verschlüsselte E-Mails aktiviert wurden.",
        "expirations": {
          "after_one_day": "nach einem Tag",
          "after_one_week": "nach einer Woche",
          "after_six_months": "nach 6 Monaten",
          "after_three_months": "nach 3 Monaten",
          "after_x_days": "nach {{days}} Tagen",
          "after_year": "nach einem Jahr",
          "never": "nie"
        },
        "latest_version": "Verknüpfung immer mit der neuesten Version der Datei",
        "latest_version_help": "Wenn Sie diese Option deaktivieren, wird nur für die von Ihnen ausgewählte Kopie der Datei ein Link erstellt.",
        "notifications": "Benachrichtigungen",
        "notify_me_accessed": "Mich vom Zugriff auf den Link benachrichtigen",
        "persistent_link_conflict": "Sie haben bereits einen Link mit diesen Berechtigungen erstellt.",
        "require_login": "Empfänger müssen sich anmelden",
        "require_login_help": "Empfänger lesen die Nachricht und laden die Anlagen nach der Anmeldung bei ShareFile herunter",
        "require_login_help_request": "Empfänger lesen die Nachricht und laden die Anlagen nach der Anmeldung bei ShareFile hoch",
        "send_copy": "Kopie der E-Mail an mich senden",
        "views_per_user": "Ansichten pro Benutzer"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Empfänger dieses Links können nach der Anmeldung Dateien herunterladen.",
            "require_user_info": "Empfänger dieses Links können nach der Eingabe von Name und E-Mail-Adresse Dateien herunterladen."
          },
          "no_require_login": {
            "view_download": "Empfänger dieses Links können Dateien anzeigen und herunterladen.",
            "view_only": "Empfänger dieses Links können Dateien online anzeigen."
          },
          "require_login": {
            "view_download": "Empfänger dieses Links können nach der Anmeldung Dateien anzeigen und herunterladen.",
            "view_download_edit": "Empfänger dieses Links können nach der Anmeldung Dateien anzeigen, herunterladen und bearbeiten.",
            "view_download_watermark": "Empfänger dieses Links können nach der Anmeldung Dateien mit einem Wasserzeichen anzeigen und herunterladen.",
            "view_only": "Empfänger dieses Links können nach der Anmeldung Dateien online anzeigen.",
            "view_watermark": "Empfänger dieses Links können nach der Anmeldung Dateien mit einem Wasserzeichen online anzeigen."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Jeder mit diesem Link kann Dateien anzeigen und herunterladen.",
            "view_download_watermark": "Jeder mit diesem Link kann Dateien mit einem Wasserzeichen anzeigen und herunterladen.",
            "view_only": "Jeder mit diesem Link kann Dateien online anzeigen.",
            "view_watermark": "Jeder mit diesem Link kann Dateien mit einem Wasserzeichen anzeigen."
          },
          "employee_and_client_only": {
            "view_download": "Benutzer mit diesem Link können nach der Anmeldung Dateien anzeigen und herunterladen.",
            "view_download_edit": "Benutzer mit diesem Link können nach der Anmeldung Dateien anzeigen, herunterladen und bearbeiten.",
            "view_download_watermark": "Benutzer mit diesem Link können nach der Anmeldung Dateien mit einem Wasserzeichen anzeigen und herunterladen.",
            "view_only": "Benutzer mit diesem Link können nach der Anmeldung Dateien online anzeigen.",
            "view_watermark": "Benutzer mit diesem Link können nach der Anmeldung Dateien mit einem Wasserzeichen online anzeigen."
          },
          "employee_only": {
            "view_download": "Mitarbeiter mit diesem Link können nach der Anmeldung Dateien anzeigen und herunterladen.",
            "view_download_edit": "Mitarbeiter mit diesem Link können nach der Anmeldung Dateien anzeigen, herunterladen und bearbeiten.",
            "view_download_watermark": "Mitarbeiter mit diesem Link können nach der Anmeldung Dateien mit einem Wasserzeichen anzeigen und herunterladen.",
            "view_only": "Mitarbeiter mit diesem Link können nach der Anmeldung Dateien online anzeigen.",
            "view_watermark": "Mitarbeiter mit diesem Link können nach der Anmeldung Dateien online mit einem Wasserzeichen anzeigen."
          },
          "require_user_info": {
            "view_download": "Jeder mit diesem Link kann nach Eingabe von Name und E-Mail-Adresse Dateien anzeigen und herunterladen.",
            "view_download_watermark": "Jeder mit diesem Link kann nach Eingabe von Name und E-Mail-Adresse Dateien mit einem Wasserzeichen anzeigen und herunterladen.",
            "view_only": "Jeder mit diesem Link kann nach Eingabe von Name und E-Mail-Adresse Dateien online anzeigen.",
            "view_watermark": "Jeder mit diesem Link kann nach Eingabe von Name und E-Mail-Adresse Dateien online mit einem Wasserzeichen anzeigen."
          }
        }
      },
      "progress": {
        "progress": "Status",
        "sending": "Senden. Bitte lassen Sie das Fenster offen.",
        "upload_then_send": "Upload und Senden der Datei. Bitte lassen Sie das Fenster offen."
      },
      "remember_message": "Betreff und Nachricht merken",
      "request": "Anfordern",
      "request_files": "Dateien anfordern",
      "required": "* Erforderlich",
      "send": "Senden",
      "send_to_specific_people": "An bestimmte Personen senden",
      "sending_cancel_confirm": "Möchten Sie die Nachricht wirklich abbrechen? Sie wird gerade gesendet.",
      "share_access_label": "Personen mit diesem Link Folgendes erlauben",
      "share_bundle": "Paket freigeben",
      "share_files": "Dateien freigeben",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Empfänger können nach der Anmeldung Dateien herunterladen.",
              "require_user_info": "Jeder kann zugreifen, wenn er die E-Mail-Adresse eines Empfängers eingeben kann."
            },
            "no_require_login": {
              "view_download": "Jeder kann herunterladen, ohne sich anzumelden.",
              "view_only": "Jeder kann anzeigen, ohne sich anzumelden."
            },
            "require_login": {
              "view_download": "Empfänger können nach der Anmeldung Dateien herunterladen.",
              "view_download_edit": "Empfänger können nach der Anmeldung Dateien bearbeiten.",
              "view_download_watermark": "Empfänger können nach der Anmeldung Dateien mit einem Wasserzeichen herunterladen.",
              "view_only": "Empfänger können nach der Anmeldung Dateien online anzeigen.",
              "view_watermark": "Empfänger können nach der Anmeldung Dateien mit einem Wasserzeichen online anzeigen."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Jeder kann herunterladen, ohne sich anzumelden.",
              "view_download_watermark": "Jeder kann ohne Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
              "view_only": "Jeder kann anzeigen, ohne sich anzumelden.",
              "view_watermark": "Jeder kann eine Kopie mit Wasserzeichen anzeigen, ohne sich anzumelden."
            },
            "employee_and_client_only": {
              "view_download": "Benutzer können nach der Anmeldung herunterladen.",
              "view_download_edit": "Benutzer können nach der Anmeldung bearbeiten.",
              "view_download_watermark": "Benutzer können nach der Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
              "view_only": "Benutzer können nach der Anmeldung anzeigen.",
              "view_watermark": "Benutzer können nach der Anmeldung eine Kopie mit Wasserzeichen anzeigen."
            },
            "employee_only": {
              "view_download": "Mitarbeiter können nach der Anmeldung Dateien herunterladen.",
              "view_download_edit": "Mitarbeiter können nach der Anmeldung Dateien bearbeiten.",
              "view_download_watermark": "Mitarbeiter können nach der Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
              "view_only": "Mitarbeiter können nach der Anmeldung anzeigen.",
              "view_watermark": "Mitarbeiter können nach der Anmeldung eine Kopie mit Wasserzeichen anzeigen."
            },
            "require_user_info": {
              "view_download": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung herunterladen.",
              "view_download_watermark": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung eine Kopie mit Wasserzeichen herunterladen.",
              "view_only": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung anzeigen.",
              "view_watermark": "Bei Eingabe von Name und E-Mail-Adresse kann jeder ohne Anmeldung eine Kopie mit Wasserzeichen anzeigen."
            }
          }
        },
        "analyzing_file_content": "Dateiinhalt wird analysiert...",
        "apply_recommended_options": "Empfohlene Optionen anwenden",
        "applying_recommended_options": "Empfohlene Optionen werden angewendet",
        "create_secure_link": "Sicheren Link erstellen",
        "data_found": "Gefundene Daten:",
        "expiry_tooltip": {
          "after_one_day": "Der Link läuft nach einem Tag ab.",
          "after_one_week": "Der Link läuft nach einer Woche ab.",
          "after_six_months": "Der Link läuft nach sechs Monaten ab.",
          "after_three_months": "Der Link läuft nach drei Monaten ab.",
          "after_x_days": "Der Link läuft nach {{days}} Tagen ab.",
          "after_year": "Der Link läuft nach einem Jahr ab.",
          "never": "Der Link läuft nie ab."
        },
        "feedback": {
          "helpful": "Hilfreich",
          "not_helpful": "Nicht hilfreich",
          "was_this_helpful": "War dies hilfreich?"
        },
        "file_may_contain_personal_information": "Diese Datei kann personenbezogene Daten enthalten.",
        "file_may_contain_sensitive_information": "Diese Datei enthält sensible Informationen.",
        "pii_marker_type": {
          "ADDRESS": "Adresse",
          "AGE": "Alter",
          "AWS_ACCESS_KEY": "AWS-Zugriffsschlüssel",
          "AWS_SECRET_KEY": "Geheimer Schlüssel für AWS",
          "BANK_ACCOUNT_NUMBER": "Bankkontonummer",
          "BANK_ROUTING": "Bankleitzahl",
          "CA_HEALTH_NUMBER": "Kanadische Gesundheitsnummer",
          "CA_SOCIAL_INSURANCE_NUMBER": "Kanadische Sozialversicherungsnummer",
          "CREDIT_DEBIT_CVV": "Kredit-/Debitkarten-CVV",
          "CREDIT_DEBIT_EXPIRY": "Kredit-/Debitkarten-Ablauf",
          "CREDIT_DEBIT_NUMBER": "Kredit-/Debitkartennummer",
          "DATE_TIME": "Datum/Uhrzeit",
          "DRIVER_ID": "Führerschein",
          "EMAIL": "E-Mail",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Internationale Bankkontonummer (IBAN)",
          "IN_AADHAAR": "Indische Aadhaar-Kartennummer",
          "IN_NREGA": "Indien NREGA-Nummer",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Indische permanente Kontonummer (PAN)",
          "IN_VOTER_NUMBER": "Indien Wählernummer",
          "IP_ADDRESS": "IP-Adresse",
          "LICENSE_PLATE": "Kennzeichen",
          "MAC_ADDRESS": "MAC-Adresse",
          "NAME": "Name",
          "PASSPORT_NUMBER": "Reisepassnummer",
          "PASSWORD": "Kennwort",
          "PHONE": "Telefon",
          "PIN": "PIN",
          "SSN": "Sozialversicherungsnummer (SSN)",
          "SWIFT_CODE": "SWIFT-Code",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Britische National Health Service-Nummer",
          "UK_NATIONAL_INSURANCE_NUMBER": "Nationale britische Versicherungsnummer",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Eindeutige britische Steuernummer",
          "URL": "URL",
          "USERNAME": "Benutzername",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "US-Steueridentifikationsnummer (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "Fahrzeugidentifikationsnummer (FIN)"
        },
        "recommended_tag": "Empfohlen",
        "skip": "Überspringen",
        "view_details": "Details anzeigen",
        "we_are_still_working_on_it": "Wir arbeiten noch daran..."
      },
      "subject": "Betreff",
      "title": "Freigeben",
      "to": "An",
      "toast": {
        "connector_filebox_recipients": "Diese Datei wird in die Dateibox kopiert. Empfänger haben u. U. nicht sofort Zugriff.",
        "multiple_source_error": "Alle Elemente müssen aus derselben Datenquelle stammen.",
        "scan_warning": "Es gibt eine große Datei in dieser Freigabe. Sie können Ihren Link senden, aber der Download ist möglicherweise für mehrere Minuten nicht verfügbar, während unser Virenscan abgeschlossen ist.",
        "send_success": "Element(e) wurde(n) gesendet.",
        "share_request_success": "Die Anforderung wurde gesendet",
        "share_send_success": "Freigabe wurde gesendet",
        "upload_error": "Mindestens eine Datei wurde nicht hochgeladen.",
        "upload_in_progress": "Ein Upload wird durchgeführt. Bitte lassen Sie das Fenster geöffnet."
      },
      "upload_location": "Uploadspeicherort",
      "view": "Anzeigen",
      "view_access_expires": "Ansichtzugriff läuft ab"
    },
    "shared_folders": "Freigegebene Ordner",
    "treeview": {
      "cancel": "Abbrechen",
      "current_location": "(Aktueller Speicherort)",
      "folder_created": "Ordner wurde erstellt",
      "folder_name": "Ordnername",
      "folder_name_length_error": "Der Ordnername darf nicht mehr als {{value}} Zeichen haben.",
      "save": "Speichern",
      "untitled": "Unbenannt"
    },
    "upload": {
      "add_more": "Weitere hinzufügen",
      "browse_files": "Dateien durchsuchen",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Abbrechen",
      "clear_all": "Auswahl aufheben",
      "drag_drop": "Dateien hier einfügen",
      "drop_files_here": "Dateien hier einfügen",
      "edit": "Bearbeiten",
      "failed": "Fehler",
      "file_name": "Dateiname",
      "folder_warning": "Mindestens eine der eingefügten Dateien ist ein Ordner. Der Upload von Ordnern wird zurzeit nicht unterstützt.",
      "from_computer": "Von Computer",
      "from_sharefile": "Von ShareFile",
      "item_details": "Details",
      "item_failed_to_upload": "Fehler beim Upload von Element",
      "items_selected": "Element",
      "more_than_one_item_selected": "Elemente",
      "overwrite_same_name": "Dateien mit demselben Namen überschreiben.",
      "prevent_folders": "Freigabe von Ordnern ist mit dieser Option nicht verfügbar. Verwenden Sie einzelne Dateien.",
      "save": "Speichern",
      "upload": "Upload",
      "upload_to": "Hochladen in '{{folderName}}'",
      "uploaded": "Hochgeladen"
    },
    "validation": {
      "enter_required_value": "Dieses Feld ist erforderlich."
    },
    "virus": {
      "contact_admin": "Wenden Sie sich an Ihren Administrator, wenn Sie der Meinung sind, dass dies ein Fehler ist.",
      "file_marked_as_false_positive_title": "Schädlicher Inhalt erkannt",
      "file_marked_as_false_positive_warn": "Wir haben schädlichen Inhalt in dieser Datei entdeckt. Ihr Administrator hat den Zugriff wiederhergestellt, aber wir können nicht garantieren, dass es sicher ist, die Datei zu öffnen.",
      "malicious_file": "Diese Datei wurde als schädlich identifiziert und enthält möglicherweise einen Virus.",
      "malicious_file_block": "Wir haben schädlichen Inhalt erkannt und den Zugriff auf diese Datei eingeschränkt. Wir empfehlen, die Datei zu löschen.",
      "malicious_file_block_action": "Sie haben eine Datei mit schädlichem Inhalt ausgewählt.",
      "malicious_file_block_archive": "Wir haben schädlichen Inhalt erkannt und den Zugriff auf diese Datei eingeschränkt.",
      "malicious_file_title": "Schädliche Datei erkannt",
      "malicious_file_warn": "Wir haben schädlichen Inhalt in dieser Datei erkannt. Wir empfehlen, die Datei zu löschen.",
      "malicious_file_warn_action": "Sie haben eine Datei mit schädlichem Inhalt ausgewählt. Wir empfehlen, die Datei zu löschen.",
      "malicious_file_warn_archive": "Wir haben schädlichen Inhalt in dieser Datei erkannt.",
      "unscanned_file_block": "Diese Datei wird auf schädlichen Inhalt überprüft. Aktualisieren Sie, um den neuesten Status anzuzeigen.",
      "unscanned_file_block_action": "Die ausgewählte Datei wird auf schädlichen Inhalt gescannt. Versuchen Sie es später noch einmal.",
      "unscanned_file_block_title": "Dateiscan wird ausgeführt"
    },
    "yes": "Ja",
    "you": "Sie"
  }
}, {
  "key": "en",
  "content": {
    "add": "Add",
    "address_book": {
      "address_book": "Address Book",
      "address_book_icon_label": "Open Address Book",
      "company": "Company",
      "contact_type": "Contact type",
      "distribution": "Distribution Group",
      "employees": "Employees",
      "name": "Name",
      "no_contact": "No contacts matched your search",
      "personal": "Personal Address Book",
      "shared": "Shared Address Book"
    },
    "cancel": "Cancel",
    "caution": "Caution",
    "checkout": {
      "about_to_check_out_expire_message": "Your check out will expire in 24 hours. Other users will be able to see that you've checked out the file and will still be able to download it.",
      "about_to_check_out_filename": "You are about to check out '{{itemName}}'.",
      "checkedout_multiple_action": "Are you sure you want to {{title}} these files?",
      "checkedout_multiple_msg": "One or more files are checked out.",
      "checkedout_single_date": "{{userName}} checked out this file. The check out will expire on {{checkedOutDate}}.",
      "checkedout_single_filename": "Are you sure you want to {{title}} '{{fileName}}'?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "You are about to discard the check out of"
    },
    "contactSelect": {
      "clearValue": "Clear value",
      "noResults": "No results found",
      "searching": "Searching...",
      "select": "Select...",
      "start_typing": "Start typing to find users"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Continue",
    "continue_anyway": "Continue anyway",
    "copy": {
      "copy": "Copy",
      "copy_target_not_allowed": "The item you have selected cannot be copied to this folder. Please try a different folder.",
      "copying_item_to": "Copying \"{{fileName}}\" to {{destinationFolder}}",
      "copying_item_to_plural": "Copying {{count}} items to {{destinationFolder}}",
      "need_permission": "Need permission to copy here. Try a different subfolder or a different folder.",
      "title": "Copying"
    },
    "create_folder": "Create Folder",
    "done": "Done",
    "favorites": "Favorites",
    "file_list": {
      "view_all": "View all {{count}} items"
    },
    "file_list_modal": {
      "dont_show_again": "Don't show this message again",
      "move_away_selections": "If you move away from your current folder, your selections will be lost."
    },
    "generic_error": "An error has occurred",
    "get_approval": {
      "add_approvers": "Add Approvers",
      "approvers": "Approvers",
      "approvers_in_order": "Approvers must approve in order",
      "approvers_tooltip": " These individuals are required to provide approval. If you add a distribution group, people are listed individually.",
      "due_date": "Due Date:",
      "edit_approval_settings": "Edit Approval Settings",
      "message": "Message",
      "options": {
        "edit_approval_settings": "Edit Approval Settings",
        "request_for_new_version": "Send an approval request for each new version uploaded",
        "request_for_new_version_help": "Each time a new version is uploaded, everyone is notified to approve the new version.",
        "require_login": "Require participants to log in"
      },
      "send_for_approval": "Send for approval",
      "title": "Get Approval",
      "viewers": "Viewers",
      "viewers_tooltip": " These individuals can view information and make comments, but cannot approve."
    },
    "load_more": "Load more",
    "move": {
      "cannot_move_to_current": "Cannot move to the current location. Try a different subfolder or a different folder.",
      "cannot_move_to_selected": "Cannot move to a folder that is currently selected. Try a different subfolder or a different folder.",
      "move": "Move",
      "move_target_not_allowed": "The item you have selected cannot be moved to this folder. Please try a different folder.",
      "moving_item_to": "Moving \"{{fileName}}\" to {{destinationFolder}}",
      "moving_item_to_plural": "Moving {{count}} items to {{destinationFolder}}",
      "need_permission": "Need permission to move here. Try a different subfolder or a different folder.",
      "title": "Moving"
    },
    "no": "No",
    "persistent_links": {
      "copy": "Copy",
      "copy_to_clipboard": "Link copied to your clipboard",
      "create_link": "Create link",
      "create_new_link": "Create another link",
      "delete_link": "Delete link",
      "delete_modal_cancel_text": "Cancel",
      "delete_modal_confirm_text": "Delete link",
      "delete_modal_message": "Deleting this link will make it inaccessible. Are you sure you want to remove access?",
      "edit_options": "Edit options",
      "expiry_day": "Expires in one day",
      "expiry_days": "Expires in {{remainingDays}} days",
      "items": "Items",
      "links_to_version": "Links to a version created on {{creationDate}} at {{creationTime}}",
      "notify_link_access": "Notify me when this link is accessed",
      "notify_link_access_request": "Notify me when files are uploaded",
      "replace_link": "Replace link",
      "replace_modal_confirm_text": "Replace link",
      "replace_modal_message": "Replacing this link will create a new link with the same permissions. The old link will become inaccessible. Are you sure you want to remove access?",
      "toast": {
        "link_created": "Link created and copied to clipboard"
      },
      "view_all_items": "View all items"
    },
    "personal_folders": "Personal Folders",
    "progress": {
      "finalize_upload": "Finalizing Upload...",
      "hour_remaining": "{{hoursRemaining}} hr ",
      "less_1_min_remaining": "Less than a minute",
      "minute_remaining": "{{minutesRemaining}} min ",
      "remaining": "{{remainingTimeDisplay}} remaining ",
      "retrying": "Upload Error: Retrying",
      "second_remaining": "{{secondsRemaining}} s ",
      "shouldnt_take_long": "This shouldn't take long...",
      "starting_upload": "Starting upload...",
      "transfer_progress": "{{progress}} of {{total}}"
    },
    "save": "Save",
    "select": "Select",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Unable to sign",
      "title": "Send for Signature"
    },
    "share": {
      "access_expires": "Access expires",
      "add_files_from_device": "Add items from my device",
      "add_files_from_sharefile": "Add items from ShareFile",
      "add_items": "Add items",
      "add_more_items": "Add more items",
      "back": "Back",
      "breadcrumbs": "In \"{{breadcrumbs}}\"",
      "cancel": "Cancel",
      "cancel_confirm": "Are you sure you want to cancel the message?",
      "compose": "Compose",
      "copy": "Copy",
      "copy_success": "Copied to Clipboard!",
      "create_and_copy": "Create and copy",
      "default_message_subject": "{{name}} has sent you files",
      "default_message_subject_request": "{{name}} has requested files from you",
      "done": "Done",
      "download": "Download",
      "edit": "Edit",
      "edit_link_options": "Edit Link Options",
      "edit_message_options": "Edit Message Options",
      "edit_options": "Edit options",
      "edit_sign_in": "Edit (sign in required)",
      "email_title": "Email with ShareFile",
      "empty_folder": "This folder is empty",
      "encrypt_message": "Encrypt this email",
      "encrypted_message_send_success": "Encrypted Message sent successfully",
      "expiration_changed": "One or more of the items selected has an expiration date sooner than the link options selected.",
      "file_box": "File Box",
      "file_location": "File location",
      "from_my_device": "From my device",
      "get_a_link": "Get a Link",
      "get_a_link2": "Get a link",
      "get_temp_link": "Get a temporary link",
      "groups_not_supported": "Distribution groups are not supported for encrypted messages.",
      "link_options": "Link options",
      "message": "Message",
      "message_encrypted": "This message is encrypted.",
      "message_options": "Message options",
      "message_send_fail_attachment": "Your message was not sent because there was an issue attaching the file {{file}}.",
      "message_send_fail_hard": "The message could not be sent at this time. Please try again later.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Recipients can download after signing in.",
            "require_user_info": "Anyone will be able to access this link if they can enter a recipient's email address."
          },
          "no_require_login": {
            "view_download": "This will create a link that allows anyone to download what you're sharing without signing in.",
            "view_only": "This will create a link that allows anyone to view what you're sharing without signing in."
          },
          "require_login": {
            "view_download": "Recipients can download after signing in.",
            "view_download_edit": "Recipients can edit after signing in.",
            "view_download_watermark": "Recipients can download with a watermark after signing in.",
            "view_only": "Recipients can view online after signing in.",
            "view_watermark": "Recipients can view online with a watermark after signing in."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Anyone can download without signing in.",
            "view_download_watermark": "Anyone can download a watermarked copy without signing in.",
            "view_only": "Anyone can view without signing in.",
            "view_watermark": "Anyone can view a watermarked copy without signing in."
          },
          "employee_and_client_only": {
            "view_download": "Users can download after signing in.",
            "view_download_edit": "Users can edit after signing in.",
            "view_download_watermark": "Users can download a watermarked copy after signing in.",
            "view_only": "Users can view after signing in.",
            "view_watermark": "Users can view a watermarked copy after signing in."
          },
          "employee_only": {
            "view_download": "Employees can download after signing in.",
            "view_download_edit": "Employees can edit after signing in.",
            "view_download_watermark": "Employees can download a watermarked copy after signing in.",
            "view_only": "Employees can view after signing in.",
            "view_watermark": "Employees can view a watermarked copy after signing in."
          },
          "require_user_info": {
            "view_download": "Anyone can download without signing in if they provide a name and email.",
            "view_download_watermark": "Anyone can download a watermarked copy without signing in if they provide a name and email.",
            "view_only": "Anyone can view without signing in if they provide a name and email.",
            "view_watermark": "Anyone can view a watermarked copy without signing in if they provide a name and email."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Recipients can upload without signing in.",
            "require_login": "Recipients can upload after signing in."
          },
          "link": {
            "anonymous": "Anyone can upload without signing in.",
            "employee_and_client_only": "Users can upload after signing in.",
            "employee_only": "Employees can upload after signing in.",
            "require_user_info": "Anyone can upload without signing in if they provide a name and email."
          }
        }
      },
      "no_files_error": "Please add at least one file.",
      "no_items": "No items",
      "options": {
        "access": "Access options",
        "access_options": {
          "for_tracking_only": "For tracking purposes only.",
          "label": "Who can access this link",
          "message_for_hipaa": "You cannot share files publicly due to HIPAA support being enabled on your account. Please reach out to your admin.",
          "message_for_hipaa_edit": "You cannot edit files due to HIPAA support being enabled on your account. Please reach out to your admin.",
          "selections": {
            "anyone": "Anyone (public)",
            "clients_and_employees": "Client and employee users (after signing in)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Employee users (after signing in)",
            "name_and_email": "Anyone (public, must enter a name and email)"
          },
          "set_by_admin": "Your administrator has set this option.",
          "tooltip": "These are recipient requirements for this link. Employee users are typically people within your company."
        },
        "add_watermark": "Add a watermark",
        "allow_recipients": {
          "edit_about_link": "About Office Online Editing",
          "edit_tooltip": "Edit access rights allow users to edit the shared files online. Some file types do not support editing.",
          "select_label": "Allow recipients to:",
          "tooltip": "View online only prevents users from downloading the file. Some file types do not support view-only sharing or watermarking.",
          "tooltip_about_view_only_link": "About view-only sharing",
          "tooltip_about_watermarking_link": "About watermarking"
        },
        "downloads_limits": {
          "unlimited": "Unlimited"
        },
        "downloads_per_user": "Downloads per user",
        "edit_disabled_message": "Your share settings have changed because you added a file that doesn't support editing.",
        "edit_options_access_level_warning": {
          "FullControl": "Anyone can download what you're sharing without signing in.",
          "ViewOnline": "Anyone can view what you're sharing without signing in."
        },
        "edit_options_warning": "Permissions will change for everyone who already has this link. You can create a new link if you don't want to change this one.",
        "edit_permission_alert_message": "Allowing recipients to edit requires them to sign in.",
        "email_me_accessed": "Email me when files are accessed",
        "encrypt_email": "Encrypt email",
        "encrypt_message": "Add encryption to your email message for extra protection. Note, your files are already encrypted.",
        "encrypted_email_enabled": "Access options have been adjusted because encrypted email has been enabled.",
        "expirations": {
          "after_one_day": "after one day",
          "after_one_week": "after a week",
          "after_six_months": "after six months",
          "after_three_months": "after three months",
          "after_x_days": "after {{days}} days",
          "after_year": "after a year",
          "never": "never"
        },
        "latest_version": "Always link to the latest version of the file",
        "latest_version_help": "Turning off this option will only provide a link to the current copy of the file you have selected.",
        "notifications": "Notifications",
        "notify_me_accessed": "Notify me when this is accessed",
        "persistent_link_conflict": "You've already created a link with these permissions.",
        "require_login": "Require recipients to sign in",
        "require_login_help": "Recipients will read the message and download the attachments after logging into ShareFile",
        "require_login_help_request": "Recipients will read the message and upload the attachments after logging into ShareFile",
        "send_copy": "Send me a copy of this email",
        "views_per_user": "Views per user"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Recipients of this link can download after signing in.",
            "require_user_info": "Recipients of this link can download after entering name and email."
          },
          "no_require_login": {
            "view_download": "Recipients of this link can view and download.",
            "view_only": "Recipients of this link can view online."
          },
          "require_login": {
            "view_download": "Recipients of this link can view and download after signing in.",
            "view_download_edit": "Recipients of this link can view, download and edit after signing in.",
            "view_download_watermark": "Recipients of this link can view and download with a watermark after signing in.",
            "view_only": "Recipients of this link can view online after signing in.",
            "view_watermark": "Recipients of this link can view online with a watermark after signing in."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Anyone with this link can view and download.",
            "view_download_watermark": "Anyone with this link can view and download with a watermark.",
            "view_only": "Anyone with this link can view online.",
            "view_watermark": "Anyone with this link can view online with a watermark."
          },
          "employee_and_client_only": {
            "view_download": "Users with this link can view and download after signing in.",
            "view_download_edit": "Users with this link can view, download and edit after signing in.",
            "view_download_watermark": "Users with this link can view and download with a watermark after signing in.",
            "view_only": "Users with this link can view online after signing in.",
            "view_watermark": "Users with this link can view online with a watermark after signing in."
          },
          "employee_only": {
            "view_download": "Employees with this link can view and download after signing in.",
            "view_download_edit": "Employees with this link can view, download and edit after signing in.",
            "view_download_watermark": "Employees with this link can view and download with a watermark after signing in.",
            "view_only": "Employees with this link can view online after signing in.",
            "view_watermark": "Employees with this link can view online with a watermark after signing in."
          },
          "require_user_info": {
            "view_download": "Anyone with this link can view and download after entering name and email.",
            "view_download_watermark": "Anyone with this link can view and download with a watermark after entering name and email.",
            "view_only": "Anyone with this link can view online after entering name and email.",
            "view_watermark": "Anyone with this link can view online with a watermark after entering name and email."
          }
        }
      },
      "progress": {
        "progress": "Progress",
        "sending": "Sending. Please keep window open.",
        "upload_then_send": "Uploading then sending your file. Please keep window open."
      },
      "remember_message": "Remember subject and message",
      "request": "Request",
      "request_files": "Request files",
      "required": "* Required",
      "send": "Send",
      "send_to_specific_people": "Send to specific people",
      "sending_cancel_confirm": "Are you sure you want to cancel the message? Sending is in progress.",
      "share_access_label": "Allow people with this link to",
      "share_bundle": "Share - Bundle",
      "share_files": "Share files",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Recipients can download after signing in.",
              "require_user_info": "Anyone can access if they can enter a recipient's email address."
            },
            "no_require_login": {
              "view_download": "Anyone can download without signing in.",
              "view_only": "Anyone can view without signing in."
            },
            "require_login": {
              "view_download": "Recipients can download after signing in.",
              "view_download_edit": "Recipients can edit after signing in.",
              "view_download_watermark": "Recipients can download with a watermark after signing in.",
              "view_only": "Recipients can view online after signing in.",
              "view_watermark": "Recipients can view online with a watermark after signing in."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Anyone can download without signing in.",
              "view_download_watermark": "Anyone can download a watermarked copy without signing in.",
              "view_only": "Anyone can view without signing in.",
              "view_watermark": "Anyone can view a watermarked copy without signing in."
            },
            "employee_and_client_only": {
              "view_download": "Users can download after signing in.",
              "view_download_edit": "Users can edit after signing in.",
              "view_download_watermark": "Users can download a watermarked copy after signing in.",
              "view_only": "Users can view after signing in.",
              "view_watermark": "Users can view a watermarked copy after signing in."
            },
            "employee_only": {
              "view_download": "Employees can download after signing in.",
              "view_download_edit": "Employees can edit after signing in.",
              "view_download_watermark": "Employees can download a watermarked copy after signing in.",
              "view_only": "Employees can view after signing in.",
              "view_watermark": "Employees can view a watermarked copy after signing in."
            },
            "require_user_info": {
              "view_download": "Anyone can download without signing in if they provide a name and email.",
              "view_download_watermark": "Anyone can download a watermarked copy without signing in if they provide a name and email.",
              "view_only": "Anyone can view without signing in if they provide a name and email.",
              "view_watermark": "Anyone can view a watermarked copy without signing in if they provide a name and email."
            }
          }
        },
        "analyzing_file_content": "Analyzing file content...",
        "apply_recommended_options": "Apply recommended options",
        "applying_recommended_options": "Applying recommended options",
        "create_secure_link": "Create a secure link",
        "data_found": "Data found:",
        "expiry_tooltip": {
          "after_one_day": "The link will expire after one day.",
          "after_one_week": "The link will expire after a week.",
          "after_six_months": "The link will expire after six months.",
          "after_three_months": "The link will expire after three months.",
          "after_x_days": "The link will expire after {{days}} days.",
          "after_year": "The link will expire after a year.",
          "never": "The link will never expire."
        },
        "feedback": {
          "helpful": "Helpful",
          "not_helpful": "Not helpful",
          "was_this_helpful": "Was this helpful?"
        },
        "file_may_contain_personal_information": "This file may contain personal information.",
        "file_may_contain_sensitive_information": "This file may contain sensitive information.",
        "pii_marker_type": {
          "ADDRESS": "Address",
          "AGE": "Age",
          "AWS_ACCESS_KEY": "AWS Access Key",
          "AWS_SECRET_KEY": "AWS Secret Key",
          "BANK_ACCOUNT_NUMBER": "Bank Account Number",
          "BANK_ROUTING": "Bank Routing",
          "CA_HEALTH_NUMBER": "Canada Health Number",
          "CA_SOCIAL_INSURANCE_NUMBER": "Canada Social Insurance Number",
          "CREDIT_DEBIT_CVV": "Credit/Debit CVV",
          "CREDIT_DEBIT_EXPIRY": "Credit/Debit Expiry",
          "CREDIT_DEBIT_NUMBER": "Credit/Debit Card Number",
          "DATE_TIME": "Date/Time",
          "DRIVER_ID": "Driver ID",
          "EMAIL": "Email",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "International Bank Account Number (IBAN)",
          "IN_AADHAAR": "India Aadhaar Card Number",
          "IN_NREGA": "India NREGA Number",
          "IN_PERMANENT_ACCOUNT_NUMBER": "India Permanent Account Number (PAN)",
          "IN_VOTER_NUMBER": "India Voter Number",
          "IP_ADDRESS": "IP Address",
          "LICENSE_PLATE": "License Plate",
          "MAC_ADDRESS": "MAC Address",
          "NAME": "Name",
          "PASSPORT_NUMBER": "Passport Number",
          "PASSWORD": "Password",
          "PHONE": "Phone",
          "PIN": "PIN",
          "SSN": "Social Security Number (SSN)",
          "SWIFT_CODE": "SWIFT Code",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "UK National Health Service Number",
          "UK_NATIONAL_INSURANCE_NUMBER": "UK National Insurance Number",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "UK Unique Taxpayer Reference Number",
          "URL": "URL",
          "USERNAME": "Username",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "US Individual Tax Identification Number (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "Vehicle Identification Number (VIN)"
        },
        "recommended_tag": "Recommended",
        "skip": "Skip",
        "view_details": "View details",
        "we_are_still_working_on_it": "We're still working on it..."
      },
      "subject": "Subject",
      "title": "Share",
      "to": "To",
      "toast": {
        "connector_filebox_recipients": "This file will be copied over to File Box and recipients may not have immediate access.",
        "multiple_source_error": "All items must be from the same data source.",
        "scan_warning": "There’s a large file in this share. You can send your link, but the download may not be available for several minutes while our virus scan completes.",
        "send_success": "Item(s) sent successfully.",
        "share_request_success": "Request sent successfully",
        "share_send_success": "Share sent successfully",
        "upload_error": "One or more files failed to upload.",
        "upload_in_progress": "There is an upload in progress. Please keep window open."
      },
      "upload_location": "Upload Location",
      "view": "View",
      "view_access_expires": "View access expires"
    },
    "shared_folders": "Shared Folders",
    "treeview": {
      "cancel": "Cancel",
      "current_location": "(Current Location)",
      "folder_created": "folder created",
      "folder_name": "Folder name",
      "folder_name_length_error": "The folder name cannot exceed {{value}} characters.",
      "save": "Save",
      "untitled": "Untitled"
    },
    "upload": {
      "add_more": "Add more",
      "browse_files": "Browse files",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Cancel",
      "clear_all": "Clear all",
      "drag_drop": "Drag files here",
      "drop_files_here": "Drop files here",
      "edit": "Edit",
      "failed": "Failed",
      "file_name": "File name",
      "folder_warning": "It looks like one or more files you dragged in might be a folder. Uploading folders is not currently supported.",
      "from_computer": "From Computer",
      "from_sharefile": "From ShareFile",
      "item_details": "Item details",
      "item_failed_to_upload": "Item failed to upload",
      "items_selected": "item",
      "more_than_one_item_selected": "items",
      "overwrite_same_name": "Overwrite files with the same name.",
      "prevent_folders": "Sharing folders is not available with this option. Please use individual files.",
      "save": "Save",
      "upload": "Upload",
      "upload_to": "Upload to \"{{folderName}}\"",
      "uploaded": "Uploaded"
    },
    "validation": {
      "enter_required_value": "This field is required."
    },
    "virus": {
      "contact_admin": "Contact your administrator if you think this is an error.",
      "file_marked_as_false_positive_title": "Malicious content detected",
      "file_marked_as_false_positive_warn": "We detected malicious content in this file. Your administrator has restored access, but we can't guarantee it's safe to open.",
      "malicious_file": "This file has been identified as malicious and may contain a virus.",
      "malicious_file_block": "We detected malicious content and have restricted access to this file. We recommend that you delete it.",
      "malicious_file_block_action": "You selected a file that has malicious content.",
      "malicious_file_block_archive": "We detected malicious content and have restricted access to this file.",
      "malicious_file_title": "Malicious file detected",
      "malicious_file_warn": "We detected malicious content in this file. We recommend that you delete it.",
      "malicious_file_warn_action": "You selected a file that has malicious content. We recommend that you delete it.",
      "malicious_file_warn_archive": "We detected malicious content in this file.",
      "unscanned_file_block": "This file is being scanned for malicious content. Refresh for the latest status.",
      "unscanned_file_block_action": "You selected a file that is being scanned for malicious content. Try again later.",
      "unscanned_file_block_title": "File scan in progress"
    },
    "yes": "Yes",
    "you": "You"
  }
}, {
  "key": "es",
  "content": {
    "add": "Agregar",
    "address_book": {
      "address_book": "Libreta de direcciones",
      "address_book_icon_label": "Open Address Book",
      "company": "Empresa",
      "contact_type": "Tipo de contacto",
      "distribution": "Grupo de distribución",
      "employees": "Empleados",
      "name": "Nombre",
      "no_contact": "No hay contactos que correspondan con su búsqueda",
      "personal": "Libreta de direcciones personal",
      "shared": "Libreta de direcciones compartida"
    },
    "cancel": "Cancelar",
    "caution": "Precaución",
    "checkout": {
      "about_to_check_out_expire_message": "La desprotección caducará dentro de 24 horas. Otros usuarios podrán ver que usted ha desprotegido el archivo y podrán descargarlo.",
      "about_to_check_out_filename": "Está a punto de desproteger '{{itemName}}'.",
      "checkedout_multiple_action": "¿Seguro que quiere {{title}} estos archivos?",
      "checkedout_multiple_msg": "Hay uno o varios archivos desprotegidos.",
      "checkedout_single_date": "{{userName}} desprotegió este archivo y la desprotección caducará el {{checkedOutDate}}.",
      "checkedout_single_filename": "¿Seguro que quiere {{title}} '{{fileName}}'?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "Está a punto de descartar la desprotección de"
    },
    "contactSelect": {
      "clearValue": "Borrar valor",
      "noResults": "No hay resultados",
      "searching": "Buscando...",
      "select": "Seleccionar...",
      "start_typing": "Comience a escribir para buscar usuarios"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Continuar",
    "continue_anyway": "Continuar de todos modos",
    "copy": {
      "copy": "Copiar",
      "copy_target_not_allowed": "El elemento que ha seleccionado no puede copiarse en esta carpeta. Inténtelo en una carpeta diferente.",
      "copying_item_to": "Copiando \"{{fileName}}\" en {{destinationFolder}}",
      "copying_item_to_plural": "Copiando {{count}} elementos en {{destinationFolder}}",
      "need_permission": "Se necesita permiso para copiar aquí. Inténtelo en una subcarpeta o carpeta diferente.",
      "title": "Copiar"
    },
    "create_folder": "Crear carpeta",
    "done": "Listo",
    "favorites": "Favoritos",
    "file_list": {
      "view_all": "Ver todos los elementos ({{count}})"
    },
    "file_list_modal": {
      "dont_show_again": "No volver a mostrar este mensaje",
      "move_away_selections": "Si abandona la carpeta actual, se perderá lo que haya seleccionado."
    },
    "generic_error": "Ha ocurrido un error",
    "get_approval": {
      "add_approvers": "Agregar aprobadores",
      "approvers": "Aprobadores",
      "approvers_in_order": "Los aprobadores deben dar aprobaciones por orden",
      "approvers_tooltip": " Es necesario que estas personas den su aprobación. Si agrega un grupo de distribución, las personas aparecen individualmente en la lista.",
      "due_date": "Fecha de vencimiento:",
      "edit_approval_settings": "Modificar parámetros de aprobación",
      "message": "Mensaje",
      "options": {
        "edit_approval_settings": "Modificar parámetros de aprobación",
        "request_for_new_version": "Enviar una solicitud de aprobación para cada nueva versión cargada",
        "request_for_new_version_help": "Cada vez que se carga una nueva versión, se notifica a todos para que la aprueben.",
        "require_login": "Requerir que los participantes inicien sesión"
      },
      "send_for_approval": "Enviar para la aprobación",
      "title": "Obtener aprobación",
      "viewers": "Participantes",
      "viewers_tooltip": " Estas personas pueden ver la información y hacer comentarios al respecto, pero no pueden dar aprobaciones."
    },
    "load_more": "Cargar más",
    "move": {
      "cannot_move_to_current": "No se puede mover a la ubicación actual. Inténtelo en una subcarpeta o carpeta diferente.",
      "cannot_move_to_selected": "No se puede mover a una carpeta seleccionada en este momento. Inténtelo en una subcarpeta o carpeta diferente.",
      "move": "Mover",
      "move_target_not_allowed": "El elemento que ha seleccionado no puede moverse a esta carpeta. Inténtelo en una carpeta diferente.",
      "moving_item_to": "Moviendo \"{{fileName}}\" a {{destinationFolder}}",
      "moving_item_to_plural": "Moviendo {{count}} elementos a {{destinationFolder}}",
      "need_permission": "Se necesita permiso para mover elementos aquí. Inténtelo en una subcarpeta o carpeta diferente.",
      "title": "Mover"
    },
    "no": "No",
    "persistent_links": {
      "copy": "Copiar",
      "copy_to_clipboard": "Enlace copiado al Portapapeles",
      "create_link": "Crear enlace",
      "create_new_link": "Crear otro enlace",
      "delete_link": "Eliminar enlace",
      "delete_modal_cancel_text": "Cancelar",
      "delete_modal_confirm_text": "Eliminar enlace",
      "delete_modal_message": "Al eliminar este enlace, se volverá inaccesible. ¿Seguro que quiere quitar el acceso?",
      "edit_options": "Modificar opciones",
      "expiry_day": "Caduca en un día",
      "expiry_days": "Caduca en {{remainingDays}} días",
      "items": "Elementos",
      "links_to_version": "Enlaces a una versión creada el {{creationDate}}, {{creationTime}}",
      "notify_link_access": "Notificarme cuando alguien acceda a este enlace",
      "notify_link_access_request": "Notificar cuando los archivos se hayan cargado",
      "replace_link": "Reemplazar enlace",
      "replace_modal_confirm_text": "Reemplazar enlace",
      "replace_modal_message": "Al reemplazar este enlace, se creará otro enlace con los mismos permisos. El enlace anterior quedará inaccesible. ¿Seguro que quiere quitar el acceso?",
      "toast": {
        "link_created": "Enlace creado y copiado en el portapapeles"
      },
      "view_all_items": "Ver todos los elementos"
    },
    "personal_folders": "Carpetas personales",
    "progress": {
      "finalize_upload": "Finalizando la carga...",
      "hour_remaining": "{{hoursRemaining}} hr ",
      "less_1_min_remaining": "Menos de un minuto",
      "minute_remaining": "{{minutesRemaining}} min ",
      "remaining": "Queda: {{remainingTimeDisplay}} ",
      "retrying": "Error de carga: Reintentando",
      "second_remaining": "{{secondsRemaining}} s ",
      "shouldnt_take_long": "Espere unos momentos...",
      "starting_upload": "Iniciando la carga...",
      "transfer_progress": "{{progress}} de {{total}}"
    },
    "save": "Guardar",
    "select": "Seleccionar",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "No se puede firmar",
      "title": "Enviar para firma"
    },
    "share": {
      "access_expires": "El acceso caduca",
      "add_files_from_device": "Agregar elementos desde mi dispositivo",
      "add_files_from_sharefile": "Agregar elementos desde ShareFile",
      "add_items": "Agregar elementos",
      "add_more_items": "Agregar más elementos",
      "back": "Atrás",
      "breadcrumbs": "En \"{{breadcrumbs}}\"",
      "cancel": "Cancelar",
      "cancel_confirm": "¿Seguro que quiere cancelar el mensaje?",
      "compose": "Redactar",
      "copy": "Copiar",
      "copy_success": "Copiado al portapapeles",
      "create_and_copy": "Crear y copiar",
      "default_message_subject": "{{name}} le ha enviado archivos",
      "default_message_subject_request": "{{name}} le ha solicitado archivos",
      "done": "Listo",
      "download": "Descargar",
      "edit": "Modificar",
      "edit_link_options": "Modificar opciones de enlace",
      "edit_message_options": "Modificar opciones de mensaje",
      "edit_options": "Modificar opciones",
      "edit_sign_in": "Modificar (requiere iniciar sesión)",
      "email_title": "Enviar por correo electrónico con ShareFile",
      "empty_folder": "Esta carpeta está vacía",
      "encrypt_message": "Cifrar este correo electrónico",
      "encrypted_message_send_success": "Mensaje cifrado enviado correctamente",
      "expiration_changed": "Uno o varios de los elementos seleccionados tienen una fecha de caducidad anterior a las opciones de enlace seleccionadas.",
      "file_box": "Caja de archivos",
      "file_location": "Ubicación del archivo",
      "from_my_device": "Desde mi dispositivo",
      "get_a_link": "Obtener un enlace",
      "get_a_link2": "Obtener un enlace",
      "get_temp_link": "Obtener un enlace temporal",
      "groups_not_supported": "Los grupos de distribución no reciben respaldo para mensajes cifrados.",
      "link_options": "Opciones de enlace",
      "message": "Mensaje",
      "message_encrypted": "Este mensaje está cifrado.",
      "message_options": "Opciones de mensaje",
      "message_send_fail_attachment": "El mensaje no se envió porque hubo un problema al adjuntar el archivo {{file}}.",
      "message_send_fail_hard": "El mensaje no pudo enviarse en este momento. Inténtelo de nuevo más tarde.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Los destinatarios pueden descargar contenido tras iniciar sesión.",
            "require_user_info": "Cualquier persona podrá acceder a este enlace si puede introducir la dirección de correo electrónico de un destinatario."
          },
          "no_require_login": {
            "view_download": "Se creará un enlace que permitirá a cualquier persona descargar lo que está compartiendo sin iniciar sesión.",
            "view_only": "Se creará un enlace que permitirá a cualquier persona ver lo que está compartiendo sin iniciar sesión."
          },
          "require_login": {
            "view_download": "Los destinatarios pueden descargar contenido tras iniciar sesión.",
            "view_download_edit": "Los destinatarios pueden modificar contenido tras iniciar sesión.",
            "view_download_watermark": "Los destinatarios pueden descargar contenido con una marca de agua tras iniciar sesión.",
            "view_only": "Los destinatarios pueden ver contenido en línea tras iniciar sesión.",
            "view_watermark": "Los destinatarios pueden ver contenido en línea con una marca de agua tras iniciar sesión."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Cualquier persona puede descargar contenido sin iniciar sesión.",
            "view_download_watermark": "Cualquier persona puede descargar una copia con marca de agua sin iniciar sesión.",
            "view_only": "Cualquier persona puede ver contenido sin iniciar sesión.",
            "view_watermark": "Cualquier persona puede ver una copia con marca de agua sin iniciar sesión."
          },
          "employee_and_client_only": {
            "view_download": "Los usuarios pueden descargar contenido tras iniciar sesión.",
            "view_download_edit": "Los usuarios pueden modificar contenido tras iniciar sesión.",
            "view_download_watermark": "Los usuarios pueden descargar una copia con marca de agua tras iniciar sesión.",
            "view_only": "Los usuarios pueden ver contenido tras iniciar sesión.",
            "view_watermark": "Los usuarios pueden ver una copia con marca de agua tras iniciar sesión."
          },
          "employee_only": {
            "view_download": "Los empleados pueden descargar contenido tras iniciar sesión.",
            "view_download_edit": "Los empleados pueden modificar contenido tras iniciar sesión.",
            "view_download_watermark": "Los empleados pueden descargar una copia con marca de agua tras iniciar sesión.",
            "view_only": "Los empleados pueden ver contenido tras iniciar sesión.",
            "view_watermark": "Los empleados pueden ver una copia con marca de agua tras iniciar sesión."
          },
          "require_user_info": {
            "view_download": "Cualquier persona puede descargar contenido sin iniciar sesión si proporciona un nombre y un correo electrónico.",
            "view_download_watermark": "Cualquier persona puede descargar una copia con marca de agua sin iniciar sesión si proporciona un nombre y un correo electrónico.",
            "view_only": "Cualquier persona puede ver contenido sin iniciar sesión si proporciona un nombre y un correo electrónico.",
            "view_watermark": "Cualquier persona puede ver una copia con marca de agua sin iniciar sesión si proporciona un nombre y un correo electrónico."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Los destinatarios pueden cargar contenido sin iniciar sesión.",
            "require_login": "Los destinatarios pueden cargar contenido tras iniciar sesión."
          },
          "link": {
            "anonymous": "Cualquier persona puede cargar contenido sin iniciar sesión.",
            "employee_and_client_only": "Los usuarios pueden cargar contenido tras iniciar sesión.",
            "employee_only": "Los empleados pueden cargar contenido tras iniciar sesión.",
            "require_user_info": "Cualquier persona puede cargar contenido sin iniciar sesión si proporciona un nombre y un correo electrónico."
          }
        }
      },
      "no_files_error": "Agregue al menos un archivo.",
      "no_items": "No hay elementos",
      "options": {
        "access": "Opciones de acceso",
        "access_options": {
          "for_tracking_only": "Solo con fines de seguimiento.",
          "label": "¿Quién puede acceder a este enlace?",
          "message_for_hipaa": "No puede compartir archivos públicamente debido a que la conformidad con HIPAA está habilitada en su cuenta. Contacte con su administrador.",
          "message_for_hipaa_edit": "No puede modificar archivos debido a que la conformidad con HIPAA está habilitada en su cuenta. Contacte con su administrador.",
          "selections": {
            "anyone": "Cualquiera (público)",
            "clients_and_employees": "Usuarios clientes y empleados (tras iniciar sesión)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Usuarios empleados (tras iniciar sesión)",
            "name_and_email": "Cualquiera (público, debe introducir un nombre y correo electrónico)"
          },
          "set_by_admin": "El administrador ha establecido esta opción.",
          "tooltip": "Estos son los requisitos del destinatario para este enlace. Los usuarios empleados suelen ser personas dentro de su empresa."
        },
        "add_watermark": "Agregar una marca de agua",
        "allow_recipients": {
          "edit_about_link": "Acerca de la modificación de contenido de Office Online",
          "edit_tooltip": "Los derechos de acceso de modificación permiten a los usuarios modificar archivos compartidos en línea. Algunos tipos de archivos no se pueden modificar.",
          "select_label": "Permitir a los destinatarios:",
          "tooltip": "La visualización en línea solo impide que los usuarios descarguen el archivo. Algunos tipos de archivos no son compatibles con el modo de \"solo lectura\" para uso compartido ni con la marca de agua.",
          "tooltip_about_view_only_link": "Acerca del uso compartido de solo lectura",
          "tooltip_about_watermarking_link": "Acerca de la marca de agua"
        },
        "downloads_limits": {
          "unlimited": "Sin límite"
        },
        "downloads_per_user": "Descargas por usuario",
        "edit_disabled_message": "Sus parámetros de uso compartido han cambiado porque agregó un archivo que no se puede modificar.",
        "edit_options_access_level_warning": {
          "FullControl": "Cualquiera puede descargar lo que está compartiendo sin iniciar sesión.",
          "ViewOnline": "Cualquiera puede ver lo que está compartiendo sin iniciar sesión."
        },
        "edit_options_warning": "Los permisos cambiarán para todos los que ya tengan este enlace. Puede crear otro enlace si no quiere cambiar este.",
        "edit_permission_alert_message": "Para que los destinatarios puedan modificar contenido, primero deben iniciar sesión.",
        "email_me_accessed": "Enviarme un correo cuando se acceda a los archivos",
        "encrypt_email": "Cifrar correo electrónico",
        "encrypt_message": "Agregue cifrado a su mensaje de correo electrónico para mayor protección. Nota: sus archivos ya están cifrados.",
        "encrypted_email_enabled": "Las opciones de acceso se han ajustado porque se ha habilitado el correo electrónico cifrado.",
        "expirations": {
          "after_one_day": "al cabo de un día",
          "after_one_week": "al cabo de una semana",
          "after_six_months": "al cabo de seis meses",
          "after_three_months": "al cabo de tres meses",
          "after_x_days": "al cabo de {{days}} días",
          "after_year": "al cabo de un año",
          "never": "nunca"
        },
        "latest_version": "Enlazar siempre con la versión más reciente del archivo",
        "latest_version_help": "Si se desactiva esta opción, solo se enlazará la copia actual del archivo seleccionado.",
        "notifications": "Notificaciones",
        "notify_me_accessed": "Notificarme cuando alguien acceda a esto",
        "persistent_link_conflict": "Ya creó un enlace con estos permisos.",
        "require_login": "Requerir que los destinatarios inicien sesión",
        "require_login_help": "Los destinatarios leerán el mensaje y descargarán los datos adjuntos después de iniciar sesión en ShareFile",
        "require_login_help_request": "Los destinatarios leerán el mensaje y cargarán los datos adjuntos después de iniciar sesión en ShareFile",
        "send_copy": "Enviarme una copia de este mensaje",
        "views_per_user": "Vistas por usuario"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Los destinatarios de este enlace pueden descargarlo después de iniciar sesión.",
            "require_user_info": "Los destinatarios de este enlace pueden descargarlo después de introducir su nombre y su dirección de correo electrónico."
          },
          "no_require_login": {
            "view_download": "Los destinatarios de este enlace pueden verlo y descargarlo.",
            "view_only": "Los destinatarios de este enlace pueden verlo en línea."
          },
          "require_login": {
            "view_download": "Los destinatarios de este enlace pueden verlo y descargarlo después de iniciar sesión.",
            "view_download_edit": "Los destinatarios de este enlace pueden verlo, descargarlo y modificarlo después de iniciar sesión.",
            "view_download_watermark": "Los destinatarios de este enlace pueden verlo y descargarlo con una marca de agua después de iniciar sesión.",
            "view_only": "Los destinatarios de este enlace pueden verlo en línea después de iniciar sesión.",
            "view_watermark": "Los destinatarios de este enlace pueden verlo en línea con una marca de agua después de iniciar sesión."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Cualquier persona con este enlace puede verlo y descargarlo.",
            "view_download_watermark": "Cualquier persona con este enlace puede verlo y descargarlo con una marca de agua.",
            "view_only": "Cualquier persona con este enlace puede verlo en línea.",
            "view_watermark": "Cualquier persona con este enlace puede verlo en línea con una marca de agua."
          },
          "employee_and_client_only": {
            "view_download": "Los usuarios con este enlace pueden verlo y descargarlo después de iniciar sesión.",
            "view_download_edit": "Los usuarios con este enlace pueden verlo, descargarlo y modificarlo después de iniciar sesión.",
            "view_download_watermark": "Los usuarios con este enlace pueden verlo y descargarlo con una marca de agua después de iniciar sesión.",
            "view_only": "Los usuarios con este enlace pueden verlo en línea después de iniciar sesión.",
            "view_watermark": "Los usuarios con este enlace pueden verlo en línea con una marca de agua después de iniciar sesión."
          },
          "employee_only": {
            "view_download": "Los empleados con este enlace pueden verlo y descargarlo después de iniciar sesión.",
            "view_download_edit": "Los empleados con este enlace pueden verlo, descargarlo y modificarlo después de iniciar sesión.",
            "view_download_watermark": "Los empleados con este enlace pueden verlo y descargarlo con una marca de agua después de iniciar sesión.",
            "view_only": "Los empleados con este enlace pueden verlo en línea después de iniciar sesión.",
            "view_watermark": "Los empleados con este enlace pueden verlo en línea con una marca de agua después de iniciar sesión."
          },
          "require_user_info": {
            "view_download": "Cualquier persona con este enlace puede verlo y descargarlo después de introducir su nombre y su dirección de correo electrónico.",
            "view_download_watermark": "Cualquier persona con este enlace puede verlo y descargarlo con una marca de agua después de introducir su nombre y su dirección de correo electrónico.",
            "view_only": "Cualquier persona con este enlace puede verlo en línea después de introducir su nombre y su dirección de correo electrónico.",
            "view_watermark": "Cualquier persona con este enlace puede verlo en línea con una marca de agua después de introducir su nombre y su dirección de correo electrónico."
          }
        }
      },
      "progress": {
        "progress": "Progreso",
        "sending": "Enviando. Mantenga abierta la ventana.",
        "upload_then_send": "Cargando y enviando su archivo. Mantenga abierta la ventana."
      },
      "remember_message": "Recordar asunto y mensaje",
      "request": "Solicitud",
      "request_files": "Solicitar archivos",
      "required": "* Requerido",
      "send": "Enviar",
      "send_to_specific_people": "Enviar a personas específicas",
      "sending_cancel_confirm": "¿Seguro que quiere cancelar el mensaje? Se está enviando.",
      "share_access_label": "Permitir esto a las personas con este enlace:",
      "share_bundle": "Compartir: Paquete",
      "share_files": "Compartir archivos",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Los destinatarios pueden descargar contenido tras iniciar sesión.",
              "require_user_info": "Cualquier persona puede acceder si puede introducir la dirección de correo electrónico de un destinatario."
            },
            "no_require_login": {
              "view_download": "Cualquier persona puede descargar contenido sin iniciar sesión.",
              "view_only": "Cualquier persona puede ver contenido sin iniciar sesión."
            },
            "require_login": {
              "view_download": "Los destinatarios pueden descargar contenido tras iniciar sesión.",
              "view_download_edit": "Los destinatarios pueden modificar contenido tras iniciar sesión.",
              "view_download_watermark": "Los destinatarios pueden descargar contenido con una marca de agua tras iniciar sesión.",
              "view_only": "Los destinatarios pueden ver contenido en línea tras iniciar sesión.",
              "view_watermark": "Los destinatarios pueden ver contenido en línea con una marca de agua tras iniciar sesión."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Cualquier persona puede descargar contenido sin iniciar sesión.",
              "view_download_watermark": "Cualquier persona puede descargar una copia con marca de agua sin iniciar sesión.",
              "view_only": "Cualquier persona puede ver contenido sin iniciar sesión.",
              "view_watermark": "Cualquier persona puede ver una copia con marca de agua sin iniciar sesión."
            },
            "employee_and_client_only": {
              "view_download": "Los usuarios pueden descargar contenido tras iniciar sesión.",
              "view_download_edit": "Los usuarios pueden modificar contenido tras iniciar sesión.",
              "view_download_watermark": "Los usuarios pueden descargar una copia con marca de agua tras iniciar sesión.",
              "view_only": "Los usuarios pueden ver contenido tras iniciar sesión.",
              "view_watermark": "Los usuarios pueden ver una copia con marca de agua tras iniciar sesión."
            },
            "employee_only": {
              "view_download": "Los empleados pueden descargar contenido tras iniciar sesión.",
              "view_download_edit": "Los empleados pueden modificar contenido tras iniciar sesión.",
              "view_download_watermark": "Los empleados pueden descargar una copia con marca de agua tras iniciar sesión.",
              "view_only": "Los empleados pueden ver contenido tras iniciar sesión.",
              "view_watermark": "Los empleados pueden ver una copia con marca de agua tras iniciar sesión."
            },
            "require_user_info": {
              "view_download": "Cualquier persona puede descargar contenido sin iniciar sesión si proporciona un nombre y un correo electrónico.",
              "view_download_watermark": "Cualquier persona puede descargar una copia con marca de agua sin iniciar sesión si proporciona un nombre y un correo electrónico.",
              "view_only": "Cualquier persona puede ver contenido sin iniciar sesión si proporciona un nombre y un correo electrónico.",
              "view_watermark": "Cualquier persona puede ver una copia con marca de agua sin iniciar sesión si proporciona un nombre y un correo electrónico."
            }
          }
        },
        "analyzing_file_content": "Analizando el contenido del archivo...",
        "apply_recommended_options": "Aplicar opciones recomendadas",
        "applying_recommended_options": "Aplicando opciones recomendadas",
        "create_secure_link": "Crear un enlace seguro",
        "data_found": "Datos encontrados:",
        "expiry_tooltip": {
          "after_one_day": "El enlace caducará al cabo de un día.",
          "after_one_week": "El enlace caducará al cabo de una semana.",
          "after_six_months": "El enlace caducará al cabo de seis meses.",
          "after_three_months": "El enlace caducará al cabo de tres meses.",
          "after_x_days": "El enlace caducará al cabo de {{days}} d.",
          "after_year": "El enlace caducará al cabo de un año.",
          "never": "El enlace nunca caducará."
        },
        "feedback": {
          "helpful": "Útil",
          "not_helpful": "No útil",
          "was_this_helpful": "¿Le resultó útil?"
        },
        "file_may_contain_personal_information": "Este archivo puede contener información personal.",
        "file_may_contain_sensitive_information": "Este archivo puede contener información confidencial.",
        "pii_marker_type": {
          "ADDRESS": "Dirección",
          "AGE": "Edad",
          "AWS_ACCESS_KEY": "Clave de acceso de AWS",
          "AWS_SECRET_KEY": "Clave secreta de AWS",
          "BANK_ACCOUNT_NUMBER": "Número de cuenta bancaria",
          "BANK_ROUTING": "Redirección bancaria",
          "CA_HEALTH_NUMBER": "Número de salud de Canadá",
          "CA_SOCIAL_INSURANCE_NUMBER": "Número de la Seguridad Social de Canadá",
          "CREDIT_DEBIT_CVV": "CVV de crédito/débito",
          "CREDIT_DEBIT_EXPIRY": "Caducidad de crédito/débito",
          "CREDIT_DEBIT_NUMBER": "Número de tarjeta de crédito/débito",
          "DATE_TIME": "Fecha/Hora",
          "DRIVER_ID": "ID de conductor",
          "EMAIL": "Correo electrónico",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Número de cuenta bancaria internacional (IBAN)",
          "IN_AADHAAR": "Número de tarjeta Aadhaar de India",
          "IN_NREGA": "Número NREGA de India",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Número de cuenta permanente (PAN) de India",
          "IN_VOTER_NUMBER": "Número de votante de India",
          "IP_ADDRESS": "Dirección IP",
          "LICENSE_PLATE": "Placa de matrícula",
          "MAC_ADDRESS": "Dirección MAC",
          "NAME": "Nombre",
          "PASSPORT_NUMBER": "Número de pasaporte",
          "PASSWORD": "Contraseña",
          "PHONE": "Teléfono",
          "PIN": "PIN",
          "SSN": "Número de la Seguridad Social (SSN)",
          "SWIFT_CODE": "Código SWIFT",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Número del Servicio Nacional de Salud del Reino Unido",
          "UK_NATIONAL_INSURANCE_NUMBER": "Número de la Seguridad Social de Reino Unido",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Número de referencia único de contribuyente del Reino Unido",
          "URL": "URL",
          "USERNAME": "Nombre de usuario",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "Número de identificación fiscal individual (ITIN) de EE. UU.",
          "VEHICLE_IDENTIFICATION_NUMBER": "Número de identificación del vehículo (VIN)"
        },
        "recommended_tag": "Recomendado",
        "skip": "Omitir",
        "view_details": "Ver detalles",
        "we_are_still_working_on_it": "Todavía estamos trabajando en ello..."
      },
      "subject": "Asunto",
      "title": "Compartir",
      "to": "Para",
      "toast": {
        "connector_filebox_recipients": "Este archivo se copiará a la Caja de archivos. Es posible que los destinatarios no tengan acceso inmediato.",
        "multiple_source_error": "Todos los elementos deben ser del mismo origen de datos.",
        "scan_warning": "Hay un archivo grande en este recurso compartido. Puede enviar el enlace, pero es posible que la descarga no esté disponible durante unos minutos mientras se completa el análisis de detección de virus.",
        "send_success": "Elemento(s) enviados correctamente.",
        "share_request_success": "Solicitud enviada correctamente",
        "share_send_success": "Recurso compartido enviado correctamente",
        "upload_error": "No se pudo cargar uno o varios archivos.",
        "upload_in_progress": "Hay una carga en curso. Deje la ventana abierta."
      },
      "upload_location": "Ubicación de carga",
      "view": "Ver",
      "view_access_expires": "El acceso de vista caduca"
    },
    "shared_folders": "Carpetas compartidas",
    "treeview": {
      "cancel": "Cancelar",
      "current_location": "(Ubicación actual)",
      "folder_created": "carpeta creada",
      "folder_name": "Nombre de carpeta",
      "folder_name_length_error": "El nombre de la carpeta no puede tener más de {{value}} caracteres.",
      "save": "Guardar",
      "untitled": "Sin título"
    },
    "upload": {
      "add_more": "Agregar más",
      "browse_files": "Examinar archivos",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Cancelar",
      "clear_all": "Borrar todo",
      "drag_drop": "Arrastre aquí los archivos",
      "drop_files_here": "Coloque aquí los archivos",
      "edit": "Modificar",
      "failed": "Falló",
      "file_name": "Nombre de archivo",
      "folder_warning": "Parece que alguno de los objetos arrastrados es una carpeta. La carga de carpetas no recibe respaldo en estos momentos.",
      "from_computer": "Desde el equipo",
      "from_sharefile": "Desde ShareFile",
      "item_details": "Detalles del elemento",
      "item_failed_to_upload": "El elemento no se pudo cargar",
      "items_selected": "elemento",
      "more_than_one_item_selected": "elementos",
      "overwrite_same_name": "Sobrescribir archivos con el mismo nombre.",
      "prevent_folders": "El uso compartido de carpetas no está disponible con esta opción. Inténtelo con archivos sueltos.",
      "save": "Guardar",
      "upload": "Cargar",
      "upload_to": "Cargar en \"{{folderName}}\"",
      "uploaded": "Cargado"
    },
    "validation": {
      "enter_required_value": "Este campo es obligatorio."
    },
    "virus": {
      "contact_admin": "Póngase en contacto con el administrador si cree que se trata de un error.",
      "file_marked_as_false_positive_title": "Contenido malicioso detectado",
      "file_marked_as_false_positive_warn": "Hemos detectado contenido malicioso en este archivo. El administrador ha restablecido el acceso, pero no podemos garantizar que sea seguro abrirlo.",
      "malicious_file": "Este archivo se ha identificado como malicioso y puede contener un virus.",
      "malicious_file_block": "Hemos detectado contenido malicioso y hemos restringido el acceso a este archivo. Le recomendamos eliminarlo.",
      "malicious_file_block_action": "Seleccionó un archivo que tiene contenido malicioso.",
      "malicious_file_block_archive": "Hemos detectado contenido malicioso y hemos restringido el acceso a este archivo.",
      "malicious_file_title": "Archivo malicioso detectado",
      "malicious_file_warn": "Hemos detectado contenido malicioso en este archivo. Le recomendamos eliminarlo.",
      "malicious_file_warn_action": "Seleccionó un archivo que tiene contenido malicioso. Le recomendamos eliminarlo.",
      "malicious_file_warn_archive": "Hemos detectado contenido malicioso en este archivo.",
      "unscanned_file_block": "Este archivo se está analizando en busca de contenido malicioso. Actualice la página para obtener el estado más reciente.",
      "unscanned_file_block_action": "Seleccionó un archivo que se está analizando en busca de contenido malicioso. Inténtelo de nuevo más tarde.",
      "unscanned_file_block_title": "Análisis de archivos en curso"
    },
    "yes": "Sí",
    "you": "Usted"
  }
}, {
  "key": "fr",
  "content": {
    "add": "Ajouter",
    "address_book": {
      "address_book": "Carnet d'adresses",
      "address_book_icon_label": "Open Address Book",
      "company": "Société",
      "contact_type": "Type de contact",
      "distribution": "Groupe de distribution",
      "employees": "Employés",
      "name": "Nom",
      "no_contact": "Aucun contact ne correspond à votre recherche",
      "personal": "Carnet d'adresses personnel",
      "shared": "Carnet d'adresses partagé"
    },
    "cancel": "Annuler",
    "caution": "Attention",
    "checkout": {
      "about_to_check_out_expire_message": "Le fichier extrait expirera dans 24 heures. Les autres utilisateurs pourront voir que vous avez extrait le fichier et pourront toujours le télécharger.",
      "about_to_check_out_filename": "Vous êtes sur le point d'extraire « {{itemName}} ».",
      "checkedout_multiple_action": "Êtes-vous sûr de vouloir {{title}} ces fichiers ?",
      "checkedout_multiple_msg": "Un ou plusieurs fichiers sont extraits.",
      "checkedout_single_date": "{{userName}} a extrait ce fichier. Le fichier expire le {{checkedOutDate}}.",
      "checkedout_single_filename": "Êtes-vous sûr de vouloir {{title}} « {{fileName}} » ?",
      "checkout_discard_filename": "« {{itemName}} »",
      "checkout_discard_msg": "Vous êtes sur le point d'abandonner l'extraction de"
    },
    "contactSelect": {
      "clearValue": "Effacer valeur",
      "noResults": "Aucun résultat trouvé",
      "searching": "Recherche...",
      "select": "Sélectionner...",
      "start_typing": "Commencez à taper pour trouver des utilisateurs"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Continuer",
    "continue_anyway": "Continuer quand même",
    "copy": {
      "copy": "Copier",
      "copy_target_not_allowed": "L'élément que vous avez sélectionné ne peut pas être copié dans ce dossier. Essayez un dossier différent.",
      "copying_item_to": "Copie de « {{fileName}} » sur {{destinationFolder}}",
      "copying_item_to_plural": "Copie de {{count}} éléments dans {{destinationFolder}}",
      "need_permission": "Des autorisations sont nécessaires pour copier ici. Essayez de copier sur un sous-dossier ou dossier différent.",
      "title": "Copie"
    },
    "create_folder": "Créer un dossier",
    "done": "Terminé",
    "favorites": "Favoris",
    "file_list": {
      "view_all": "Afficher les {{count}} éléments"
    },
    "file_list_modal": {
      "dont_show_again": "Ne plus afficher ce message",
      "move_away_selections": "Si vous naviguez en dehors du dossier actuel, vos sélections seront perdues."
    },
    "generic_error": "Une erreur s’est produite",
    "get_approval": {
      "add_approvers": "Ajouter des approbateurs",
      "approvers": "Approbateurs",
      "approvers_in_order": "Les approbateurs doivent approuver dans l'ordre",
      "approvers_tooltip": " Ces personnes doivent donner leur approbation. Si vous ajoutez un groupe de distribution, les personnes sont répertoriées individuellement.",
      "due_date": "Date d'échéance :",
      "edit_approval_settings": "Modifier paramètres d'approbation",
      "message": "Message",
      "options": {
        "edit_approval_settings": "Modifier paramètres d'approbation",
        "request_for_new_version": "Envoyer une demande d'approbation pour chaque nouvelle version chargée",
        "request_for_new_version_help": "Chaque fois qu'une nouvelle version est chargée, tout le monde est invité à approuver la nouvelle version.",
        "require_login": "Exiger que les participants se connectent"
      },
      "send_for_approval": "Envoyer pour approbation",
      "title": "Obtenir l’approbation",
      "viewers": "Observateurs",
      "viewers_tooltip": " Ces personnes peuvent voir les informations et émettre des commentaires, mais ne peuvent pas les approuver."
    },
    "load_more": "Charger plus",
    "move": {
      "cannot_move_to_current": "Impossible de déplacer dans l’emplacement actuel. Essayez sur un sous-dossier ou un dossier différent.",
      "cannot_move_to_selected": "Impossible de déplacer sur un dossier actuellement sélectionné. Essayez sur un sous-dossier ou un dossier différent.",
      "move": "Déplacer",
      "move_target_not_allowed": "L'élément que vous avez sélectionné ne peut pas être déplacé dans ce dossier. Essayez un dossier différent.",
      "moving_item_to": "Déplacement de « {{fileName}} » sur {{destinationFolder}}",
      "moving_item_to_plural": "Déplacement de {{count}} éléments dans {{destinationFolder}}",
      "need_permission": "Des autorisations sont nécessaires pour déplacer ici. Essayez de déplacer sur un sous-dossier ou dossier différent.",
      "title": "Déplacement"
    },
    "no": "Non",
    "persistent_links": {
      "copy": "Copier",
      "copy_to_clipboard": "Lien copié sur le presse-papiers",
      "create_link": "Créer lien",
      "create_new_link": "Créer un autre lien",
      "delete_link": "Supprimer le lien",
      "delete_modal_cancel_text": "Annuler",
      "delete_modal_confirm_text": "Supprimer le lien",
      "delete_modal_message": "La suppression de ce lien le rendra inaccessible. Êtes-vous sûr de vouloir supprimer l'accès ?",
      "edit_options": "Modifier les options",
      "expiry_day": "Expire dans un jour",
      "expiry_days": "Expire dans {{remainingDays}} jours",
      "items": "Éléments",
      "links_to_version": "Liens vers une version créée le {{creationDate}} à {{creationTime}}",
      "notify_link_access": "M'avertir en cas d'accès au lien",
      "notify_link_access_request": "M'avertir lorsque des fichiers sont chargés",
      "replace_link": "Remplacer le lien",
      "replace_modal_confirm_text": "Remplacer le lien",
      "replace_modal_message": "Le remplacement de ce lien créera un nouveau lien avec les mêmes autorisations. L'ancien lien ne sera plus accessible. Êtes-vous sûr de vouloir supprimer l'accès ?",
      "toast": {
        "link_created": "Lien créé et copié dans le presse-papiers"
      },
      "view_all_items": "Afficher tous les éléments"
    },
    "personal_folders": "Dossiers personnels",
    "progress": {
      "finalize_upload": "Finalisation du chargement...",
      "hour_remaining": "{{hoursRemaining}} hr(s) ",
      "less_1_min_remaining": "moins d'une minute",
      "minute_remaining": "{{minutesRemaining}} min(s) ",
      "remaining": "{{remainingTimeDisplay}} restant(s) ",
      "retrying": "Erreur de chargement : nouvelle tentative",
      "second_remaining": "{{secondsRemaining}} s ",
      "shouldnt_take_long": "Veuillez patienter...",
      "starting_upload": "Démarrage du chargement...",
      "transfer_progress": "{{progress}} sur {{total}}"
    },
    "save": "Enregistrer",
    "select": "Sélectionner",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Impossible de signer",
      "title": "Envoyer pour signature"
    },
    "share": {
      "access_expires": "Accès expire",
      "add_files_from_device": "Ajouter des éléments depuis mon appareil",
      "add_files_from_sharefile": "Ajouter des éléments depuis ShareFile",
      "add_items": "Ajouter des éléments",
      "add_more_items": "Ajouter plus d’éléments",
      "back": "Précédent",
      "breadcrumbs": "Dans « {{breadcrumbs}} »",
      "cancel": "Annuler",
      "cancel_confirm": "Êtes-vous sûr de vouloir annuler le message ?",
      "compose": "Composer",
      "copy": "Copier",
      "copy_success": "Copié sur le Presse-papiers !",
      "create_and_copy": "Créer et copier",
      "default_message_subject": "{{name}} vous a envoyé des fichiers",
      "default_message_subject_request": "{{name}} vous a demandé des fichiers",
      "done": "Terminé",
      "download": "Télécharger",
      "edit": "Modifier",
      "edit_link_options": "Modifier les options de lien",
      "edit_message_options": "Modifier les options des messages",
      "edit_options": "Modifier les options",
      "edit_sign_in": "Modifier (connexion requise)",
      "email_title": "Envoyer avec ShareFile",
      "empty_folder": "Ce dossier est vide",
      "encrypt_message": "Crypter cet e-mail",
      "encrypted_message_send_success": "Message crypté envoyé avec succès",
      "expiration_changed": "Un ou plusieurs des éléments sélectionnés disposent d'une date d'expiration antérieure aux options de lien sélectionnées.",
      "file_box": "Zone de fichier",
      "file_location": "Emplacement du fichier",
      "from_my_device": "Depuis mon appareil",
      "get_a_link": "Obtenir un lien",
      "get_a_link2": "Obtenir un lien",
      "get_temp_link": "Obtenir un lien temporaire",
      "groups_not_supported": "Les groupes de distribution ne sont pas pris en charge pour les messages cryptés.",
      "link_options": "Options de lien",
      "message": "Message",
      "message_encrypted": "Ce message est crypté.",
      "message_options": "Options de message",
      "message_send_fail_attachment": "Votre message n'a pas été envoyé en raison d'un problème lors de l'ajout du fichier {{file}}.",
      "message_send_fail_hard": "Le message n'a pas pu être envoyé pour le moment. Veuillez réessayer ultérieurement.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Les destinataires peuvent télécharger après s'être connectés.",
            "require_user_info": "Quiconque pourra accéder à ce lien s'il peut saisir l'adresse e-mail d'un destinataire."
          },
          "no_require_login": {
            "view_download": "Cela créera un lien qui permettra à quiconque de télécharger ce que vous partagez sans se connecter.",
            "view_only": "Cela créera un lien qui permettra à quiconque de voir ce que vous partagez sans se connecter."
          },
          "require_login": {
            "view_download": "Les destinataires peuvent télécharger après s'être connectés.",
            "view_download_edit": "Les destinataires peuvent modifier après s'être connectés.",
            "view_download_watermark": "Les destinataires peuvent télécharger avec un filigrane après s'être connectés.",
            "view_only": "Les destinataires peuvent consulter en ligne après s'être connectés.",
            "view_watermark": "Les destinataires peuvent consulter en ligne avec un filigrane après s'être connectés."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Quiconque peut télécharger du contenu sans se connecter.",
            "view_download_watermark": "Quiconque peut télécharger une copie filigranée sans se connecter.",
            "view_only": "Quiconque peut consulter du contenu sans se connecter.",
            "view_watermark": "Quiconque peut consulter une copie filigranée sans se connecter."
          },
          "employee_and_client_only": {
            "view_download": "Les utilisateurs peuvent télécharger du contenu après s'être connectés.",
            "view_download_edit": "Les utilisateurs peuvent modifier du contenu après s'être connectés.",
            "view_download_watermark": "Les utilisateurs peuvent télécharger une copie filigranée après s'être connectés.",
            "view_only": "Les utilisateurs peuvent consulter le contenu après s'être connectés.",
            "view_watermark": "Les utilisateurs peuvent consulter une copie filigranée après s'être connectés."
          },
          "employee_only": {
            "view_download": "Les employés peuvent télécharger après s'être connectés.",
            "view_download_edit": "Les employés peuvent modifier après s'être connectés.",
            "view_download_watermark": "Les employés peuvent télécharger une copie filigranée après s'être connectés.",
            "view_only": "Les employés peuvent consulter le contenu après s'être connectés.",
            "view_watermark": "Les employés peuvent consulter une copie filigranée après s'être connectés."
          },
          "require_user_info": {
            "view_download": "Quiconque peut télécharger du contenu sans se connecter s'il fournit un nom et une adresse e-mail.",
            "view_download_watermark": "Quiconque peut télécharger une copie filigranée sans se connecter s'il fournit un nom et une adresse e-mail.",
            "view_only": "Quiconque peut consulter du contenu sans se connecter s'il fournit un nom et une adresse e-mail.",
            "view_watermark": "Quiconque peut consulter une copie filigranée sans se connecter s'il fournit un nom et une adresse e-mail."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Les destinataires peuvent charger du contenu après s'être connectés.",
            "require_login": "Les destinataires peuvent charger après s'être connectés."
          },
          "link": {
            "anonymous": "Quiconque peut charger du contenu sans se connecter.",
            "employee_and_client_only": "Les utilisateurs peuvent charger du contenu après s'être connectés.",
            "employee_only": "Les employés peuvent charger après s'être connectés.",
            "require_user_info": "Quiconque peut charger du contenu sans se connecter s'il fournit un nom et une adresse e-mail."
          }
        }
      },
      "no_files_error": "Veuillez ajouter au moins un fichier.",
      "no_items": "Aucun élément",
      "options": {
        "access": "Options d'accès",
        "access_options": {
          "for_tracking_only": "À des fins de suivi uniquement.",
          "label": "Personnes autorisées à accéder à ce lien",
          "message_for_hipaa": "Vous ne pouvez pas partager de fichiers publiquement, car la prise en charge HIPAA est activée sur votre compte. Contactez l'administrateur.",
          "message_for_hipaa_edit": "Vous ne pouvez pas modifier les fichiers, car la prise en charge HIPAA est activée sur votre compte. Veuillez contacter l'administrateur.",
          "selections": {
            "anyone": "Quiconque (public)",
            "clients_and_employees": "Utilisateurs clients et employés (après connexion)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Utilisateurs employés (après connexion)",
            "name_and_email": "Quiconque (public, doit entrer un nom et un e-mail)"
          },
          "set_by_admin": "Votre administrateur a configuré cette option.",
          "tooltip": "Exigences d'accès au lien auxquelles sont soumis les destinataires. Les utilisateurs employés sont généralement des personnes au sein de votre entreprise."
        },
        "add_watermark": "Ajouter un filigrane",
        "allow_recipients": {
          "edit_about_link": "À propos de la modification de contenu Office Online",
          "edit_tooltip": "Les droits d'accès en modification permettent aux utilisateurs de modifier les fichiers partagés en ligne. Certains types de fichiers ne prennent pas en charge la modification.",
          "select_label": "Autorisation des destinataires :",
          "tooltip": "L'option Consulter en ligne uniquement empêche les utilisateurs de télécharger le fichier. Certains types de fichiers ne prennent pas en charge le partage en lecture seule ou les filigranes.",
          "tooltip_about_view_only_link": "À propos du partage en lecture seule",
          "tooltip_about_watermarking_link": "À propos des filigranes"
        },
        "downloads_limits": {
          "unlimited": "Illimités"
        },
        "downloads_per_user": "Téléchargements par utilisateur",
        "edit_disabled_message": "Vos paramètres de partage ont été modifiés car vous avez ajouté un fichier qui ne prend pas en charge la modification.",
        "edit_options_access_level_warning": {
          "FullControl": "Quiconque peut télécharger ce que vous partagez sans se connecter.",
          "ViewOnline": "Quiconque peut consulter ce que vous partagez sans se connecter."
        },
        "edit_options_warning": "Les autorisations seront modifiées pour tous ceux qui disposent déjà de ce lien. Vous pouvez créer un nouveau lien si vous ne souhaitez pas modifier celui-ci.",
        "edit_permission_alert_message": "Pour autoriser les destinataires à apporter des modifications, ils doivent se connecter.",
        "email_me_accessed": "M'envoyer un e-mail en cas d'accès aux fichiers",
        "encrypt_email": "Crypter e-mail",
        "encrypt_message": "Pour une protection renforcée, cryptez vos messages électroniques. Veuillez noter que vos fichiers sont déjà cryptés.",
        "encrypted_email_enabled": "Les options d'accès ont été ajustées car les e-mails cryptés ont été activés.",
        "expirations": {
          "after_one_day": "après un jour",
          "after_one_week": "après une semaine",
          "after_six_months": "après six mois",
          "after_three_months": "après trois mois",
          "after_x_days": "après {{days}} jours",
          "after_year": "après une année",
          "never": "jamais"
        },
        "latest_version": "Toujours lier à la dernière version du fichier",
        "latest_version_help": "La désactivation de cette option fournira uniquement un lien vers la copie actuelle du fichier que vous avez sélectionné.",
        "notifications": "Notifications",
        "notify_me_accessed": "M'avertir en cas d'accès",
        "persistent_link_conflict": "Vous avez déjà créé un lien avec ces autorisations.",
        "require_login": "Exiger que les destinataires se connectent",
        "require_login_help": "Les destinataires liront le message et téléchargeront les pièces jointes après s'être connectés à ShareFile",
        "require_login_help_request": "Les destinataires liront le message et chargeront les pièces jointes après s'être connectés à ShareFile",
        "send_copy": "M'envoyer une copie de cet e-mail",
        "views_per_user": "Consultations par utilisateur"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Les destinataires de ce lien peuvent le télécharger après s'être connectés.",
            "require_user_info": "Les destinataires de ce lien peuvent le télécharger après avoir entré leur nom et e-mail."
          },
          "no_require_login": {
            "view_download": "Les destinataires de ce lien peuvent le consulter et le télécharger.",
            "view_only": "Les destinataires de ce lien peuvent le consulter en ligne."
          },
          "require_login": {
            "view_download": "Les destinataires de ce lien peuvent le consulter et le télécharger après s'être connectés.",
            "view_download_edit": "Les destinataires de ce lien peuvent le consulter, le télécharger et le modifier après s'être connectés.",
            "view_download_watermark": "Les destinataires de ce lien peuvent le consulter et le télécharger avec un filigrane après s'être connectés.",
            "view_only": "Les destinataires de ce lien peuvent le consulter en ligne après s'être connectés.",
            "view_watermark": "Les destinataires de ce lien peuvent le consulter en ligne avec un filigrane après s'être connectés."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Toute personne avec ce lien peut le consulter et le télécharger.",
            "view_download_watermark": "Toute personne avec ce lien peut le consulter et le télécharger avec un filigrane.",
            "view_only": "Toute personne avec ce lien peut le consulter en ligne.",
            "view_watermark": "Toute personne avec ce lien peut le consulter en ligne avec un filigrane."
          },
          "employee_and_client_only": {
            "view_download": "Les utilisateurs avec ce lien peuvent le consulter et le télécharger après s'être connectés.",
            "view_download_edit": "Les utilisateurs avec ce lien peuvent le consulter, le télécharger et le modifier après s'être connectés.",
            "view_download_watermark": "Les utilisateurs avec ce lien peuvent le consulter et le télécharger avec un filigrane après s'être connectés.",
            "view_only": "Les utilisateurs avec ce lien peuvent le consulter en ligne après s'être connectés.",
            "view_watermark": "Les utilisateurs avec ce lien peuvent le consulter en ligne avec un filigrane après s'être connectés."
          },
          "employee_only": {
            "view_download": "Les employés avec ce lien peuvent le consulter et le télécharger après s'être connectés.",
            "view_download_edit": "Les employés avec ce lien peuvent le consulter, le télécharger et le modifier après s'être connectés.",
            "view_download_watermark": "Les employés avec ce lien peuvent le consulter et le télécharger avec un filigrane après s'être connectés.",
            "view_only": "Les employés avec ce lien peuvent le consulter en ligne après s'être connectés.",
            "view_watermark": "Les employés avec ce lien peuvent le consulter en ligne avec un filigrane après s'être connectés."
          },
          "require_user_info": {
            "view_download": "Toute personne disposant de ce lien peut le consulter et le télécharger après avoir entré son nom et e-mail.",
            "view_download_watermark": "Toute personne disposant de ce lien peut le consulter et le télécharger avec un filigrane après avoir entré son nom et e-mail.",
            "view_only": "Toute personne avec ce lien peut le consulter en ligne après avoir entré son nom et e-mail.",
            "view_watermark": "Toute personne avec ce lien peut le consulter en ligne avec un filigrane après avoir entré son nom et e-mail."
          }
        }
      },
      "progress": {
        "progress": "Progression",
        "sending": "Envoi en cours. Ne fermez pas la fenêtre.",
        "upload_then_send": "Chargement puis envoi de votre fichier. Ne fermez pas la fenêtre."
      },
      "remember_message": "Mémoriser l'objet et le message",
      "request": "Demander",
      "request_files": "Demander des fichiers",
      "required": "* Requis",
      "send": "Envoyer",
      "send_to_specific_people": "Envoyer à des personnes spécifiques",
      "sending_cancel_confirm": "Êtes-vous sûr de vouloir annuler le message ? Il est en cours d'envoi.",
      "share_access_label": "Autoriser les personnes disposant de ce lien à",
      "share_bundle": "Partager - Bundle",
      "share_files": "Partager des fichiers",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Les destinataires peuvent télécharger après s'être connectés.",
              "require_user_info": "Quiconque pourra accéder à ce lien à condition de saisir l'adresse e-mail d'un destinataire."
            },
            "no_require_login": {
              "view_download": "Quiconque peut télécharger du contenu sans se connecter.",
              "view_only": "Quiconque peut consulter du contenu sans se connecter."
            },
            "require_login": {
              "view_download": "Les destinataires peuvent télécharger après s'être connectés.",
              "view_download_edit": "Les destinataires peuvent modifier après s'être connectés.",
              "view_download_watermark": "Les destinataires peuvent télécharger avec un filigrane après s'être connectés.",
              "view_only": "Les destinataires peuvent consulter en ligne après s'être connectés.",
              "view_watermark": "Les destinataires peuvent consulter en ligne avec un filigrane après s'être connectés."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Quiconque peut télécharger du contenu sans se connecter.",
              "view_download_watermark": "Quiconque peut télécharger une copie filigranée sans se connecter.",
              "view_only": "Quiconque peut consulter du contenu sans se connecter.",
              "view_watermark": "Quiconque peut consulter une copie filigranée sans se connecter."
            },
            "employee_and_client_only": {
              "view_download": "Les utilisateurs peuvent télécharger du contenu après s'être connectés.",
              "view_download_edit": "Les utilisateurs peuvent modifier du contenu après s'être connectés.",
              "view_download_watermark": "Les utilisateurs peuvent télécharger une copie filigranée après s'être connectés.",
              "view_only": "Les utilisateurs peuvent consulter le contenu après s'être connectés.",
              "view_watermark": "Les utilisateurs peuvent consulter une copie filigranée après s'être connectés."
            },
            "employee_only": {
              "view_download": "Les employés peuvent télécharger après s'être connectés.",
              "view_download_edit": "Les employés peuvent modifier après s'être connectés.",
              "view_download_watermark": "Les employés peuvent télécharger une copie filigranée après s'être connectés.",
              "view_only": "Les employés peuvent consulter le contenu après s'être connectés.",
              "view_watermark": "Les employés peuvent consulter une copie filigranée après s'être connectés."
            },
            "require_user_info": {
              "view_download": "Quiconque peut télécharger du contenu sans se connecter s'il fournit un nom et une adresse e-mail.",
              "view_download_watermark": "Quiconque peut télécharger une copie filigranée sans se connecter s'il fournit un nom et une adresse e-mail.",
              "view_only": "Quiconque peut consulter du contenu sans se connecter s'il fournit un nom et une adresse e-mail.",
              "view_watermark": "Quiconque peut consulter une copie filigranée sans se connecter s'il fournit un nom et une adresse e-mail."
            }
          }
        },
        "analyzing_file_content": "Analyse du contenu du fichier...",
        "apply_recommended_options": "Appliquer les options recommandées",
        "applying_recommended_options": "Application des options recommandées",
        "create_secure_link": "Créer un lien sécurisé",
        "data_found": "Données trouvées :",
        "expiry_tooltip": {
          "after_one_day": "Le lien expirera au bout d'un jour.",
          "after_one_week": "Le lien expirera au bout d'une semaine.",
          "after_six_months": "Le lien expirera au bout de six mois.",
          "after_three_months": "Le lien expirera au bout de trois mois.",
          "after_x_days": "Le lien expirera au bout de {{days}} jours.",
          "after_year": "Le lien expirera au bout d'un an.",
          "never": "Le lien n'expirera jamais."
        },
        "feedback": {
          "helpful": "Utile",
          "not_helpful": "Pas utile",
          "was_this_helpful": "Cela vous a-t-il été utile ?"
        },
        "file_may_contain_personal_information": "Ce fichier peut contenir des informations personnelles.",
        "file_may_contain_sensitive_information": "Ce fichier peut contenir des informations sensibles.",
        "pii_marker_type": {
          "ADDRESS": "Adresse",
          "AGE": "Âge",
          "AWS_ACCESS_KEY": "Clé d'accès AWS",
          "AWS_SECRET_KEY": "Clé secrète AWS",
          "BANK_ACCOUNT_NUMBER": "Numéro de compte bancaire",
          "BANK_ROUTING": "Routage bancaire",
          "CA_HEALTH_NUMBER": "Numéro de carte Santé au Canada",
          "CA_SOCIAL_INSURANCE_NUMBER": "Numéro d'assurance sociale au Canada",
          "CREDIT_DEBIT_CVV": "CVV carte crédit/débit",
          "CREDIT_DEBIT_EXPIRY": "Expiration carte crédit/débit",
          "CREDIT_DEBIT_NUMBER": "Numéro de carte crédit/débit",
          "DATE_TIME": "Date/Heure",
          "DRIVER_ID": "Identifiant de conducteur",
          "EMAIL": "E-mail",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Numéro de compte bancaire international (IBAN)",
          "IN_AADHAAR": "Numéro de carte Aadhaar en Inde",
          "IN_NREGA": "Numéro NREGA en Inde",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Numéro de compte permanent en Inde (PAN)",
          "IN_VOTER_NUMBER": "Numéro d'électeur en Inde",
          "IP_ADDRESS": "IP Address",
          "LICENSE_PLATE": "Plaque d'immatriculation",
          "MAC_ADDRESS": "Adresse MAC",
          "NAME": "Nom",
          "PASSPORT_NUMBER": "Numéro de passeport",
          "PASSWORD": "Mot de passe",
          "PHONE": "Téléphone",
          "PIN": "Code PIN",
          "SSN": "Numéro de sécurité sociale (SSN)",
          "SWIFT_CODE": "Code SWIFT",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Numéro du service national de santé au Royaume-Uni",
          "UK_NATIONAL_INSURANCE_NUMBER": "Numéro de sécurité sociale au Royaume-Uni",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Numéro de référence fiscal unique au Royaume-Uni",
          "URL": "Adresse URL",
          "USERNAME": "Nom d'utilisateur",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "Numéro d'identification fiscale individuel aux États-Unis (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "Numéro d'identification du véhicule (VIN)"
        },
        "recommended_tag": "Recommandé",
        "skip": "Ignorer",
        "view_details": "Afficher les détails",
        "we_are_still_working_on_it": "Nous y travaillons encore..."
      },
      "subject": "Objet",
      "title": "Partager",
      "to": "À",
      "toast": {
        "connector_filebox_recipients": "Ce fichier va être copié sur la zone de fichier. Il est possible que les destinataires n'y ait pas accès immédiatement.",
        "multiple_source_error": "Tous les éléments doivent provenir de la même source de données.",
        "scan_warning": "Ce partage contient un fichier volumineux. Vous pouvez envoyer votre lien, mais le téléchargement risque de ne pas être disponible pendant plusieurs minutes, le temps que notre analyse antivirus se termine.",
        "send_success": "Élément(s) envoyé(s) avec succès.",
        "share_request_success": "Demande envoyée avec succès",
        "share_send_success": "Partage envoyé avec succès",
        "upload_error": "Échec du chargement d'un ou de plusieurs fichiers.",
        "upload_in_progress": "Chargement en cours. Laissez la fenêtre ouverte."
      },
      "upload_location": "Emplacement de chargement",
      "view": "Afficher",
      "view_access_expires": "L'accès en consultation expire le"
    },
    "shared_folders": "Dossiers partagés",
    "treeview": {
      "cancel": "Annuler",
      "current_location": "(Emplacement actuel)",
      "folder_created": "dossier créé",
      "folder_name": "Nom du dossier",
      "folder_name_length_error": "Le nom du dossier ne peut pas dépasser {{value}} caractères.",
      "save": "Enregistrer",
      "untitled": "Sans titre"
    },
    "upload": {
      "add_more": "Ajouter",
      "browse_files": "Parcourir les fichiers",
      "byte_units": {
        "B": "o",
        "EB": "Eo",
        "GB": "Go",
        "KB": "Ko",
        "MB": "Mo",
        "PB": "Po",
        "TB": "To",
        "YB": "Yo",
        "ZB": "Zo"
      },
      "cancel": "Annuler",
      "clear_all": "Tout effacer",
      "drag_drop": "Déposer les fichiers ici",
      "drop_files_here": "Déposez les fichiers ici",
      "edit": "Modifier",
      "failed": "Échec",
      "file_name": "Nom du fichier",
      "folder_warning": "Il semble qu'un ou plusieurs des fichiers que vous avez déplacés soient un dossier. Le chargement de dossiers n'est pas pris en charge pour le moment.",
      "from_computer": "De l'ordinateur",
      "from_sharefile": "De ShareFile",
      "item_details": "Détails de l'élément",
      "item_failed_to_upload": "Échec de chargement de l'élément",
      "items_selected": "élément",
      "more_than_one_item_selected": "éléments",
      "overwrite_same_name": "Remplacer les fichiers portant le même nom.",
      "prevent_folders": "Le partage de dossiers n'est pas disponible avec cette option. Veuillez utiliser des fichiers individuels.",
      "save": "Enregistrer",
      "upload": "Charger",
      "upload_to": "Charger sur « {{folderName}} »",
      "uploaded": "Chargé"
    },
    "validation": {
      "enter_required_value": "Ce champ est obligatoire."
    },
    "virus": {
      "contact_admin": "Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.",
      "file_marked_as_false_positive_title": "Contenu malveillant détecté",
      "file_marked_as_false_positive_warn": "Nous avons détecté du contenu malveillant dans ce fichier. Votre administrateur a rétabli l'accès, mais nous ne pouvons pas garantir qu'il puisse être ouvert en toute sécurité.",
      "malicious_file": "Ce fichier a été identifié comme étant malveillant et peut contenir un virus.",
      "malicious_file_block": "Nous avons détecté du contenu malveillant et avons restreint l'accès à ce fichier. Nous vous recommandons de le supprimer.",
      "malicious_file_block_action": "Vous avez sélectionné un fichier dont le contenu est malveillant.",
      "malicious_file_block_archive": "Nous avons détecté du contenu malveillant et avons restreint l'accès à ce fichier.",
      "malicious_file_title": "Fichier malveillant détecté",
      "malicious_file_warn": "Nous avons détecté du contenu malveillant dans ce fichier. Nous vous recommandons de le supprimer.",
      "malicious_file_warn_action": "Vous avez sélectionné un fichier dont le contenu est malveillant. Nous vous recommandons de le supprimer.",
      "malicious_file_warn_archive": "Nous avons détecté du contenu malveillant dans ce fichier.",
      "unscanned_file_block": "Ce fichier est en cours d'analyse afin de détecter du contenu malveillant. Actualisez pour afficher l'état le plus récent.",
      "unscanned_file_block_action": "Vous avez sélectionné un fichier en cours d'analyse afin de détecter du contenu malveillant. Réessayez plus tard.",
      "unscanned_file_block_title": "Analyse des fichiers en cours"
    },
    "yes": "Oui",
    "you": "Vous"
  }
}, {
  "key": "it",
  "content": {
    "add": "Aggiungi",
    "address_book": {
      "address_book": "Rubrica",
      "address_book_icon_label": "Open Address Book",
      "company": "Società",
      "contact_type": "Tipo di contatto",
      "distribution": "Gruppo di distribuzione",
      "employees": "Dipendenti",
      "name": "Nome",
      "no_contact": "Nessun contatto corrisponde alla ricerca",
      "personal": "Rubrica personale",
      "shared": "Rubrica condivisa"
    },
    "cancel": "Annulla",
    "caution": "Attenzione",
    "checkout": {
      "about_to_check_out_expire_message": "Il file estratto scadrà tra 24 ore. Altri utenti saranno in grado di visualizzare che il file è stato estratto e potranno scaricarlo.",
      "about_to_check_out_filename": "Si sta per estrarre '{{itemName}}'.",
      "checkedout_multiple_action": "{{title}} i file?",
      "checkedout_multiple_msg": "Uno o più file sono stati estratti.",
      "checkedout_single_date": "{{userName}} ha estratto questo file. L'estrazione scadrà il {{checkedOutDate}}.",
      "checkedout_single_filename": "{{title}} '{{fileName}}'?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "Si sta per ignorare l'estrazione di"
    },
    "contactSelect": {
      "clearValue": "Cancella valore",
      "noResults": "Nessun risultato trovato",
      "searching": "Ricerca...",
      "select": "Seleziona...",
      "start_typing": "Iniziare a digitare per trovare gli utenti"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Continua",
    "continue_anyway": "Continua comunque",
    "copy": {
      "copy": "Copia",
      "copy_target_not_allowed": "Impossibile copiare l'elemento selezionato nella cartella. Provare con un'altra cartella.",
      "copying_item_to": "Copia di \"{{fileName}}\" in {{destinationFolder}}",
      "copying_item_to_plural": "Copia di {{count}} elementi in {{destinationFolder}}",
      "need_permission": "Per copiare qui è necessaria l'autorizzazione. Provare con un'altra cartella o sottocartella.",
      "title": "Copia in corso"
    },
    "create_folder": "Crea cartella",
    "done": "Fatto",
    "favorites": "Preferiti",
    "file_list": {
      "view_all": "Visualizza tutti gli {{count}} elementi"
    },
    "file_list_modal": {
      "dont_show_again": "Non mostrare questo messaggio in futuro",
      "move_away_selections": "Se si abbandona la cartella corrente, le selezioni andranno perse."
    },
    "generic_error": "Si è verificato un errore",
    "get_approval": {
      "add_approvers": "Aggiungi responsabili approvazione",
      "approvers": "Responsabili approvazione",
      "approvers_in_order": "I responsabili approvazione devono approvare in base all'ordine",
      "approvers_tooltip": " Questi utenti devono concedere l'approvazione. Se si aggiunge un gruppo di distribuzione, le persone vengono elencate singolarmente.",
      "due_date": "Scadenza:",
      "edit_approval_settings": "Modifica impostazioni di approvazione",
      "message": "Messaggio",
      "options": {
        "edit_approval_settings": "Modifica impostazioni di approvazione",
        "request_for_new_version": "Invia una richiesta di approvazione per ogni nuova versione caricata",
        "request_for_new_version_help": "Ogni volta che si carica una nuova versione, tutti ricevono una notifica per approvare la nuova versione.",
        "require_login": "Richiedi ai partecipanti di accedere"
      },
      "send_for_approval": "Invia per l'approvazione",
      "title": "Ottieni approvazione",
      "viewers": "Partecipanti",
      "viewers_tooltip": " Questi utenti possono visualizzare informazioni e aggiungere commenti, ma non possono approvare."
    },
    "load_more": "Carica altro",
    "move": {
      "cannot_move_to_current": "Impossibile spostare nella posizione corrente. Provare con un'altra cartella o sottocartella.",
      "cannot_move_to_selected": "Impossibile spostare in una cartella attualmente selezionata. Provare con un'altra cartella o sottocartella.",
      "move": "Sposta",
      "move_target_not_allowed": "Impossibile spostare l'elemento selezionato nella cartella. Provare con un'altra cartella.",
      "moving_item_to": "Spostamento di \"{{fileName}}\" in {{destinationFolder}}",
      "moving_item_to_plural": "Spostamento di {{count}} elementi in {{destinationFolder}}",
      "need_permission": "Per spostare qui è necessaria l'autorizzazione. Provare con un'altra cartella o sottocartella.",
      "title": "Spostamento"
    },
    "no": "No",
    "persistent_links": {
      "copy": "Copia",
      "copy_to_clipboard": "Collegamento copiato negli Appunti",
      "create_link": "Crea collegamento",
      "create_new_link": "Crea un altro collegamento",
      "delete_link": "Elimina collegamento",
      "delete_modal_cancel_text": "Annulla",
      "delete_modal_confirm_text": "Elimina collegamento",
      "delete_modal_message": "L'eliminazione di questo collegamento lo renderà inaccessibile. Si è certi di voler rimuovere l'accesso?",
      "edit_options": "Modifica opzioni",
      "expiry_day": "Scade tra un giorno",
      "expiry_days": "Scade tra {{remainingDays}} giorni",
      "items": "Elementi",
      "links_to_version": "Collegamenti a una versione creata il giorno {{creationDate}} alle {{creationTime}}",
      "notify_link_access": "Avvisami quando viene effettuato l'accesso a questo collegamento",
      "notify_link_access_request": "Avvisami quando vengono caricati file",
      "replace_link": "Sostituisci collegamento",
      "replace_modal_confirm_text": "Sostituisci collegamento",
      "replace_modal_message": "La sostituzione di questo collegamento creerà un nuovo collegamento con le stesse autorizzazioni. Il vecchio collegamento diventerà inaccessibile. Si è certi di voler rimuovere l'accesso?",
      "toast": {
        "link_created": "Collegamento creato e copiato negli Appunti"
      },
      "view_all_items": "Visualizza tutti gli elementi"
    },
    "personal_folders": "Cartelle personali",
    "progress": {
      "finalize_upload": "Completamento del caricamento...",
      "hour_remaining": "{{hoursRemaining}} h ",
      "less_1_min_remaining": "Meno di un minuto",
      "minute_remaining": "{{minutesRemaining}} min ",
      "remaining": "{{remainingTimeDisplay}} rimanente/i ",
      "retrying": "Errore di caricamento: nuovo tentativo",
      "second_remaining": "{{secondsRemaining}} s ",
      "shouldnt_take_long": "L'operazione non richiederà molto tempo...",
      "starting_upload": "Avvio del caricamento...",
      "transfer_progress": "{{progress}} di {{total}}"
    },
    "save": "Salva",
    "select": "Seleziona",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Impossibile firmare",
      "title": "Invia per la firma"
    },
    "share": {
      "access_expires": "L'accesso scade",
      "add_files_from_device": "Aggiungi elementi dal mio dispositivo",
      "add_files_from_sharefile": "Aggiungi elementi da ShareFile",
      "add_items": "Aggiungi elementi",
      "add_more_items": "Aggiungi altri elementi",
      "back": "Indietro",
      "breadcrumbs": "In \"{{breadcrumbs}}\"",
      "cancel": "Annulla",
      "cancel_confirm": "Annullare il messaggio?",
      "compose": "Componi",
      "copy": "Copia",
      "copy_success": "Copiato negli Appunti",
      "create_and_copy": "Crea e copia",
      "default_message_subject": "{{name}} ha inviato file all'utente corrente",
      "default_message_subject_request": "{{name}} ha richiesto file da te",
      "done": "Fine",
      "download": "Scarica",
      "edit": "Modifica",
      "edit_link_options": "Modifica opzioni collegamento",
      "edit_message_options": "Modifica opzioni messaggio",
      "edit_options": "Modifica opzioni",
      "edit_sign_in": "Modifica (è richiesto l'accesso)",
      "email_title": "Invia per e-mail con ShareFile",
      "empty_folder": "La cartella è vuota",
      "encrypt_message": "Crittografa questa e-mail",
      "encrypted_message_send_success": "Messaggio crittografato inviato correttamente",
      "expiration_changed": "Uno o più elementi selezionati presentano una data di scadenza precedente alle opzioni del collegamento selezionate.",
      "file_box": "Cartella condivisione file",
      "file_location": "Percorso file",
      "from_my_device": "Dal mio dispositivo",
      "get_a_link": "Ottieni un collegamento",
      "get_a_link2": "Ottieni un collegamento",
      "get_temp_link": "Ottieni un collegamento temporaneo",
      "groups_not_supported": "I gruppi di distribuzione non sono supportati per i messaggi crittografati.",
      "link_options": "Opzioni collegamento",
      "message": "Messaggio",
      "message_encrypted": "Il messaggio è crittografato.",
      "message_options": "Opzioni messaggi",
      "message_send_fail_attachment": "Impossibile inviare il messaggio: si è verificato un problema durante l'aggiunta del file {{file}} in allegato.",
      "message_send_fail_hard": "Non è al momento possibile inviare il messaggio. Riprovare più tardi.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "I destinatari possono scaricare dopo aver effettuato l'accesso.",
            "require_user_info": "Chiunque sarà in grado di accedere a questo collegamento se può inserire l'indirizzo e-mail di un destinatario."
          },
          "no_require_login": {
            "view_download": "Verrà creato un collegamento che consentirà a chiunque di scaricare ciò che condividi senza effettuare l'accesso.",
            "view_only": "Verrà creato un collegamento che consentirà a chiunque di visualizzare ciò che condividi senza effettuare l'accesso."
          },
          "require_login": {
            "view_download": "I destinatari possono scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "I destinatari possono modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "I destinatari possono scaricare con una filigrana dopo aver effettuato l'accesso.",
            "view_only": "I destinatari possono visualizzare online dopo aver effettuato l'accesso.",
            "view_watermark": "I destinatari possono visualizzare online con una filigrana dopo aver effettuato l'accesso."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Chiunque può scaricare senza effettuare l'accesso.",
            "view_download_watermark": "Chiunque può scaricare una copia con filigrana senza effettuare l'accesso.",
            "view_only": "Chiunque può visualizzare senza effettuare l'accesso.",
            "view_watermark": "Chiunque può visualizzare una copia con filigrana senza effettuare l'accesso."
          },
          "employee_and_client_only": {
            "view_download": "Gli utenti possono scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "Gli utenti possono modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "Gli utenti possono scaricare una copia con filigrana dopo aver effettuato l'accesso.",
            "view_only": "Gli utenti possono visualizzare dopo aver effettuato l'accesso.",
            "view_watermark": "Gli utenti possono visualizzare una copia con filigrana dopo aver effettuato l'accesso."
          },
          "employee_only": {
            "view_download": "I dipendenti possono scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "I dipendenti possono modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "I dipendenti possono scaricare una copia con filigrana dopo aver effettuato l'accesso.",
            "view_only": "I dipendenti possono visualizzare dopo aver effettuato l'accesso.",
            "view_watermark": "I dipendenti possono visualizzare una copia con filigrana dopo aver effettuato l'accesso."
          },
          "require_user_info": {
            "view_download": "Chiunque può scaricare senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
            "view_download_watermark": "Chiunque può scaricare una copia con filigrana senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
            "view_only": "Chiunque può visualizzare senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
            "view_watermark": "Chiunque può visualizzare una copia con filigrana senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "I destinatari possono caricare senza effettuare l'accesso.",
            "require_login": "I destinatari possono caricare dopo aver effettuato l'accesso."
          },
          "link": {
            "anonymous": "Chiunque può caricare senza effettuare l'accesso.",
            "employee_and_client_only": "Gli utenti possono caricare dopo aver effettuato l'accesso.",
            "employee_only": "I dipendenti possono caricare dopo aver effettuato l'accesso.",
            "require_user_info": "Chiunque può caricare senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail."
          }
        }
      },
      "no_files_error": "Aggiungere almeno un file.",
      "no_items": "Nessun elemento",
      "options": {
        "access": "Opzioni di accesso",
        "access_options": {
          "for_tracking_only": "Solo a scopo di monitoraggio.",
          "label": "Chi può accedere a questo collegamento",
          "message_for_hipaa": "Non è possibile condividere file pubblicamente, perché il supporto HIPAA è abilitato sull'account. Contattare l'amministratore.",
          "message_for_hipaa_edit": "Non è possibile modificare i file perché il supporto HIPAA è abilitato sull'account. Contattare l'amministratore.",
          "selections": {
            "anyone": "Chiunque (pubblico)",
            "clients_and_employees": "Utenti clienti e dipendenti (dopo aver effettuato l'accesso)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Utenti dipendenti (dopo aver effettuato l'accesso)",
            "name_and_email": "Chiunque (pubblico, occorre inserire un nome e un indirizzo e-mail)"
          },
          "set_by_admin": "L'amministratore ha impostato questa opzione.",
          "tooltip": "Questi sono i requisiti dei destinatari di questo collegamento. Gli utenti dipendenti sono in genere persone interne all'azienda."
        },
        "add_watermark": "Aggiungere una filigrana",
        "allow_recipients": {
          "edit_about_link": "Informazioni sulla modifica di Office Online",
          "edit_tooltip": "I diritti di accesso alla modifica consentono agli utenti di modificare i file condivisi online. Alcuni tipi di file non supportano la modifica.",
          "select_label": "Consenti ai destinatari di:",
          "tooltip": "La visualizzazione online impedisce solo di scaricare il file. Alcuni tipi di file non supportano la filigrana o la condivisione di sola visualizzazione.",
          "tooltip_about_view_only_link": "Informazioni sulla condivisione di sola visualizzazione",
          "tooltip_about_watermarking_link": "Informazioni sulla filigrana"
        },
        "downloads_limits": {
          "unlimited": "Senza limiti"
        },
        "downloads_per_user": "Download per utente",
        "edit_disabled_message": "Le impostazioni di condivisione sono state modificate perché è stato aggiunto un file che non supporta la modifica.",
        "edit_options_access_level_warning": {
          "FullControl": "Chiunque può scaricare ciò che stai condividendo senza effettuare l'accesso.",
          "ViewOnline": "Chiunque può visualizzare ciò che stai condividendo senza effettuare l'accesso."
        },
        "edit_options_warning": "Le autorizzazioni cambieranno per tutti coloro che hanno già questo collegamento. È possibile creare un nuovo collegamento se non si desidera modificarlo.",
        "edit_permission_alert_message": "Per consentire ai destinatari di modificare è necessario che effettuino l'accesso.",
        "email_me_accessed": "Invia e-mail quando si accede ai file",
        "encrypt_email": "Crittografa e-mail",
        "encrypt_message": "Consente di aggiungere la crittografia al messaggio e-mail per una maggiore protezione. Nota: i file sono già crittografati.",
        "encrypted_email_enabled": "Le opzioni di accesso sono state modificate perché è stata abilitata la posta elettronica crittografata.",
        "expirations": {
          "after_one_day": "dopo un giorno",
          "after_one_week": "dopo una settimana",
          "after_six_months": "dopo sei mesi",
          "after_three_months": "dopo tre mesi",
          "after_x_days": "dopo {{days}} giorni",
          "after_year": "dopo un anno",
          "never": "mai"
        },
        "latest_version": "Collega sempre all'ultima versione del file",
        "latest_version_help": "La disattivazione di questa opzione fornirà solo un collegamento alla copia corrente del file selezionato.",
        "notifications": "Notifiche",
        "notify_me_accessed": "Avvisami in caso di accesso",
        "persistent_link_conflict": "È già stato creato un collegamento con queste autorizzazioni.",
        "require_login": "Richiedi ai destinatari di accedere",
        "require_login_help": "I destinatari leggeranno il messaggio e scaricheranno gli allegati dopo aver eseguito l'accesso a ShareFile",
        "require_login_help_request": "I destinatari leggeranno il messaggio e caricheranno gli allegati dopo aver eseguito l'accesso a ShareFile",
        "send_copy": "Invia una copia di questa e-mail",
        "views_per_user": "Visualizzazioni per utente"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "I destinatari di questo collegamento possono scaricare dopo aver effettuato l'accesso.",
            "require_user_info": "I destinatari di questo link possono scaricare dopo aver inserito nome ed e-mail."
          },
          "no_require_login": {
            "view_download": "I destinatari di questo collegamento possono visualizzare e scaricare.",
            "view_only": "I destinatari di questo link possono visualizzare online."
          },
          "require_login": {
            "view_download": "I destinatari di questo collegamento possono visualizzare e scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "I destinatari di questo collegamento possono visualizzare, scaricare e modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "I destinatari di questo collegamento possono visualizzare e scaricare con una filigrana dopo aver effettuato l'accesso.",
            "view_only": "I destinatari di questo collegamento possono visualizzare online dopo aver effettuato l'accesso.",
            "view_watermark": "I destinatari di questo link possono visualizzare online con una filigrana dopo aver effettuato l'accesso."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Con questo collegamento chiunque può visualizzare e scaricare.",
            "view_download_watermark": "Con questo collegamento chiunque può visualizzare e scaricare con una filigrana.",
            "view_only": "Con questo collegamento chiunque può visualizzare online.",
            "view_watermark": "Con questo collegamento chiunque può visualizzare online con una filigrana."
          },
          "employee_and_client_only": {
            "view_download": "Gli utenti dotati di questo collegamento possono visualizzare e scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "Gli utenti dotati di questo collegamento possono visualizzare, scaricare e modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "Gli utenti dotati di questo collegamento possono visualizzare e scaricare con una filigrana dopo aver effettuato l'accesso.",
            "view_only": "Gli utenti dotati di questo collegamento possono visualizzare online dopo aver effettuato l'accesso.",
            "view_watermark": "Gli utenti dotati di questo collegamento possono visualizzare online con una filigrana dopo aver effettuato l'accesso."
          },
          "employee_only": {
            "view_download": "I dipendenti dotati di questo collegamento possono visualizzare e scaricare dopo aver effettuato l'accesso.",
            "view_download_edit": "I dipendenti dotati di questo collegamento possono visualizzare, scaricare e modificare dopo aver effettuato l'accesso.",
            "view_download_watermark": "I dipendenti dotati di questo collegamento possono visualizzare e scaricare con una filigrana dopo aver effettuato l'accesso.",
            "view_only": "I dipendenti dotati di questo collegamento possono visualizzare online dopo aver effettuato l'accesso.",
            "view_watermark": "I dipendenti dotati di questo collegamento possono visualizzare online con una filigrana dopo aver effettuato l'accesso."
          },
          "require_user_info": {
            "view_download": "Con questo collegamento chiunque può visualizzare e scaricare dopo aver inserito nome ed e-mail.",
            "view_download_watermark": "Con questo collegamento chiunque può visualizzare e scaricare con una filigrana dopo aver inserito nome ed e-mail.",
            "view_only": "Con questo collegamento chiunque può visualizzare online dopo aver inserito nome ed e-mail.",
            "view_watermark": "Con questo collegamento chiunque può visualizzare online con una filigrana dopo aver inserito nome ed e-mail."
          }
        }
      },
      "progress": {
        "progress": "Avanzamento",
        "sending": "Invio in corso. Non chiudere la finestra.",
        "upload_then_send": "Caricamento e invio del file. Non chiudere la finestra."
      },
      "remember_message": "Ricorda oggetto e messaggio",
      "request": "Richiedi",
      "request_files": "Richiedere i file",
      "required": "* Obbligatorio",
      "send": "Invia",
      "send_to_specific_people": "Invia a persone specifiche",
      "sending_cancel_confirm": "Annullare il messaggio? L'invio è in corso.",
      "share_access_label": "Consenti a chi ha questo collegamento",
      "share_bundle": "Condividi - Bundle",
      "share_files": "Condividi file",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "I destinatari possono scaricare dopo aver effettuato l'accesso.",
              "require_user_info": "Chiunque può accedere se può inserire l'indirizzo e-mail di un destinatario."
            },
            "no_require_login": {
              "view_download": "Chiunque può scaricare senza effettuare l'accesso.",
              "view_only": "Chiunque può visualizzare senza effettuare l'accesso."
            },
            "require_login": {
              "view_download": "I destinatari possono scaricare dopo aver effettuato l'accesso.",
              "view_download_edit": "I destinatari possono modificare dopo aver effettuato l'accesso.",
              "view_download_watermark": "I destinatari possono scaricare con una filigrana dopo aver effettuato l'accesso.",
              "view_only": "I destinatari possono visualizzare online dopo aver effettuato l'accesso.",
              "view_watermark": "I destinatari possono visualizzare online con una filigrana dopo aver effettuato l'accesso."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Chiunque può scaricare senza effettuare l'accesso.",
              "view_download_watermark": "Chiunque può scaricare una copia con filigrana senza effettuare l'accesso.",
              "view_only": "Chiunque può visualizzare senza effettuare l'accesso.",
              "view_watermark": "Chiunque può visualizzare una copia con filigrana senza effettuare l'accesso."
            },
            "employee_and_client_only": {
              "view_download": "Gli utenti possono scaricare dopo aver effettuato l'accesso.",
              "view_download_edit": "Gli utenti possono modificare dopo aver effettuato l'accesso.",
              "view_download_watermark": "Gli utenti possono scaricare una copia con filigrana dopo aver effettuato l'accesso.",
              "view_only": "Gli utenti possono visualizzare dopo aver effettuato l'accesso.",
              "view_watermark": "Gli utenti possono visualizzare una copia con filigrana dopo aver effettuato l'accesso."
            },
            "employee_only": {
              "view_download": "I dipendenti possono scaricare dopo aver effettuato l'accesso.",
              "view_download_edit": "I dipendenti possono modificare dopo aver effettuato l'accesso.",
              "view_download_watermark": "I dipendenti possono scaricare una copia con filigrana dopo aver effettuato l'accesso.",
              "view_only": "I dipendenti possono visualizzare dopo aver effettuato l'accesso.",
              "view_watermark": "I dipendenti possono visualizzare una copia con filigrana dopo aver effettuato l'accesso."
            },
            "require_user_info": {
              "view_download": "Chiunque può scaricare senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
              "view_download_watermark": "Chiunque può scaricare una copia con filigrana senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
              "view_only": "Chiunque può visualizzare senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail.",
              "view_watermark": "Chiunque può visualizzare una copia con filigrana senza effettuare l'accesso se fornisce un nome e un indirizzo e-mail."
            }
          }
        },
        "analyzing_file_content": "Analisi del contenuto del file...",
        "apply_recommended_options": "Applica le opzioni consigliate",
        "applying_recommended_options": "Applicazione delle opzioni consigliate",
        "create_secure_link": "Crea un collegamento sicuro",
        "data_found": "Dati trovati:",
        "expiry_tooltip": {
          "after_one_day": "Il collegamento scadrà dopo un giorno.",
          "after_one_week": "Il collegamento scadrà dopo una settimana.",
          "after_six_months": "Il collegamento scadrà dopo sei mesi.",
          "after_three_months": "Il collegamento scadrà dopo tre mesi.",
          "after_x_days": "Il collegamento scadrà dopo {{days}} giorni.",
          "after_year": "Il collegamento scadrà dopo un anno.",
          "never": "Il collegamento non scadrà mai."
        },
        "feedback": {
          "helpful": "Utile",
          "not_helpful": "Non utile",
          "was_this_helpful": "È stato utile?"
        },
        "file_may_contain_personal_information": "Questo file potrebbe contenere informazioni personali.",
        "file_may_contain_sensitive_information": "Questo file potrebbe contenere informazioni sensibili.",
        "pii_marker_type": {
          "ADDRESS": "Indirizzo",
          "AGE": "Età",
          "AWS_ACCESS_KEY": "Chiave di accesso AWS",
          "AWS_SECRET_KEY": "Chiave segreta AWS",
          "BANK_ACCOUNT_NUMBER": "Numero di conto bancario",
          "BANK_ROUTING": "Instradamento bancario",
          "CA_HEALTH_NUMBER": "Numero sanitario canadese",
          "CA_SOCIAL_INSURANCE_NUMBER": "Numero di previdenza sociale canadese",
          "CREDIT_DEBIT_CVV": "CVV carta di credito/debito",
          "CREDIT_DEBIT_EXPIRY": "Scadenza carta di credito/debito",
          "CREDIT_DEBIT_NUMBER": "Numero di carta di credito/debito",
          "DATE_TIME": "Data/Ora",
          "DRIVER_ID": "ID conducente",
          "EMAIL": "Invia e-mail",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Numero di conto bancario internazionale (IBAN)",
          "IN_AADHAAR": "Numero della carta India Aadhaar",
          "IN_NREGA": "Numero NREGA dell'India",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Numero di conto permanente dell'India (PAN)",
          "IN_VOTER_NUMBER": "Numero di elettore dell'India",
          "IP_ADDRESS": "Indirizzo IP",
          "LICENSE_PLATE": "Targa",
          "MAC_ADDRESS": "Indirizzo MAC",
          "NAME": "Nome",
          "PASSPORT_NUMBER": "Numero di passaporto",
          "PASSWORD": "Password",
          "PHONE": "Telefono",
          "PIN": "PIN",
          "SSN": "Numero di previdenza sociale (SSN)",
          "SWIFT_CODE": "Codice SWIFT",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Numero del servizio sanitario nazionale del Regno Unito",
          "UK_NATIONAL_INSURANCE_NUMBER": "Numero di previdenza nazionale del Regno Unito",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Numero di riferimento unico del contribuente del Regno Unito",
          "URL": "URL",
          "USERNAME": "Nome utente",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "Numero di identificazione fiscale individuale degli Stati Uniti (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "Numero di identificazione del veicolo (VIN)"
        },
        "recommended_tag": "Consigliate",
        "skip": "Ignora",
        "view_details": "Visualizza dettagli",
        "we_are_still_working_on_it": "Ci stiamo ancora lavorando..."
      },
      "subject": "Oggetto",
      "title": "Condividi",
      "to": "A",
      "toast": {
        "connector_filebox_recipients": "Il file verrà copiato nella Cartella condivisione file ed è possibile che i destinatari non riescano ad accedere a esso nell'immediato.",
        "multiple_source_error": "Tutti gli elementi devono provenire dalla stessa origine dati.",
        "scan_warning": "C'è un file di grandi dimensioni in questa condivisione. È possibile inviare il collegamento, ma il download potrebbe non essere disponibile per diversi minuti mentre la nostra scansione antivirus viene completata.",
        "send_success": "Elemento/i inviato/i correttamente.",
        "share_request_success": "Richiesta inviata correttamente",
        "share_send_success": "Condivisione inviata correttamente",
        "upload_error": "Impossibile caricare uno o più file.",
        "upload_in_progress": "È in corso un caricamento. Non chiudere la finestra."
      },
      "upload_location": "Posizione di caricamento",
      "view": "Visualizza",
      "view_access_expires": "L'accesso in visualizzazione scade"
    },
    "shared_folders": "Cartelle condivise",
    "treeview": {
      "cancel": "Annulla",
      "current_location": "(Posizione corrente)",
      "folder_created": "cartella creata",
      "folder_name": "Nome cartella",
      "folder_name_length_error": "Il nome della cartella non può contenere più di {{value}} caratteri.",
      "save": "Salva",
      "untitled": "Senza nome"
    },
    "upload": {
      "add_more": "Aggiungi altro",
      "browse_files": "Sfoglia file",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Annulla",
      "clear_all": "Canc. tutto",
      "drag_drop": "Trascinare i file qui",
      "drop_files_here": "Rilasciare i file qui",
      "edit": "Modifica",
      "failed": "Operazione non riuscita",
      "file_name": "Nome file",
      "folder_warning": "È probabile che alcuni file trascinati siano cartelle. Al momento il caricamento di cartelle non è supportato.",
      "from_computer": "Dal computer",
      "from_sharefile": "Da ShareFile",
      "item_details": "Dettagli elemento",
      "item_failed_to_upload": "Impossibile caricare l'elemento",
      "items_selected": "elemento",
      "more_than_one_item_selected": "elementi",
      "overwrite_same_name": "Sovrascrivere i file con lo stesso nome.",
      "prevent_folders": "La condivisione delle cartelle non è disponibile con questa opzione. Utilizzare file singoli.",
      "save": "Salva",
      "upload": "Carica",
      "upload_to": "Carica in \"{{folderName}}\"",
      "uploaded": "Caricati"
    },
    "validation": {
      "enter_required_value": "Questo campo è obbligatorio."
    },
    "virus": {
      "contact_admin": "Contattare l'amministratore se si ritiene che si tratti di un errore.",
      "file_marked_as_false_positive_title": "Rilevati contenuti dannosi",
      "file_marked_as_false_positive_warn": "Abbiamo rilevato contenuti dannosi in questo file. L'amministratore ha ripristinato l'accesso, ma non possiamo garantire che sia sicuro da aprire.",
      "malicious_file": "Il file è stato identificato come dannoso e potrebbe contenere virus.",
      "malicious_file_block": "Abbiamo rilevato contenuti dannosi e abbiamo limitato l'accesso a questo file. Si consiglia di eliminarlo.",
      "malicious_file_block_action": "È stato selezionato un file con contenuto dannoso.",
      "malicious_file_block_archive": "Abbiamo rilevato contenuti dannosi e abbiamo limitato l'accesso a questo file.",
      "malicious_file_title": "Rilevato file dannoso",
      "malicious_file_warn": "Abbiamo rilevato contenuti dannosi in questo file. Si consiglia di eliminarlo.",
      "malicious_file_warn_action": "È stato selezionato un file con contenuto dannoso. Si consiglia di eliminarlo.",
      "malicious_file_warn_archive": "Abbiamo rilevato contenuti dannosi in questo file.",
      "unscanned_file_block": "Questo file viene analizzato alla ricerca di contenuti dannosi. Aggiornare per visualizzare lo stato più recente.",
      "unscanned_file_block_action": "È stato selezionato un file che viene analizzato alla ricerca di contenuto dannoso. Riprovare più tardi.",
      "unscanned_file_block_title": "Analisi dei file in corso"
    },
    "yes": "Sì",
    "you": "L'utente"
  }
}, {
  "key": "ja",
  "content": {
    "add": "追加",
    "address_book": {
      "address_book": "アドレス帳",
      "address_book_icon_label": "Open Address Book",
      "company": "会社",
      "contact_type": "連絡先の種類",
      "distribution": "配信グループ",
      "employees": "従業員",
      "name": "名前",
      "no_contact": "検索と一致する連絡先はありません",
      "personal": "個人用アドレス帳",
      "shared": "共有アドレス帳"
    },
    "cancel": "キャンセル",
    "caution": "注意",
    "checkout": {
      "about_to_check_out_expire_message": "24 時間で、チェックアウトの有効期限が切れます。チェックアウトしたファイルはほかのユーザーが確認できるようになり、ダウンロードできます。",
      "about_to_check_out_filename": "'{{itemName}}' をチェックアウトしようとしています。",
      "checkedout_multiple_action": "これらのファイルを{{title}}してもよろしいですか?",
      "checkedout_multiple_msg": "1 つまたは複数のファイルがチェックアウトされています。",
      "checkedout_single_date": "{{userName}}がこのファイルをチェックアウトしています。チェックアウトは{{checkedOutDate}}に終了します。",
      "checkedout_single_filename": "{{title}} '{{fileName}}'を実行してもよろしいですか?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "次のファイルのチェックアウトを破棄しようとしています:"
    },
    "contactSelect": {
      "clearValue": "値のクリア",
      "noResults": "結果が見つかりませんでした",
      "searching": "検索中...",
      "select": "選択...",
      "start_typing": "ユーザーを見つけるための入力を開始する"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "続行",
    "continue_anyway": "このまま続行する",
    "copy": {
      "copy": "コピー",
      "copy_target_not_allowed": "選択したアイテムはこのフォルダーにコピーできません。別のフォルダーを試してください。",
      "copying_item_to": "\"{{fileName}}\"を{{destinationFolder}}にコピー中",
      "need_permission": "ここにコピーする権限が必要です。別のサブフォルダーまたはフォルダーにしてください。",
      "title": "コピーしています"
    },
    "create_folder": "フォルダーの作成",
    "done": "完了",
    "favorites": "お気に入り",
    "file_list": {
      "view_all": "すべてのアイテムを表示 ({{count}})"
    },
    "file_list_modal": {
      "dont_show_again": "このメッセージを再度表示しない",
      "move_away_selections": "現在のフォルダーから移動すると、選択は無効になります。"
    },
    "generic_error": "エラーが発生しました",
    "get_approval": {
      "add_approvers": "承認者を追加",
      "approvers": "承認者",
      "approvers_in_order": "承認者は順に承認する必要があります",
      "approvers_tooltip": " これらの個人は承認を提供します。配布グループを追加すると、ユーザーが個別に一覧表示されます。",
      "due_date": "期限:",
      "edit_approval_settings": "承認設定の編集",
      "message": "メッセージ",
      "options": {
        "edit_approval_settings": "承認設定の編集",
        "request_for_new_version": "新しいバージョンのアップロード後に承認依頼を送信する",
        "request_for_new_version_help": "新しいバージョンがアップロードされるたびに、全ユーザーに承認依頼を通知します。",
        "require_login": "参加者のログオンを要求する"
      },
      "send_for_approval": "承認の送信",
      "title": "承認の取得",
      "viewers": "閲覧者",
      "viewers_tooltip": " これらの個人は情報の閲覧、コメントの追加はできても承認はできません。"
    },
    "load_more": "さらに読み込む",
    "move": {
      "cannot_move_to_current": "現在の場所に移動できません。別のサブフォルダーまたはフォルダーを試してください。",
      "cannot_move_to_selected": "現在選択しているフォルダーに移動できません。別のサブフォルダーまたはフォルダーを試してください。",
      "move": "移動",
      "move_target_not_allowed": "選択したアイテムはこのフォルダーに移動できません。別のフォルダーを試してください。",
      "moving_item_to": "\"{{fileName}}\"を{{destinationFolder}}に移動中",
      "need_permission": "ここに移動する権限が必要です。別のサブフォルダーまたはフォルダーにしてください。",
      "title": "移動しています"
    },
    "no": "いいえ",
    "persistent_links": {
      "copy": "コピー",
      "copy_to_clipboard": "クリップボードにリンクがコピーされました",
      "create_link": "リンクの作成",
      "create_new_link": "別のリンクを作成する",
      "delete_link": "リンクの削除",
      "delete_modal_cancel_text": "キャンセル",
      "delete_modal_confirm_text": "リンクを削除",
      "delete_modal_message": "このリンクを削除すると、アクセスできなくなります。アクセスを削除してもよろしいですか?",
      "edit_options": "オプションの編集",
      "expiry_day": "残り 1 日で期限切れ",
      "expiry_days": "残り {{remainingDays}} 日で期限切れ",
      "items": "アイテム",
      "links_to_version": "バージョン ({{creationDate}}、{{creationTime}} に作成) へのリンク",
      "notify_link_access": "このリンクがアクセスされたら通知する",
      "notify_link_access_request": "ファイルがアップロードされたら通知する",
      "replace_link": "リンクの置換",
      "replace_modal_confirm_text": "リンクの置換",
      "replace_modal_message": "このリンクを置き換えると、同じ権限で新しいリンクが作成されます。古いリンクにはアクセスできなくなります。アクセスを削除してもよろしいですか?",
      "toast": {
        "link_created": "リンクが作成され、クリップボードにコピーされました"
      },
      "view_all_items": "すべてのアイテムを表示"
    },
    "personal_folders": "個人用フォルダー",
    "progress": {
      "finalize_upload": "アップロードを終了しています...",
      "hour_remaining": "{{hoursRemaining}} 時間 ",
      "less_1_min_remaining": "1分未満",
      "minute_remaining": "{{minutesRemaining}} 分 ",
      "remaining": "残り時間{{remainingTimeDisplay}} ",
      "retrying": "アップロード エラー: 再試行",
      "second_remaining": "{{secondsRemaining}} 秒 ",
      "shouldnt_take_long": "時間はかかりません...",
      "starting_upload": "アップロードを開始しています...",
      "transfer_progress": "{{total}}の{{progress}}"
    },
    "save": "保存",
    "select": "選択",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "署名できません",
      "title": "署名の送信"
    },
    "share": {
      "access_expires": "アクセスの有効期限が切れます",
      "add_files_from_device": "デバイスからアイテムを追加",
      "add_files_from_sharefile": "ShareFile からアイテムを追加",
      "add_items": "アイテムを追加",
      "add_more_items": "さらにアイテムを追加",
      "back": "戻る",
      "breadcrumbs": "\"{{breadcrumbs}}\"内",
      "cancel": "キャンセル",
      "cancel_confirm": "メッセージをキャンセルしてもよろしいですか?",
      "compose": "作成",
      "copy": "コピー",
      "copy_success": "クリップボードにコピーしました",
      "create_and_copy": "作成してコピー",
      "default_message_subject": "{{name}} がファイルを送信しました",
      "default_message_subject_request": "{{name}}がファイルを要求しています",
      "done": "完了",
      "download": "ダウンロード",
      "edit": "編集",
      "edit_link_options": "リンクオプションの編集",
      "edit_message_options": "メッセージオプションの編集",
      "edit_options": "オプションの編集",
      "edit_sign_in": "編集 (サインインが必要)",
      "email_title": "ShareFileによるメール送信",
      "empty_folder": "このフォルダーは空です",
      "encrypt_message": "このメールを暗号化する",
      "encrypted_message_send_success": "暗号化されたメッセージの送信に成功しました",
      "expiration_changed": "選択されたアイテムのうち 1 つまたは複数が選択されたリンク オプションより早く期限切れになります。",
      "file_box": "ファイルボックス",
      "file_location": "ファイルの場所",
      "from_my_device": "デバイスから",
      "get_a_link": "リンクの取得",
      "get_a_link2": "リンクの取得",
      "get_temp_link": "一時的なリンクを取得",
      "groups_not_supported": "配信グループは暗号化されたメッセージをサポートしていません。",
      "link_options": "リンク オプション",
      "message": "メッセージ",
      "message_encrypted": "このメッセージは暗号化されます。",
      "message_options": "メッセージ オプション",
      "message_send_fail_attachment": "添付ファイルの{{file}}に問題があったため、メッセージは送信されませんでした。",
      "message_send_fail_hard": "今回、メッセージは送信できませんでした。後でもう一度試してください。",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "受信者は、サインイン後にダウンロードできます。",
            "require_user_info": "受信者のメール アドレスを入力できれば、誰でもこのリンクにアクセスできます。"
          },
          "no_require_login": {
            "view_download": "これにより、共有しているものを誰でもサインインなしでダウンロードできるリンクが作成されます。",
            "view_only": "これにより、共有しているものを誰でもサインインなしで表示できるリンクが作成されます。"
          },
          "require_login": {
            "view_download": "受信者は、サインイン後にダウンロードできます。",
            "view_download_edit": "受信者は、サインイン後に編集できます。",
            "view_download_watermark": "受信者は、サインイン後に透かし付きでダウンロードできます。",
            "view_only": "受信者は、サインイン後にオンラインで表示できます。",
            "view_watermark": "受信者は、サインイン後に透かし付きでオンライン表示できます。"
          }
        },
        "link": {
          "anonymous": {
            "view_download": "誰でもサインインなしでダウンロードできます。",
            "view_download_watermark": "誰でもサインインなしで透かし入りのコピーをダウンロードできます。",
            "view_only": "誰でもサインインなしで表示できます。",
            "view_watermark": "誰でもサインインなしで透かし入りのコピーを表示できます。"
          },
          "employee_and_client_only": {
            "view_download": "ユーザーは、サインイン後にダウンロードできます。",
            "view_download_edit": "ユーザーは、サインイン後に編集できます。",
            "view_download_watermark": "ユーザーは、サインイン後に透かし入りのコピーをダウンロードできます。",
            "view_only": "ユーザーは、サインイン後に表示できます。",
            "view_watermark": "ユーザーは、サインイン後に透かし入りのコピーを表示できます。"
          },
          "employee_only": {
            "view_download": "従業員は、サインイン後にダウンロードできます。",
            "view_download_edit": "従業員は、サインイン後に編集できます。",
            "view_download_watermark": "従業員は、サインイン後に透かし入りのコピーをダウンロードできます。",
            "view_only": "従業員は、サインイン後に表示で表示す。",
            "view_watermark": "従業員は、サインイン後に透かし入りのコピーを表示できます。"
          },
          "require_user_info": {
            "view_download": "名前とメール アドレスを入力すれば、誰でもサインインなしでダウンロードできます。",
            "view_download_watermark": "名前とメール アドレスを入力すれば、誰でもサインインなしで透かし入りのコピーをダウンロードできます。",
            "view_only": "名前とメール アドレスを入力すれば、誰でもサインインなしで表示できます。",
            "view_watermark": "名前とメール アドレスを入力すれば、誰でもサインインなしで透かし入りのコピーを表示できます。"
          }
        },
        "share_request": {
          "email": {
            "anonymous": "受信者は、サインインなしでアップロードできます。",
            "require_login": "受信者は、サインイン後にアップロードできます。"
          },
          "link": {
            "anonymous": "誰でもサインインなしでアップロードできます。",
            "employee_and_client_only": "ユーザーは、サインイン後にアップロードできます。",
            "employee_only": "従業員は、サインイン後にアップロードできます。",
            "require_user_info": "名前とメール アドレスを入力すれば、誰でもサインインなしでアップロードできます。"
          }
        }
      },
      "no_files_error": "1 つ以上のファイルを選択してください。",
      "no_items": "アイテムがありません",
      "options": {
        "access": "アクセス オプション",
        "access_options": {
          "for_tracking_only": "追跡目的のみに使用。",
          "label": "このリンクにアクセスできるユーザー",
          "message_for_hipaa": "アカウントで HIPAA サポートが有効になっているため、ファイルをパブリックに共有できません。管理者に連絡してください。",
          "message_for_hipaa_edit": "アカウントで HIPAA サポートが有効になっているため、ファイルを編集できません。管理者に連絡してください。",
          "selections": {
            "anyone": "すべてのユーザー (公開)",
            "clients_and_employees": "クライアントおよび従業員ユーザー (サインイン後)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "従業員ユーザー (サインイン後)",
            "name_and_email": "すべてのユーザー (公開、名前とメールアドレスを入力する必要があります)"
          },
          "set_by_admin": "管理者がこのオプションを設定しました。",
          "tooltip": "これらはこのリンクの受信者の要件です。従業員ユーザーとは通常、社内のユーザーです。"
        },
        "add_watermark": "透かしを追加する",
        "allow_recipients": {
          "edit_about_link": "Office Online での編集について",
          "edit_tooltip": "編集アクセス権により、ユーザーは共有ファイルをオンラインで編集できます。一部のファイルの種類では、編集がサポートされていません。",
          "select_label": "受信者に次を許可します:",
          "tooltip": "オンライン表示専用ではファイルをダウンロードできません。ファイルタイプによっては表示専用の共有や透かしはサポートされません。",
          "tooltip_about_view_only_link": "表示専用の共有について",
          "tooltip_about_watermarking_link": "透かしについて"
        },
        "downloads_limits": {
          "unlimited": "無制限"
        },
        "downloads_per_user": "ユーザーごとのダウンロード回数",
        "edit_disabled_message": "編集がサポートされていないファイルを追加したため、共有設定が変更されました。",
        "edit_options_access_level_warning": {
          "FullControl": "共有しているものを誰でもサインインなしでダウンロードできます。",
          "ViewOnline": "共有しているものを誰でもサインインなしで表示できます。"
        },
        "edit_options_warning": "このリンクをすでに持っているすべてのユーザーの権限が変更されます。このリンクを変更したくない場合は、新しいリンクを作成できます。",
        "edit_permission_alert_message": "受信者が編集するには、サインインする必要があります。",
        "email_me_accessed": "ファイルがアクセスされたらメールで知らせる",
        "encrypt_email": "メールを暗号化",
        "encrypt_message": "さらに保護するためにメールのメッセージを暗号化します。注: ファイルは既に暗号化されています。",
        "encrypted_email_enabled": "暗号化されたメールが有効になっているため、アクセス オプションが調整されました。",
        "expirations": {
          "after_one_day": "1 日後",
          "after_one_week": "1 週間後",
          "after_six_months": "6か月後",
          "after_three_months": "3か月後",
          "after_x_days": "{{days}}日後",
          "after_year": "1年後",
          "never": "無期限"
        },
        "latest_version": "ファイルの最新バージョンに常にリンクを設定",
        "latest_version_help": "このオプションを無効にすると、選択したファイルの現在のコピーにリンクが設定されます。",
        "notifications": "通知",
        "notify_me_accessed": "アクセスされたら通知する",
        "persistent_link_conflict": "これらの権限を持つリンクはすでに作成されています。",
        "require_login": "受信者のサインインを要求する",
        "require_login_help": "受信者はメッセージを読み、ShareFile にログインした後に添付ファイルをダウンロードします。",
        "require_login_help_request": "受信者はメッセージを読み、ShareFile にログインした後に添付ファイルをアップロードします",
        "send_copy": "このメールのコピーを自分に送信する",
        "views_per_user": "ユーザーごとの表示回数"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "このリンクの受信者は、サインイン後にダウンロードできます。",
            "require_user_info": "このリンクの受信者は、名前とメール アドレスを入力してダウンロードできます。"
          },
          "no_require_login": {
            "view_download": "このリンクの受信者は、表示およびダウンロードできます。",
            "view_only": "このリンクの受信者は、オンラインで表示できます。"
          },
          "require_login": {
            "view_download": "このリンクの受信者は、サインイン後に表示およびダウンロードできます。",
            "view_download_edit": "このリンクの受信者は、サインイン後に表示、ダウンロード、および編集できます。",
            "view_download_watermark": "このリンクの受信者は、サインイン後に透かし付きで表示およびダウンロードできます。",
            "view_only": "このリンクの受信者は、サインイン後にオンラインで表示できます。",
            "view_watermark": "このリンクの受信者は、サインイン後に透かし付きでオンライン表示できます。"
          }
        },
        "link": {
          "anonymous": {
            "view_download": "このリンクですべてのユーザーが、表示およびダウンロードできます。",
            "view_download_watermark": "このリンクですべてのユーザーが、透かし付きで表示およびダウンロードできます。",
            "view_only": "このリンクですべてのユーザーが、オンラインで表示できます。",
            "view_watermark": "このリンクですべてのユーザーが、透かし付きでオンライン表示できます。"
          },
          "employee_and_client_only": {
            "view_download": "このリンクで従業員とクライアント ユーザーが、サインイン後に表示およびダウンロードできます。",
            "view_download_edit": "このリンクで従業員とクライアント ユーザーが、サインイン後に表示、ダウンロード、および編集できます。",
            "view_download_watermark": "このリンクで従業員とクライアント ユーザーが、サインイン後に透かし付きで表示およびダウンロードできます。",
            "view_only": "このリンクで従業員およびクライアント ユーザーが、サインイン後にオンラインで表示できます。",
            "view_watermark": "このリンクで従業員とクライアント ユーザーが、サインイン後に透かし付きでオンライン表示できます。"
          },
          "employee_only": {
            "view_download": "このリンクで従業員ユーザーが、サインイン後に表示およびダウンロードできます。",
            "view_download_edit": "このリンクで従業員ユーザーが、サインイン後に表示、ダウンロード、および編集できます。",
            "view_download_watermark": "このリンクで従業員ユーザーが、サインイン後に透かし付きで表示およびダウンロードできます。",
            "view_only": "このリンクで従業員ユーザーが、サインイン後にオンラインで表示できます。",
            "view_watermark": "このリンクで従業員ユーザーが、サインイン後に透かし付きでオンライン表示できます。"
          },
          "require_user_info": {
            "view_download": "このリンクですべてのユーザーが、名前とメール アドレスを入力して表示およびダウンロードできます。",
            "view_download_watermark": "このリンクですべてのユーザーが、名前とメール アドレスを入力して透かし付きで表示およびダウンロードできます。",
            "view_only": "このリンクですべてのユーザーが、名前とメール アドレスを入力してオンラインで表示できます。",
            "view_watermark": "このリンクですべてのユーザーが、名前とメール アドレスを入力して透かし付きでオンライン表示できます。"
          }
        }
      },
      "progress": {
        "progress": "進行状況",
        "sending": "送信しています。ウィンドウは閉じないでください。",
        "upload_then_send": "ファイルをアップロードしてから送信しています。ウィンドウは閉じないでください。"
      },
      "remember_message": "件名とメッセージを記憶する",
      "request": "要求",
      "request_files": "ファイルを要求",
      "required": "*必須",
      "send": "送信",
      "send_to_specific_people": "特定の相手への送信",
      "sending_cancel_confirm": "メッセージをキャンセルしてもよろしいですか?送信は処理中です。",
      "share_access_label": "このリンクの受信者に許可するアクセス権限",
      "share_bundle": "共有 - パッケージ",
      "share_files": "ファイルの共有",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "受信者は、サインイン後にダウンロードできます。",
              "require_user_info": "受信者のメール アドレスを入力できれば、誰でもアクセスできます。"
            },
            "no_require_login": {
              "view_download": "誰でもサインインなしでダウンロードできます。",
              "view_only": "誰でもサインインなしで表示できます。"
            },
            "require_login": {
              "view_download": "受信者は、サインイン後にダウンロードできます。",
              "view_download_edit": "受信者は、サインイン後に編集できます。",
              "view_download_watermark": "受信者は、サインイン後に透かし付きでダウンロードできます。",
              "view_only": "受信者は、サインイン後にオンラインで表示できます。",
              "view_watermark": "受信者は、サインイン後に透かし付きでオンライン表示できます。"
            }
          },
          "link": {
            "anonymous": {
              "view_download": "誰でもサインインなしでダウンロードできます。",
              "view_download_watermark": "誰でもサインインなしで透かし入りのコピーをダウンロードできます。",
              "view_only": "誰でもサインインなしで表示できます。",
              "view_watermark": "誰でもサインインなしで透かし入りのコピーを表示できます。"
            },
            "employee_and_client_only": {
              "view_download": "ユーザーは、サインイン後にダウンロードできます。",
              "view_download_edit": "ユーザーは、サインイン後に編集できます。",
              "view_download_watermark": "ユーザーは、サインイン後に透かし入りのコピーをダウンロードできます。",
              "view_only": "ユーザーは、サインイン後に表示できます。",
              "view_watermark": "ユーザーは、サインイン後に透かし入りのコピーを表示できます。"
            },
            "employee_only": {
              "view_download": "従業員は、サインイン後にダウンロードできます。",
              "view_download_edit": "従業員は、サインイン後に編集できます。",
              "view_download_watermark": "従業員は、サインイン後に透かし入りのコピーをダウンロードできます。",
              "view_only": "従業員は、サインイン後に表示で表示す。",
              "view_watermark": "従業員は、サインイン後に透かし入りのコピーを表示できます。"
            },
            "require_user_info": {
              "view_download": "名前とメール アドレスを入力すれば、誰でもサインインなしでダウンロードできます。",
              "view_download_watermark": "名前とメール アドレスを入力すれば、誰でもサインインなしで透かし入りのコピーをダウンロードできます。",
              "view_only": "名前とメール アドレスを入力すれば、誰でもサインインなしで表示できます。",
              "view_watermark": "名前とメール アドレスを入力すれば、誰でもサインインなしで透かし入りのコピーを表示できます。"
            }
          }
        },
        "analyzing_file_content": "ファイル コンテンツを分析中...",
        "apply_recommended_options": "推奨オプションを適用する",
        "applying_recommended_options": "推奨オプションを適用しています",
        "create_secure_link": "セキュア リンクを作成する",
        "data_found": "見つかったデータ:",
        "expiry_tooltip": {
          "after_one_day": "リンクは 1 日後に期限切れになります。",
          "after_one_week": "リンクは 1 週間後に期限切れになります。",
          "after_six_months": "リンクは 6 か月後に期限切れになります。",
          "after_three_months": "リンクは 3 か月後に期限切れになります。",
          "after_x_days": "リンクは {{days}} 日後に期限切れになります。",
          "after_year": "リンクは 1 年後に期限切れになります。",
          "never": "リンクに有効期限はありません。"
        },
        "feedback": {
          "helpful": "役に立つ",
          "not_helpful": "役に立たない",
          "was_this_helpful": "これは役に立ちましたか?"
        },
        "file_may_contain_personal_information": "このファイルには個人情報が含まれている可能性があります。",
        "file_may_contain_sensitive_information": "このファイルには機密情報が含まれている可能性があります。",
        "pii_marker_type": {
          "ADDRESS": "アドレス",
          "AGE": "年齢",
          "AWS_ACCESS_KEY": "AWS アクセス キー",
          "AWS_SECRET_KEY": "AWS 秘密キー",
          "BANK_ACCOUNT_NUMBER": "銀行口座番号",
          "BANK_ROUTING": "銀行のルーティング",
          "CA_HEALTH_NUMBER": "カナダの健康保険番号",
          "CA_SOCIAL_INSURANCE_NUMBER": "カナダの社会保険番号",
          "CREDIT_DEBIT_CVV": "クレジット/デビットの CVV",
          "CREDIT_DEBIT_EXPIRY": "クレジット/デビットカードの有効期限",
          "CREDIT_DEBIT_NUMBER": "クレジット/デビット カード番号",
          "DATE_TIME": "日付/時刻",
          "DRIVER_ID": "ドライバー ID",
          "EMAIL": "メール",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "国際銀行口座番号 (IBAN)",
          "IN_AADHAAR": "インドの Aadhaar カード番号",
          "IN_NREGA": "インドの NREGA 番号",
          "IN_PERMANENT_ACCOUNT_NUMBER": "インドの納税者番号 (PAN)",
          "IN_VOTER_NUMBER": "インドの投票者番号",
          "IP_ADDRESS": "IPアドレス",
          "LICENSE_PLATE": "ナンバー プレート",
          "MAC_ADDRESS": "MACアドレス",
          "NAME": "名前",
          "PASSPORT_NUMBER": "パスポート番号",
          "PASSWORD": "パスワード",
          "PHONE": "電話",
          "PIN": "PIN",
          "SSN": "社会保障番号 (SSN)",
          "SWIFT_CODE": "SWIFT コード",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "英国の国民保健サービス番号",
          "UK_NATIONAL_INSURANCE_NUMBER": "英国の社会保険番号",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "英国の固有納税者番号",
          "URL": "URL",
          "USERNAME": "ユーザー名",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "米国の個人納税者番号 (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "車両識別番号 (VIN)"
        },
        "recommended_tag": "推奨",
        "skip": "スキップ",
        "view_details": "詳細を表示",
        "we_are_still_working_on_it": "まだ作業中です..."
      },
      "subject": "件名",
      "title": "共有",
      "to": "対象",
      "toast": {
        "connector_filebox_recipients": "このファイルはファイル ボックスにコピーされ、受信者にはすぐにアクセスする権限がないことがあります。",
        "multiple_source_error": "すべてのアイテムが同じデータソースである必要があります。",
        "scan_warning": "この共有には大きなファイルがあります。リンクを送信することはできますが、ウイルス スキャンが完了するまでの数分間はダウンロードが利用できない場合があります。",
        "send_success": "アイテムの送信に成功しました。",
        "share_request_success": "要求の送信に成功しました",
        "share_send_success": "共有の送信に成功しました",
        "upload_error": "1 つまたは複数のファイルがアップロードできませんでした。",
        "upload_in_progress": "アップロードが進行中です。ウィンドウは閉じないでください。"
      },
      "upload_location": "アップロードの場所",
      "view": "ビュー",
      "view_access_expires": "表示アクセスの有効期限"
    },
    "shared_folders": "共有フォルダー",
    "treeview": {
      "cancel": "キャンセル",
      "current_location": "(現在の場所)",
      "folder_created": "フォルダーが作成されました",
      "folder_name": "フォルダー名",
      "folder_name_length_error": "フォルダー名は {{value}} 文字以内にする必要があります。",
      "save": "保存",
      "untitled": "名称未設定"
    },
    "upload": {
      "add_more": "さらに追加",
      "browse_files": "ファイルの参照",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "キャンセル",
      "clear_all": "すべてクリア",
      "drag_drop": "ここにファイルをドラッグ",
      "drop_files_here": "ここにファイルをドロップ",
      "edit": "編集",
      "failed": "失敗しました",
      "file_name": "ファイル名",
      "folder_warning": "ドラッグした 1 つまたは複数のファイルがフォルダーのようです。フォルダーのアップロード機能は現在サポートされていません。",
      "from_computer": "コンピューターから",
      "from_sharefile": "ShareFile から",
      "item_details": "アイテムの詳細",
      "item_failed_to_upload": "アイテムをアップロードできませんでした",
      "items_selected": "アイテム",
      "more_than_one_item_selected": "アイテム",
      "overwrite_same_name": "同じ名前のファイルを上書きします。",
      "prevent_folders": "フォルダーの共有は、このオプションで利用できません。ファイルを個別に使用してください。",
      "save": "保存",
      "upload": "アップロード",
      "upload_to": "\"{{folderName}}\"にアップロードする",
      "uploaded": "アップロードしました"
    },
    "validation": {
      "enter_required_value": "このフィールドは必須です。"
    },
    "virus": {
      "contact_admin": "これがエラーだと思われる場合は、管理者に連絡してください。",
      "file_marked_as_false_positive_title": "悪意のあるコンテンツが検出されました",
      "file_marked_as_false_positive_warn": "このファイルで悪意のあるコンテンツが検出されました。管理者がアクセスを復元しましたが、安全に開けるかどうかは保証できません。",
      "malicious_file": "このファイルは悪意のあるファイルとして識別され、ウィルスが含まれている可能性があります。",
      "malicious_file_block": "このファイルで悪意のあるコンテンツが検出され、アクセスが制限されています。削除することをお勧めします。",
      "malicious_file_block_action": "悪意のあるコンテンツを含むファイルを選択しました。",
      "malicious_file_block_archive": "このファイルで悪意のあるコンテンツが検出され、アクセスが制限されています。",
      "malicious_file_title": "悪意のあるファイルが検出されました",
      "malicious_file_warn": "このファイルで悪意のあるコンテンツが検出されました。削除することをお勧めします。",
      "malicious_file_warn_action": "悪意のあるコンテンツを含むファイルを選択しました。削除することをお勧めします。",
      "malicious_file_warn_archive": "このファイルで悪意のあるコンテンツが検出されました。",
      "unscanned_file_block": "このファイルに悪意のあるコンテンツが存在しないかどうか、スキャンしています。最新の状態を表示するには、表示を更新してください。",
      "unscanned_file_block_action": "悪意のあるコンテンツをスキャン中のファイルを選択しました。後でもう一度試してください。",
      "unscanned_file_block_title": "ファイル スキャンが進行中です"
    },
    "yes": "はい",
    "you": "あなた"
  }
}, {
  "key": "nl",
  "content": {
    "add": "Toevoegen",
    "address_book": {
      "address_book": "Adresboek",
      "address_book_icon_label": "Open Address Book",
      "company": "Bedrijf",
      "contact_type": "Contacttype",
      "distribution": "Distributiegroep",
      "employees": "Medewerkers",
      "name": "Naam",
      "no_contact": "Uw zoekopdracht heeft geen contactpersonen gevonden",
      "personal": "Persoonlijk adresboek",
      "shared": "Gedeeld adresboek"
    },
    "cancel": "Annuleren",
    "caution": "Let op",
    "checkout": {
      "about_to_check_out_expire_message": "Het uitchecken verloopt over 24 uur. Andere gebruikers kunnen zien dat u het bestand hebt uitgecheckt en kunnen het bestand nog steeds downloaden.",
      "about_to_check_out_filename": "U staat op het punt om '{{itemName}}' uit te checken.",
      "checkedout_multiple_action": "Weet u zeker dat u deze bestanden wilt {{title}}?",
      "checkedout_multiple_msg": "Eén of meer bestanden zijn uitgecheckt.",
      "checkedout_single_date": "{{userName}} heeft dit bestand uitgecheckt. Het uitchecken verloopt op {{checkedOutDate}}.",
      "checkedout_single_filename": "Weet u zeker dat u '{{fileName}}' wilt {{title}}?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "U staat op het punt het uitchecken te negeren van"
    },
    "contactSelect": {
      "clearValue": "Waarde wissen",
      "noResults": "Geen resultaten gevonden",
      "searching": "Zoeken...",
      "select": "Selecteren...",
      "start_typing": "Begin met typen om gebruikers te vinden"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Doorgaan",
    "continue_anyway": "Toch doorgaan",
    "copy": {
      "copy": "Kopiëren",
      "copy_target_not_allowed": "Het door u geselecteerde item kan niet naar deze map worden gekopieerd. Probeer een andere map.",
      "copying_item_to": "\"{{fileName}}\" naar {{destinationFolder}} kopiëren",
      "copying_item_to_plural": "{{count}} items naar {{destinationFolder}} kopiëren",
      "need_permission": "Machtiging vereist om hier naartoe te kopiëren. Probeer een andere submap of een andere map.",
      "title": "Bezig met kopiëren"
    },
    "create_folder": "Map maken",
    "done": "Klaar",
    "favorites": "Favorieten",
    "file_list": {
      "view_all": "Alle {{count}} items weergeven"
    },
    "file_list_modal": {
      "dont_show_again": "Dit bericht niet meer weergeven",
      "move_away_selections": "Als u de huidige map verlaat, gaat uw selectie verloren."
    },
    "generic_error": "Er is een fout opgetreden",
    "get_approval": {
      "add_approvers": "Fiatteurs toevoegen",
      "approvers": "Fiatteurs",
      "approvers_in_order": "Fiatteurs moeten in aangegeven volgorde goedkeuren",
      "approvers_tooltip": " Deze personen moeten goedkeuring geven. Als u een distributiegroep toevoegt, worden de personen afzonderlijk vermeld.",
      "due_date": "Vervaldatum:",
      "edit_approval_settings": "Goedkeuringsinstellingen bewerken",
      "message": "Bericht",
      "options": {
        "edit_approval_settings": "Goedkeuringsinstellingen bewerken",
        "request_for_new_version": "Stuur een goedkeuringsaanvraag voor elke nieuwe geüploade versie",
        "request_for_new_version_help": "Elke keer dat een nieuwe versie wordt geüpload, ontvangt iedereen een melding om de nieuwe versie goed te keuren.",
        "require_login": "Vereisen dat deelnemers zich aanmelden"
      },
      "send_for_approval": "Verzenden voor goedkeuring",
      "title": "Goedkeuring krijgen",
      "viewers": "Waarnemers",
      "viewers_tooltip": " Deze personen kunnen informatie bekijken en opmerkingen maken, maar kunnen niet goedkeuren."
    },
    "load_more": "Meer laden",
    "move": {
      "cannot_move_to_current": "Kan niet naar de huidige locatie verplaatsen. Probeer een andere submap of een andere map.",
      "cannot_move_to_selected": "Kan niet naar een map verplaatsen die momenteel is geselecteerd. Probeer een andere submap of een andere map.",
      "move": "Verplaatsen",
      "move_target_not_allowed": "Het door u geselecteerde item kan niet naar deze map worden verplaatst. Probeer een andere map.",
      "moving_item_to": "\"{{fileName}}\" naar \"{{destinationFolder}}\" verplaatsen",
      "moving_item_to_plural": "{{count}} items naar {{destinationFolder}} verplaatsen",
      "need_permission": "Machtiging vereist om hier naartoe te verplaatsen. Probeer een andere submap of een andere map.",
      "title": "Bezig met verplaatsen"
    },
    "no": "Nee",
    "persistent_links": {
      "copy": "Kopiëren",
      "copy_to_clipboard": "Koppeling naar uw klembord gekopieerd",
      "create_link": "Koppeling maken",
      "create_new_link": "Nog een koppeling maken",
      "delete_link": "Koppeling verwijderen",
      "delete_modal_cancel_text": "Annuleren",
      "delete_modal_confirm_text": "Koppeling verwijderen",
      "delete_modal_message": "Als u deze koppeling verwijdert, wordt deze ontoegankelijk. Weet u zeker dat u de toegang wilt verwijderen?",
      "edit_options": "Opties bewerken",
      "expiry_day": "Verloopt over een dag",
      "expiry_days": "Verloopt over {{remainingDays}} dagen",
      "items": "items",
      "links_to_version": "Gekoppeld aan een versie gemaakt op {{creationDate}} om {{creationTime}}",
      "notify_link_access": "Stuur mij een melding wanneer deze koppeling wordt geopend",
      "notify_link_access_request": "Stuur mij een melding wanneer bestanden zijn geüpload",
      "replace_link": "Koppeling vervangen",
      "replace_modal_confirm_text": "Koppeling vervangen",
      "replace_modal_message": "Als u deze koppeling vervangt, wordt er een nieuwe koppeling met dezelfde machtigingen gemaakt. De oude koppeling wordt ontoegankelijk. Weet u zeker dat u de toegang wilt verwijderen?",
      "toast": {
        "link_created": "Koppeling gemaakt en naar het klembord gekopieerd"
      },
      "view_all_items": "Alle items weergeven"
    },
    "personal_folders": "Persoonlijke mappen",
    "progress": {
      "finalize_upload": "Upload voltooien...",
      "hour_remaining": "{{hoursRemaining}} uur ",
      "less_1_min_remaining": "Minder dan een minuut",
      "minute_remaining": "{{minutesRemaining}} min. ",
      "remaining": "{{remainingTimeDisplay}} resterend ",
      "retrying": "Fout bij het uploaden: opnieuw proberen",
      "second_remaining": "{{secondsRemaining}} sec. ",
      "shouldnt_take_long": "Dit duurt niet lang...",
      "starting_upload": "Upload wordt gestart...",
      "transfer_progress": "{{progress}} van {{total}}"
    },
    "save": "Opslaan",
    "select": "Selecteren",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Kan niet ondertekenen",
      "title": "Verzenden voor ondertekening"
    },
    "share": {
      "access_expires": "Toegang verloopt",
      "add_files_from_device": "Items toevoegen vanaf mijn apparaat",
      "add_files_from_sharefile": "Items toevoegen uit ShareFile",
      "add_items": "Items toevoegen",
      "add_more_items": "Meer items toevoegen",
      "back": "Terug",
      "breadcrumbs": "In \"{{breadcrumbs}}\"",
      "cancel": "Annuleren",
      "cancel_confirm": "Weet u zeker dat u het bericht wilt annuleren?",
      "compose": "Opstellen",
      "copy": "Kopiëren",
      "copy_success": "Naar klembord gekopieerd",
      "create_and_copy": "Maken en kopiëren",
      "default_message_subject": "{{name}} heeft bestanden naar u verzonden",
      "default_message_subject_request": "{{name}} heeft bestanden van u aangevraagd",
      "done": "Gereed",
      "download": "downloaden",
      "edit": "Bewerken",
      "edit_link_options": "Koppelingsopties bewerken",
      "edit_message_options": "Berichtopties bewerken",
      "edit_options": "Opties bewerken",
      "edit_sign_in": "Bewerken (aanmelden vereist)",
      "email_title": "E-mail met ShareFile",
      "empty_folder": "Deze map is leeg",
      "encrypt_message": "Deze e-mail versleutelen",
      "encrypted_message_send_success": "Versleuteld bericht verzonden",
      "expiration_changed": "De vervaldatum van een of meer van de geselecteerde items is eerder dan de geselecteerde koppelingsopties.",
      "file_box": "Bestandsvak",
      "file_location": "Bestandslocatie",
      "from_my_device": "Van mijn apparaat",
      "get_a_link": "Koppeling ophalen",
      "get_a_link2": "Koppeling ophalen",
      "get_temp_link": "Tijdelijke koppeling ophalen",
      "groups_not_supported": "Distributiegroepen worden niet ondersteund voor versleutelde berichten.",
      "link_options": "Koppelingsopties",
      "message": "Bericht",
      "message_encrypted": "Dit bericht is versleuteld.",
      "message_options": "Berichtopties",
      "message_send_fail_attachment": "Uw bericht is niet verzonden, omdat er een probleem was met het bijvoegen van het bestand {{file}}.",
      "message_send_fail_hard": "Het bericht kan op dit moment niet worden verzonden. Probeer het later opnieuw.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Ontvangers kunnen downloaden nadat ze zich hebben aangemeld.",
            "require_user_info": "Iedereen heeft toegang tot deze koppeling als ze het e-mailadres van de ontvanger kunnen invoeren."
          },
          "no_require_login": {
            "view_download": "Hiermee wordt een koppeling gemaakt waarmee iedereen kan downloaden wat u deelt zonder zich aan te melden.",
            "view_only": "Hiermee wordt een koppeling gemaakt waarmee iedereen kan weergeven wat u deelt zonder zich aan te melden."
          },
          "require_login": {
            "view_download": "Ontvangers kunnen downloaden nadat ze zich hebben aangemeld.",
            "view_download_edit": "Ontvangers kunnen bewerken nadat ze zich hebben aangemeld.",
            "view_download_watermark": "Ontvangers kunnen downloaden met een watermerk nadat ze zich hebben aangemeld.",
            "view_only": "Ontvangers kunnen online weergeven nadat ze zich hebben aangemeld.",
            "view_watermark": "Ontvangers kunnen online met een watermerk weergeven nadat ze zich hebben aangemeld."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Iedereen kan downloaden zonder zich aan te melden.",
            "view_download_watermark": "Iedereen kan een kopie met watermerk downloaden zonder zich aan te melden.",
            "view_only": "Iedereen kan weergeven zonder zich aan te melden.",
            "view_watermark": "Iedereen kan een kopie met watermerk weergeven zonder zich aan te melden."
          },
          "employee_and_client_only": {
            "view_download": "Gebruikers kunnen downloaden nadat ze zich hebben aangemeld.",
            "view_download_edit": "Gebruikers kunnen bewerken nadat ze zich hebben aangemeld.",
            "view_download_watermark": "Gebruikers kunnen een kopie met watermerk downloaden nadat ze zich hebben aangemeld.",
            "view_only": "Gebruikers kunnen weergeven nadat ze zich hebben aangemeld.",
            "view_watermark": "Gebruikers kunnen een kopie met watermerk weergeven nadat ze zich hebben aangemeld."
          },
          "employee_only": {
            "view_download": "Medewerkers kunnen downloaden nadat ze zich hebben aangemeld.",
            "view_download_edit": "Medewerkers kunnen bewerken nadat ze zich hebben aangemeld.",
            "view_download_watermark": "Medewerkers kunnen een kopie met watermerk downloaden nadat ze zich hebben aangemeld.",
            "view_only": "Medewerkers kunnen weergeven nadat ze zich hebben aangemeld.",
            "view_watermark": "Medewerkers kunnen een kopie met watermerk weergeven nadat ze zich hebben aangemeld."
          },
          "require_user_info": {
            "view_download": "Iedereen die een naam en e-mailadres opgeeft kan downloaden zonder zich aan te melden.",
            "view_download_watermark": "Iedereen die een naam en e-mailadres opgeeft kan een kopie met watermerk downloaden zonder zich aan te melden.",
            "view_only": "Iedereen die een naam en e-mailadres opgeeft kan weergeven zonder zich aan te melden.",
            "view_watermark": "Iedereen die een naam en e-mailadres opgeeft kan een kopie met watermerk weergeven zonder zich aan te melden."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Ontvangers kunnen uploaden zonder zich aan te melden.",
            "require_login": "Ontvangers kunnen uploaden nadat ze zich hebben aangemeld."
          },
          "link": {
            "anonymous": "Iedereen kan uploaden zonder zich aan te melden.",
            "employee_and_client_only": "Gebruikers kunnen uploaden nadat ze zich hebben aangemeld.",
            "employee_only": "Medewerkers kunnen uploaden nadat ze zich hebben aangemeld.",
            "require_user_info": "Iedereen die een naam en e-mailadres opgeeft kan uploaden zonder zich aan te melden."
          }
        }
      },
      "no_files_error": "Voeg minstens een bestand toe.",
      "no_items": "Geen items",
      "options": {
        "access": "Toegangsopties",
        "access_options": {
          "for_tracking_only": "Uitsluitend bedoeld voor trackingdoeleinden.",
          "label": "Wie heeft toegang tot deze koppeling",
          "message_for_hipaa": "U kunt geen bestanden openbaar delen omdat HIPAA-ondersteuning is ingeschakeld voor uw account. Neem contact op met uw beheerder.",
          "message_for_hipaa_edit": "U kunt geen bestanden bewerken omdat HIPAA-ondersteuning is ingeschakeld voor uw account. Neem contact op met uw beheerder.",
          "selections": {
            "anyone": "Iedereen (openbaar)",
            "clients_and_employees": "Klanten en interne gebruikers (na aanmelding)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Interne gebruikers (na aanmelding)",
            "name_and_email": "Iedereen (openbaar, moet een naam en e-mailadres invoeren)"
          },
          "set_by_admin": "Uw beheerder heeft deze optie ingesteld.",
          "tooltip": "Dit zijn de vereisten voor de ontvangers van deze koppeling. Interne gebruikers zijn doorgaans mensen binnen uw bedrijf."
        },
        "add_watermark": "Watermerk toevoegen",
        "allow_recipients": {
          "edit_about_link": "Info over online bewerken in Office",
          "edit_tooltip": "Met toegangsrechten bewerken kunnen gebruikers de gedeelde bestanden online bewerken. Bewerken wordt door sommige bestandstypen niet ondersteund.",
          "select_label": "Ontvangers toestaan:",
          "tooltip": "Met Alleen online weergeven wordt voorkomen dat gebruikers het bestand downloaden. Sommige bestandstypen ondersteunen het delen van alleen weergeven of watermerken niet.",
          "tooltip_about_view_only_link": "Info over delen van alleen weergeven",
          "tooltip_about_watermarking_link": "Info over watermerk"
        },
        "downloads_limits": {
          "unlimited": "Onbeperkt"
        },
        "downloads_per_user": "Downloads per gebruiker",
        "edit_disabled_message": "Uw instellingen voor delen zijn gewijzigd, omdat u een bestand hebt toegevoegd dat bewerken niet ondersteunt.",
        "edit_options_access_level_warning": {
          "FullControl": "Iedereen kan downloaden wat u deelt zonder zich aan te melden.",
          "ViewOnline": "Iedereen kan weergeven wat u deelt zonder zich aan te melden."
        },
        "edit_options_warning": "De machtigingen worden gewijzigd voor iedereen die deze koppeling al heeft. U kunt een nieuwe koppeling maken als u deze niet wilt wijzigen.",
        "edit_permission_alert_message": "Als u ontvangers toestemming geeft om te bewerken, moeten ze zich aanmelden.",
        "email_me_accessed": "Stuur mij een e-mail wanneer er toegang is tot de bestanden",
        "encrypt_email": "E-mail versleutelen",
        "encrypt_message": "Voeg versleuteling toe aan uw e-mailbericht voor extra beveiliging. Uw bestanden zijn al versleuteld.",
        "encrypted_email_enabled": "De toegangsopties zijn aangepast omdat versleutelde e-mail is ingeschakeld.",
        "expirations": {
          "after_one_day": "na een dag",
          "after_one_week": "na een week",
          "after_six_months": "na zes maanden",
          "after_three_months": "na drie maanden",
          "after_x_days": "na {{days}} dagen",
          "after_year": "na een jaar",
          "never": "nooit"
        },
        "latest_version": "Altijd een koppeling maken met de meest recente versie van het bestand",
        "latest_version_help": "Als u deze optie uitschakelt, wordt alleen een koppeling geboden met de huidige kopie van het bestand dat u hebt geselecteerd.",
        "notifications": "Meldingen",
        "notify_me_accessed": "Stuur mij een melding wanneer dit wordt geopend",
        "persistent_link_conflict": "U hebt al een koppeling gemaakt met deze machtigingen.",
        "require_login": "Vereisen dat ontvangers zich aanmelden",
        "require_login_help": "Ontvangers lezen het bericht en kunnen de bijlagen downloaden nadat ze zijn aangemeld bij ShareFile",
        "require_login_help_request": "Ontvangers lezen het bericht en kunnen de bijlagen uploaden nadat ze zijn aangemeld bij ShareFile",
        "send_copy": "Stuur mij een kopie van dit e-mailbericht",
        "views_per_user": "Weergaven per gebruiker"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Ontvangers van deze koppeling hebben na aanmelding toegang tot de download.",
            "require_user_info": "Ontvangers van deze koppeling hebben na het invoeren van naam en e-mailadres toegang tot de download."
          },
          "no_require_login": {
            "view_download": "Ontvangers van deze koppeling hebben toegang tot weergave en download.",
            "view_only": "Ontvangers van deze koppeling hebben toegang tot de onlineweergave."
          },
          "require_login": {
            "view_download": "Ontvangers van deze koppeling hebben na aanmelding toegang tot de weergave en download.",
            "view_download_edit": "Ontvangers van deze koppeling hebben na aanmelding toegang tot weergave, downloaden en bewerken.",
            "view_download_watermark": "Ontvangers van deze koppeling hebben na aanmelding toegang tot de weergave en download met watermerk.",
            "view_only": "Ontvangers van deze koppeling hebben na aanmelding toegang tot de onlineweergave.",
            "view_watermark": "Ontvangers van deze koppeling hebben na aanmelding toegang tot de onlineweergave met watermerk."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Iedereen kan met deze koppeling bestanden weergeven en downloaden.",
            "view_download_watermark": "Iedereen kan met deze koppeling bestanden met een watermerk weergeven en downloaden.",
            "view_only": "Iedereen kan met deze koppeling bestanden online weergeven.",
            "view_watermark": "Iedereen kan met deze koppeling bestanden met een watermerk online weergeven."
          },
          "employee_and_client_only": {
            "view_download": "Gebruikers kunnen na aanmelding met deze koppeling bestanden weergeven en downloaden.",
            "view_download_edit": "Gebruikers kunnen na aanmelding met deze koppeling bestanden weergeven, downloaden en bewerken.",
            "view_download_watermark": "Gebruikers kunnen na aanmelding met deze koppeling bestanden met een watermerk weergeven en downloaden.",
            "view_only": "Gebruikers kunnen na aanmelding met deze koppeling bestanden online weergeven.",
            "view_watermark": "Gebruikers kunnen na aanmelding met deze koppeling bestanden met een watermerk online weergeven."
          },
          "employee_only": {
            "view_download": "Medewerkers kunnen na aanmelding met deze koppeling bestanden weergeven en downloaden.",
            "view_download_edit": "Medewerkers kunnen na aanmelding met deze koppeling bestanden weergaven, downloaden en bewerken.",
            "view_download_watermark": "Medewerkers kunnen na aanmelding met deze koppeling bestanden met een watermerk weeergeven en downloaden.",
            "view_only": "Medewerkers kunnen na aanmelding met deze koppeling bestanden online weergeven.",
            "view_watermark": "Medewerkers kunnen na aanmelding met deze koppeling bestanden met een watermerk online weeergeven."
          },
          "require_user_info": {
            "view_download": "Iedereen kan na het invoeren van naam en e-mailadres bestanden met deze koppeling weergeven en downloaden.",
            "view_download_watermark": "Iedereen kan na het invoeren van naam en e-mailadres met deze koppeling bestanden met een watermerk weergeven en downloaden.",
            "view_only": "Iedereen kan na het invoeren van naam en e-mailadres met deze koppeling bestanden online weergeven.",
            "view_watermark": "Iedereen kan na het invoeren van naam en e-mailadres met deze koppeling bestanden met een watermerk weergeven."
          }
        }
      },
      "progress": {
        "progress": "Voortgang",
        "sending": "Bezig met verzenden. Venster niet sluiten.",
        "upload_then_send": "Het bestand uploaden en verzenden. Venster niet sluiten."
      },
      "remember_message": "Onderwerp en bericht onthouden",
      "request": "Aanvragen",
      "request_files": "Bestanden aanvragen",
      "required": "* Verplicht",
      "send": "Verzenden",
      "send_to_specific_people": "Naar specifieke personen verzenden",
      "sending_cancel_confirm": "Weet u zeker dat u het bericht wilt annuleren? Het bericht wordt op dit moment verzonden.",
      "share_access_label": "Sta mensen met deze koppeling toe",
      "share_bundle": "Delen - Bundel",
      "share_files": "Bestanden delen",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Ontvangers kunnen downloaden nadat ze zich hebben aangemeld.",
              "require_user_info": "Iedereen heeft toegang als ze het e-mailadres van de ontvanger kunnen invoeren."
            },
            "no_require_login": {
              "view_download": "Iedereen kan downloaden zonder zich aan te melden.",
              "view_only": "Iedereen kan weergeven zonder zich aan te melden."
            },
            "require_login": {
              "view_download": "Ontvangers kunnen downloaden nadat ze zich hebben aangemeld.",
              "view_download_edit": "Ontvangers kunnen bewerken nadat ze zich hebben aangemeld.",
              "view_download_watermark": "Ontvangers kunnen downloaden met een watermerk nadat ze zich hebben aangemeld.",
              "view_only": "Ontvangers kunnen online weergeven nadat ze zich hebben aangemeld.",
              "view_watermark": "Ontvangers kunnen online met een watermerk weergeven nadat ze zich hebben aangemeld."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Iedereen kan downloaden zonder zich aan te melden.",
              "view_download_watermark": "Iedereen kan een kopie met watermerk downloaden zonder zich aan te melden.",
              "view_only": "Iedereen kan weergeven zonder zich aan te melden.",
              "view_watermark": "Iedereen kan een kopie met watermerk weergeven zonder zich aan te melden."
            },
            "employee_and_client_only": {
              "view_download": "Gebruikers kunnen downloaden nadat ze zich hebben aangemeld.",
              "view_download_edit": "Gebruikers kunnen bewerken nadat ze zich hebben aangemeld.",
              "view_download_watermark": "Gebruikers kunnen een kopie met watermerk downloaden nadat ze zich hebben aangemeld.",
              "view_only": "Gebruikers kunnen weergeven nadat ze zich hebben aangemeld.",
              "view_watermark": "Gebruikers kunnen een kopie met watermerk weergeven nadat ze zich hebben aangemeld."
            },
            "employee_only": {
              "view_download": "Medewerkers kunnen downloaden nadat ze zich hebben aangemeld.",
              "view_download_edit": "Medewerkers kunnen bewerken nadat ze zich hebben aangemeld.",
              "view_download_watermark": "Medewerkers kunnen een kopie met watermerk downloaden nadat ze zich hebben aangemeld.",
              "view_only": "Medewerkers kunnen weergeven nadat ze zich hebben aangemeld.",
              "view_watermark": "Medewerkers kunnen een kopie met watermerk weergeven nadat ze zich hebben aangemeld."
            },
            "require_user_info": {
              "view_download": "Iedereen die een naam en e-mailadres opgeeft kan downloaden zonder zich aan te melden.",
              "view_download_watermark": "Iedereen die een naam en e-mailadres opgeeft kan een kopie met watermerk downloaden zonder zich aan te melden.",
              "view_only": "Iedereen die een naam en e-mailadres opgeeft kan weergeven zonder zich aan te melden.",
              "view_watermark": "Iedereen die een naam en e-mailadres opgeeft kan een kopie met watermerk weergeven zonder zich aan te melden."
            }
          }
        },
        "analyzing_file_content": "Bestandsinhoud analyseren...",
        "apply_recommended_options": "Aanbevolen opties toepassen",
        "applying_recommended_options": "Aanbevolen opties toepassen",
        "create_secure_link": "Maak een beveiligde koppeling",
        "data_found": "Gevonden gegevens:",
        "expiry_tooltip": {
          "after_one_day": "De link vervalt na één dag.",
          "after_one_week": "De link vervalt na een week.",
          "after_six_months": "De link vervalt na zes maanden.",
          "after_three_months": "De link vervalt na drie maanden.",
          "after_x_days": "De link vervalt na {{days}} dagen.",
          "after_year": "De link vervalt na een jaar.",
          "never": "De link verloopt nooit."
        },
        "feedback": {
          "helpful": "Nuttig",
          "not_helpful": "Niet nuttig",
          "was_this_helpful": "Was dit nuttig?"
        },
        "file_may_contain_personal_information": "Dit bestand kan persoonlijke informatie bevatten.",
        "file_may_contain_sensitive_information": "Dit bestand kan gevoelige informatie bevatten.",
        "pii_marker_type": {
          "ADDRESS": "Adres",
          "AGE": "Leeftijd",
          "AWS_ACCESS_KEY": "AWS-toegangssleutel",
          "AWS_SECRET_KEY": "Geheime AWS-sleutel",
          "BANK_ACCOUNT_NUMBER": "Bankrekeningnummer",
          "BANK_ROUTING": "Bank routering",
          "CA_HEALTH_NUMBER": "Gezondheidsnummer Canada",
          "CA_SOCIAL_INSURANCE_NUMBER": "Sociaal verzekeringsnummer Canada",
          "CREDIT_DEBIT_CVV": "Credit/debet CVV",
          "CREDIT_DEBIT_EXPIRY": "Credit/debet vervaldatum",
          "CREDIT_DEBIT_NUMBER": "Creditcard-/betaalpasnummer",
          "DATE_TIME": "Datum/tijd",
          "DRIVER_ID": "Bestuurders-id",
          "EMAIL": "E-mail",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Internationaal bankrekeningnummer (IBAN)",
          "IN_AADHAAR": "Aadhaar-kaartnummer India",
          "IN_NREGA": "NREGA-nummer India",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Permanent rekeningnummer (PAN) India",
          "IN_VOTER_NUMBER": "Kiezersnummer India",
          "IP_ADDRESS": "IP-adres",
          "LICENSE_PLATE": "Kentekenplaat",
          "MAC_ADDRESS": "MAC-adres",
          "NAME": "Naam",
          "PASSPORT_NUMBER": "Paspoortnummer",
          "PASSWORD": "Wachtwoord",
          "PHONE": "Telefoon",
          "PIN": "Pincode",
          "SSN": "Burgerservicenummer (BSN)",
          "SWIFT_CODE": "SWIFT-code",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Nummer van de nationale gezondheidsdienst VK",
          "UK_NATIONAL_INSURANCE_NUMBER": "Nationaal verzekeringsnummer VK",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Uniek referentienummer voor belastingbetalers VK",
          "URL": "URL",
          "USERNAME": "Gebruikersnaam",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "Individueel belastingidentificatienummer (ITIN) VS",
          "VEHICLE_IDENTIFICATION_NUMBER": "Voertuigidentificatienummer (VIN)"
        },
        "recommended_tag": "Aanbevolen",
        "skip": "Overslaan",
        "view_details": "Details weergeven",
        "we_are_still_working_on_it": "We werken er nog steeds aan..."
      },
      "subject": "Onderwerp",
      "title": "Delen",
      "to": "Aan",
      "toast": {
        "connector_filebox_recipients": "Dit bestand wordt gekopieerd naar Bestandsvak. Het is mogelijk niet direct toegankelijk voor ontvangers.",
        "multiple_source_error": "Alle items moeten afkomstig zijn van dezelfde gegevensbron.",
        "scan_warning": "Er staat een groot bestand in deze share. U kunt uw koppeling verzenden, maar de download is mogelijk enkele minuten niet beschikbaar gedurende de virusscan.",
        "send_success": "Item(s) verzonden.",
        "share_request_success": "Aanvraag is verzonden",
        "share_send_success": "Share is succesvol verzonden",
        "upload_error": "Het uploaden van een of meer bestanden is mislukt.",
        "upload_in_progress": "Er is een upload in uitvoering. Venster niet sluiten."
      },
      "upload_location": "Uploadlocatie",
      "view": "Weergeven",
      "view_access_expires": "Toegang tot weergave verloopt"
    },
    "shared_folders": "Gedeelde mappen",
    "treeview": {
      "cancel": "Annuleren",
      "current_location": "(Huidige locatie)",
      "folder_created": "map gemaakt",
      "folder_name": "Mapnaam",
      "folder_name_length_error": "De mapnaam mag niet langer zijn dan {{value}} tekens.",
      "save": "Opslaan",
      "untitled": "Naamloos"
    },
    "upload": {
      "add_more": "Meer toevoegen",
      "browse_files": "Door bestanden bladeren",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "kB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Annuleren",
      "clear_all": "Alles wissen",
      "drag_drop": "Bestanden hierheen slepen",
      "drop_files_here": "Bestanden hier neerzetten",
      "edit": "Bewerken",
      "failed": "Mislukt",
      "file_name": "Bestandsnaam",
      "folder_warning": "Een of meer bestanden die u in het venster hebt gesleept, is waarschijnlijk een map. Het uploaden van mappen wordt momenteel niet ondersteund.",
      "from_computer": "Van computer",
      "from_sharefile": "Van ShareFile",
      "item_details": "Details item",
      "item_failed_to_upload": "Kan item niet uploaden",
      "items_selected": "item",
      "more_than_one_item_selected": "items",
      "overwrite_same_name": "Bestanden met dezelfde naam overschrijven.",
      "prevent_folders": "Het delen van mappen is niet beschikbaar met deze optie. Gebruik afzonderlijke bestanden.",
      "save": "Opslaan",
      "upload": "Uploaden",
      "upload_to": "Uploaden naar \"{{folderName}}\"",
      "uploaded": "Geüpload"
    },
    "validation": {
      "enter_required_value": "Dit veld is vereist."
    },
    "virus": {
      "contact_admin": "Neem contact op met uw beheerder als u denkt dat dit een fout is.",
      "file_marked_as_false_positive_title": "Schadelijke inhoud gedetecteerd",
      "file_marked_as_false_positive_warn": "We hebben schadelijke inhoud in dit bestand gedetecteerd. Uw beheerder heeft de toegang hersteld, maar we kunnen niet garanderen dat het veilig is om te openen.",
      "malicious_file": "Dit bestand is als schadelijk geïdentificeerd en bevat mogelijk een virus.",
      "malicious_file_block": "We hebben schadelijke inhoud gedetecteerd en hebben de toegang tot dit bestand beperkt. We raden u aan het bestand te verwijderen.",
      "malicious_file_block_action": "U hebt een bestand met schadelijke inhoud geselecteerd.",
      "malicious_file_block_archive": "We hebben schadelijke inhoud gedetecteerd en hebben de toegang tot dit bestand beperkt.",
      "malicious_file_title": "Schadelijk bestand gedetecteerd",
      "malicious_file_warn": "We hebben schadelijke inhoud in dit bestand gedetecteerd. We raden u aan het bestand te verwijderen.",
      "malicious_file_warn_action": "U hebt een bestand met schadelijke inhoud geselecteerd. We raden u aan het bestand te verwijderen.",
      "malicious_file_warn_archive": "We hebben schadelijke inhoud in dit bestand gedetecteerd.",
      "unscanned_file_block": "Dit bestand wordt op schadelijke inhoud gescand. Vernieuw voor de laatste status.",
      "unscanned_file_block_action": "U hebt een bestand geselecteerd dat op schadelijke inhoud wordt gescand. Probeer het later nog eens.",
      "unscanned_file_block_title": "Bestandsscan in uitvoering"
    },
    "yes": "Ja",
    "you": "U"
  }
}, {
  "key": "pt-BR",
  "content": {
    "add": "Adicionar",
    "address_book": {
      "address_book": "Catálogo de Endereços",
      "address_book_icon_label": "Open Address Book",
      "company": "Empresa",
      "contact_type": "Tipo de contato",
      "distribution": "Grupo de distribuição",
      "employees": "Funcionários",
      "name": "Nome",
      "no_contact": "Nenhum contato corresponde à pesquisa",
      "personal": "Catálogo particular de endereços",
      "shared": "Catálogo de endereços compartilhado"
    },
    "cancel": "Cancelar",
    "caution": "Atenção",
    "checkout": {
      "about_to_check_out_expire_message": "Sua desproteção vai expirar em 24 horas. Outros usuários poderão ver que você desprotegeu o arquivo e mesmo assim poderão baixá-lo.",
      "about_to_check_out_filename": "Você está prestes a desproteger '{{itemName}}'.",
      "checkedout_multiple_action": "Tem certeza de que deseja {{title}} esses arquivos?",
      "checkedout_multiple_msg": "Um ou mais arquivos foram desprotegidos.",
      "checkedout_single_date": "{{userName}} desprotegeu este arquivo. A desproteção expira em {{checkedOutDate}}.",
      "checkedout_single_filename": "Tem certeza de que deseja {{title}} '{{fileName}}'?",
      "checkout_discard_filename": "'{{itemName}}'",
      "checkout_discard_msg": "Você está prestes a descartar a desproteção de"
    },
    "contactSelect": {
      "clearValue": "Limpar valor",
      "noResults": "Nenhum resultado encontrado",
      "searching": "Pesquisando...",
      "select": "Selecionar...",
      "start_typing": "Comece a digitar para encontrar usuários"
    },
    "contact_title": "{{name}} ({{email}})",
    "continue": "Continuar",
    "continue_anyway": "Continuar mesmo assim",
    "copy": {
      "copy": "Copiar",
      "copy_target_not_allowed": "O item que você selecionou não pode ser copiado para esta pasta. Tente outra pasta.",
      "copying_item_to": "Copiando \"{{fileName}}\" para {{destinationFolder}}",
      "copying_item_to_plural": "Copiando {{count}} itens para {{destinationFolder}}",
      "need_permission": "É preciso permissão para copiar aqui. Tente outra subpasta ou outra pasta.",
      "title": "Copiando"
    },
    "create_folder": "Criar pasta",
    "done": "Concluído",
    "favorites": "Favoritos",
    "file_list": {
      "view_all": "Exibir todos os {{count}} itens"
    },
    "file_list_modal": {
      "dont_show_again": "Não mostrar esta mensagem novamente",
      "move_away_selections": "Se você sair da pasta atual, suas seleções serão perdidas."
    },
    "generic_error": "Ocorreu um erro",
    "get_approval": {
      "add_approvers": "Adicionar aprovadores",
      "approvers": "Aprovadores",
      "approvers_in_order": "Os aprovadores devem aprovar em ordem",
      "approvers_tooltip": " É necessário que essas pessoas deem sua aprovação. Se você adicionar um grupo de distribuição, as pessoas serão listadas individualmente.",
      "due_date": "Data de vencimento:",
      "edit_approval_settings": "Editar configurações de aprovação",
      "message": "Mensagem",
      "options": {
        "edit_approval_settings": "Editar configurações de aprovação",
        "request_for_new_version": "Enviar uma solicitação de aprovação para cada nova versão carregada",
        "request_for_new_version_help": "Cada vez que uma nova versão é carregada, todos são notificados para aprovar a nova versão.",
        "require_login": "Exigir que os participantes façam login"
      },
      "send_for_approval": "Enviar para aprovação",
      "title": "Obter a aprovação",
      "viewers": "Observadores",
      "viewers_tooltip": " Essas pessoas podem ver informações e fazer comentários, mas não podem aprovar."
    },
    "load_more": "Carregar mais",
    "move": {
      "cannot_move_to_current": "Não é possível mover para a localização atual. Tente outra subpasta ou pasta.",
      "cannot_move_to_selected": "Não é possível mover para uma pasta selecionada no momento. Tente outra subpasta ou pasta.",
      "move": "Mover",
      "move_target_not_allowed": "O item que você selecionou não pode ser movido para esta pasta. Tente outra pasta.",
      "moving_item_to": "Movendo \"{{fileName}}\" para {{destinationFolder}}",
      "moving_item_to_plural": "Movendo {{count}} itens para {{destinationFolder}}",
      "need_permission": "É preciso permissão para mover para cá. Tente outra subpasta ou pasta.",
      "title": "Movendo"
    },
    "no": "Não",
    "persistent_links": {
      "copy": "Copiar",
      "copy_to_clipboard": "O link foi copiado para a sua área de transferência",
      "create_link": "Criar link",
      "create_new_link": "Criar outro link",
      "delete_link": "Excluir link",
      "delete_modal_cancel_text": "Cancelar",
      "delete_modal_confirm_text": "Excluir link",
      "delete_modal_message": "A exclusão deste link o tornará inacessível. Tem certeza de que deseja remover o acesso?",
      "edit_options": "Editar opções",
      "expiry_day": "Expira em um dia",
      "expiry_days": "Expira em {{remainingDays}} dias",
      "items": "Itens",
      "links_to_version": "Links para uma versão criada em {{creationDate}} às {{creationTime}}",
      "notify_link_access": "Notificar-me quando este link for acessado",
      "notify_link_access_request": "Notificar quando os arquivos forem carregados",
      "replace_link": "Substituir link",
      "replace_modal_confirm_text": "Substituir link",
      "replace_modal_message": "Se esse link for substituído, será criado um novo link com as mesmas permissões. O link antigo ficará inacessível. Tem certeza de que deseja remover o acesso?",
      "toast": {
        "link_created": "Link criado e copiado para a área de transferência"
      },
      "view_all_items": "Ver todos os itens"
    },
    "personal_folders": "Pastas pessoais",
    "progress": {
      "finalize_upload": "Terminando o upload...",
      "hour_remaining": "{{hoursRemaining}} h ",
      "less_1_min_remaining": "Menos de um minuto",
      "minute_remaining": "{{minutesRemaining}} min ",
      "remaining": "{{remainingTimeDisplay}} restantes ",
      "retrying": "Falha no upload: tentando novamente",
      "second_remaining": "{{secondsRemaining}} s ",
      "shouldnt_take_long": "Isso não deve demorar...",
      "starting_upload": "Iniciando o upload...",
      "transfer_progress": "{{progress}} de {{total}}"
    },
    "save": "Salvar",
    "select": "Selecionar",
    "select_item": "Group select {{itemName}}",
    "send_for_signature": {
      "error": "Impossível assinar",
      "title": "Enviar para assinatura"
    },
    "share": {
      "access_expires": "O acesso expira",
      "add_files_from_device": "Adicionar itens do meu dispositivo",
      "add_files_from_sharefile": "Adicionar itens do ShareFile",
      "add_items": "Adicionar itens",
      "add_more_items": "Adicionar mais itens",
      "back": "Voltar",
      "breadcrumbs": "Em \"{{breadcrumbs}}\"",
      "cancel": "Cancelar",
      "cancel_confirm": "Tem certeza de que deseja cancelar a mensagem?",
      "compose": "Redigir",
      "copy": "Copiar",
      "copy_success": "Copiado para a área de transferência!",
      "create_and_copy": "Criar e copiar",
      "default_message_subject": "{{name}} enviou arquivos para você",
      "default_message_subject_request": "{{name}} solicitou arquivos de você",
      "done": "Concluído",
      "download": "Download",
      "edit": "Editar",
      "edit_link_options": "Editar opções de link",
      "edit_message_options": "Editar opções de mensagem",
      "edit_options": "Editar opções",
      "edit_sign_in": "Editar (é necessário fazer login)",
      "email_title": "Enviar e-mail com ShareFile",
      "empty_folder": "Esta pasta está vazia",
      "encrypt_message": "Criptografar este email",
      "encrypted_message_send_success": "Mensagem criptografada enviada com sucesso",
      "expiration_changed": "Um ou mais dos itens selecionados têm a data de validade anterior às opções de link selecionadas.",
      "file_box": "Caixa de arquivos",
      "file_location": "Localização do arquivo",
      "from_my_device": "Do meu dispositivo",
      "get_a_link": "Obter um link",
      "get_a_link2": "Obter um link",
      "get_temp_link": "Obter um link temporário",
      "groups_not_supported": "Não há suporte para grupos de distribuição quanto a mensagens criptografadas.",
      "link_options": "Opções de link",
      "message": "Mensagem",
      "message_encrypted": "Esta mensagem está criptografada.",
      "message_options": "Opções de mensagem",
      "message_send_fail_attachment": "Sua mensagem não foi enviada porque houve um problema com o arquivo anexado {{file}}.",
      "message_send_fail_hard": "A mensagem não pode ser enviada no momento. Tente novamente mais tarde.",
      "new_permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Os destinatários podem fazer o download após o login.",
            "require_user_info": "Qualquer pessoa poderá acessar este link se puder inserir o endereço de email do destinatário."
          },
          "no_require_login": {
            "view_download": "Isso criará um link que permite que qualquer pessoa baixe o que você está compartilhando sem fazer login.",
            "view_only": "Isso criará um link que permite que qualquer pessoa veja o que você está compartilhando sem fazer login."
          },
          "require_login": {
            "view_download": "Os destinatários podem fazer o download após o login.",
            "view_download_edit": "Os destinatários podem editar após o login.",
            "view_download_watermark": "Os destinatários podem fazer o download com uma marca d'água após o login.",
            "view_only": "Os destinatários podem visualizar on-line após o login.",
            "view_watermark": "Os destinatários podem ver online com uma marca d'água após o login."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Qualquer pessoa pode fazer download sem fazer login.",
            "view_download_watermark": "Qualquer pessoa pode baixar uma cópia com marca d'água sem fazer login.",
            "view_only": "Qualquer pessoa pode ver sem fazer login.",
            "view_watermark": "Qualquer pessoa pode ver uma cópia com marca d'água sem fazer login."
          },
          "employee_and_client_only": {
            "view_download": "Os usuários podem fazer o download depois de fazer login.",
            "view_download_edit": "Os usuários podem editar após o login.",
            "view_download_watermark": "Os usuários podem baixar uma cópia com marca d'água sem fazer login.",
            "view_only": "Os usuários podem ver após o login.",
            "view_watermark": "Os usuários podem ver uma cópia com marca d'água sem fazer login."
          },
          "employee_only": {
            "view_download": "Os funcionários podem fazer o download depois de fazer login.",
            "view_download_edit": "Os funcionários podem editar após o login.",
            "view_download_watermark": "Os funcionários podem baixar uma cópia com marca d'água sem fazer login.",
            "view_only": "Os funcionários podem ver após o login.",
            "view_watermark": "Os funcionários podem ver uma cópia com marca d'água sem fazer login."
          },
          "require_user_info": {
            "view_download": "Qualquer pessoa pode fazer download sem fazer login se fornecer nome e email.",
            "view_download_watermark": "Qualquer pessoa pode fazer download de uma cópia com marca d'água sem fazer login se fornecer nome e email.",
            "view_only": "Qualquer pessoa pode ver sem fazer login se fornecer nome e email.",
            "view_watermark": "Qualquer pessoa pode ver uma cópia com marca d'água sem fazer login se fornecer nome e email."
          }
        },
        "share_request": {
          "email": {
            "anonymous": "Os destinatários podem fazer o upload sem fazer login.",
            "require_login": "Os destinatários podem fazer o upload após o login."
          },
          "link": {
            "anonymous": "Qualquer pessoa pode fazer upload sem fazer login.",
            "employee_and_client_only": "Os usuários podem fazer upload depois de fazer login.",
            "employee_only": "Os funcionários podem fazer o download depois de fazer login.",
            "require_user_info": "Qualquer pessoa pode fazer upload sem fazer login se fornecer nome e email."
          }
        }
      },
      "no_files_error": "Adicione pelo menos um arquivo.",
      "no_items": "Nenhum item",
      "options": {
        "access": "Opções de acesso",
        "access_options": {
          "for_tracking_only": "Somente para fins de rastreamento.",
          "label": "Quem pode acessar este link",
          "message_for_hipaa": "Você não pode compartilhar arquivos publicamente porque o suporte à HIPAA está ativado em sua conta. Entre em contato com seu administrador.",
          "message_for_hipaa_edit": "Você não pode editar arquivos porque o suporte ao HIPAA está ativado em sua conta. Entre em contato com seu administrador.",
          "selections": {
            "anyone": "Qualquer pessoa (público)",
            "clients_and_employees": "Usuários clientes e funcionários (após fazer login)",
            "contacts_and_employees": "Client contacts and employee users (after signing in)",
            "employees_only": "Usuários funcionários (após fazer login)",
            "name_and_email": "Qualquer pessoa (público, deve inserir nome e email)"
          },
          "set_by_admin": "O seu administrador definiu esta opção.",
          "tooltip": "Estes são os requisitos do destinatário para este link. Normalmente, os usuários funcionários são pessoas dentro de sua empresa."
        },
        "add_watermark": "Adicionar uma marca d'água",
        "allow_recipients": {
          "edit_about_link": "Sobre a edição de conteúdo do Office Online",
          "edit_tooltip": "Os direitos de acesso de edição permitem que os usuários editem os arquivos compartilhados online. Alguns tipos de arquivo não oferecem suporte à edição.",
          "select_label": "Permitir aos destinatários:",
          "tooltip": "A exibição online apenas impede que os usuários baixem o arquivo. Alguns tipos de arquivo não permitem o compartilhamento somente de exibição ou a marca d'água.",
          "tooltip_about_view_only_link": "Sobre o compartilhamento somente de exibição",
          "tooltip_about_watermarking_link": "Sobre marcas d'água"
        },
        "downloads_limits": {
          "unlimited": "Ilimitado"
        },
        "downloads_per_user": "Downloads por usuário",
        "edit_disabled_message": "Suas configurações de compartilhamento foram alteradas porque você adicionou um arquivo que não oferece suporte à edição.",
        "edit_options_access_level_warning": {
          "FullControl": "Qualquer pessoa pode baixar o que você está compartilhando sem fazer login.",
          "ViewOnline": "Qualquer pessoa pode ver o que você está compartilhando sem fazer login."
        },
        "edit_options_warning": "As permissões mudarão para todos que já tenham esse link. Você poderá criar um novo link se não quiser alterá-lo.",
        "edit_permission_alert_message": "Para que os destinatários possam editar, deverão fazer login.",
        "email_me_accessed": "Enviar-me um email quando os arquivos forem acessados",
        "encrypt_email": "Criptografar email",
        "encrypt_message": "Adicione criptografia à sua mensagem de email para proteção extra. Note que seus arquivos já estão criptografados.",
        "encrypted_email_enabled": "As opções de acesso foram ajustadas porque o email criptografado foi ativado.",
        "expirations": {
          "after_one_day": "depois de um dia",
          "after_one_week": "depois de uma semana",
          "after_six_months": "depois de seis meses",
          "after_three_months": "depois de três meses",
          "after_x_days": "depois de {{days}} dias",
          "after_year": "depois de um ano",
          "never": "nunca"
        },
        "latest_version": "Sempre vincular à versão mais recente do arquivo",
        "latest_version_help": "A desativação desta opção só fornecerá um link para a cópia atual do arquivo que você selecionou.",
        "notifications": "Notificações",
        "notify_me_accessed": "Notificar-me quando o link for acessado",
        "persistent_link_conflict": "Você já criou um link com essas permissões.",
        "require_login": "Exigir logon dos destinatários",
        "require_login_help": "Os destinatários lerão a mensagem e baixarão os anexos após efetuar login no ShareFile",
        "require_login_help_request": "Os destinatários lerão a mensagem e carregarão os anexos após efetuar login no ShareFile",
        "send_copy": "Enviar uma cópia deste e-mail",
        "views_per_user": "Exibições por usuário"
      },
      "permissions_banner": {
        "email": {
          "encrypted": {
            "require_login": "Os destinatários deste link podem fazer o download após o login.",
            "require_user_info": "Os destinatários deste link podem fazer o download depois de fornecerem nome e email."
          },
          "no_require_login": {
            "view_download": "Os destinatários desse link podem visualizar e fazer o download.",
            "view_only": "Os destinatários desse link podem visualizar online."
          },
          "require_login": {
            "view_download": "Os destinatários deste link podem visualizar e fazer o download após o login.",
            "view_download_edit": "Os destinatários desse link podem visualizar, baixar e editar depois de fazer login.",
            "view_download_watermark": "Os destinatários desse link podem visualizar e fazer o download com uma marca d'água após o login.",
            "view_only": "Os destinatários deste link podem visualizar online após o login.",
            "view_watermark": "Os destinatários desse link podem ver online com uma marca d'água após o login."
          }
        },
        "link": {
          "anonymous": {
            "view_download": "Qualquer pessoa com esse link pode visualizar e baixar arquivos.",
            "view_download_watermark": "Qualquer pessoa com esse link pode visualizar e baixar arquivos com uma marca d'água.",
            "view_only": "Qualquer pessoa com esse link pode visualizar online.",
            "view_watermark": "Qualquer pessoa com esse link pode visualizar online com uma marca d'água."
          },
          "employee_and_client_only": {
            "view_download": "Os usuários com esse link podem visualizar e fazer o download após o login.",
            "view_download_edit": "Os usuários com esse link podem visualizar, baixar e editar depois de fazer login.",
            "view_download_watermark": "Os usuários com esse link podem visualizar e baixar com uma marca d'água após fazer login.",
            "view_only": "Os usuários com este link podem visualizar online após fazer login.",
            "view_watermark": "Os usuários com esse link podem visualizar on-line com uma marca d'água após o login."
          },
          "employee_only": {
            "view_download": "Os funcionários com esse link podem visualizar e fazer o download após o login.",
            "view_download_edit": "Os funcionários com esse link podem visualizar, baixar e editar depois de fazer login.",
            "view_download_watermark": "Os funcionários com esse link podem visualizar e fazer o download com uma marca d'água após fazer login.",
            "view_only": "Os funcionários com esse link podem visualizar on-line após o login.",
            "view_watermark": "Os funcionários com esse link podem visualizar online com uma marca d'água após o login."
          },
          "require_user_info": {
            "view_download": "Qualquer pessoa com esse link pode visualizar e fazer o download depois de inserir o nome e o email.",
            "view_download_watermark": "Qualquer pessoa com esse link pode visualizar e fazer o download com uma marca d'água depois de inserir o nome e o email.",
            "view_only": "Qualquer pessoa com esse link pode visualizar on-line depois de inserir o nome e o email.",
            "view_watermark": "Qualquer pessoa com esse link pode visualizar online com uma marca d'água depois de inserir o nome e o email."
          }
        }
      },
      "progress": {
        "progress": "Progresso",
        "sending": "Enviando. Mantenha a janela aberta.",
        "upload_then_send": "Fazendo upload e enviando seu arquivo. Mantenha a janela aberta."
      },
      "remember_message": "Lembrar assunto e mensagem",
      "request": "Solicitar",
      "request_files": "Solicitar arquivos",
      "required": "* Obrigatório",
      "send": "Enviar",
      "send_to_specific_people": "Enviar para pessoas específicas",
      "sending_cancel_confirm": "Tem certeza de que deseja cancelar a mensagem? O envio está em andamento.",
      "share_access_label": "Permitir às pessoas com este link",
      "share_bundle": "Compartilhar - Pacote",
      "share_files": "Compartilhar arquivos",
      "share_recommendation": {
        "access_level_tooltip": {
          "email": {
            "encrypted": {
              "require_login": "Os destinatários podem fazer o download após o login.",
              "require_user_info": "Qualquer pessoa poderá acessar se puder inserir o endereço de email do destinatário."
            },
            "no_require_login": {
              "view_download": "Qualquer pessoa pode fazer download sem fazer login.",
              "view_only": "Qualquer pessoa pode ver sem fazer login."
            },
            "require_login": {
              "view_download": "Os destinatários podem fazer o download após o login.",
              "view_download_edit": "Os destinatários podem editar após o login.",
              "view_download_watermark": "Os destinatários podem fazer o download com uma marca d'água após o login.",
              "view_only": "Os destinatários podem visualizar on-line após o login.",
              "view_watermark": "Os destinatários podem ver online com uma marca d'água após o login."
            }
          },
          "link": {
            "anonymous": {
              "view_download": "Qualquer pessoa pode fazer download sem fazer login.",
              "view_download_watermark": "Qualquer pessoa pode baixar uma cópia com marca d'água sem fazer login.",
              "view_only": "Qualquer pessoa pode ver sem fazer login.",
              "view_watermark": "Qualquer pessoa pode ver uma cópia com marca d'água sem fazer login."
            },
            "employee_and_client_only": {
              "view_download": "Os usuários podem fazer o download depois de fazer login.",
              "view_download_edit": "Os usuários podem editar após o login.",
              "view_download_watermark": "Os usuários podem baixar uma cópia com marca d'água sem fazer login.",
              "view_only": "Os usuários podem ver após o login.",
              "view_watermark": "Os usuários podem ver uma cópia com marca d'água sem fazer login."
            },
            "employee_only": {
              "view_download": "Os funcionários podem fazer o download depois de fazer login.",
              "view_download_edit": "Os funcionários podem editar após o login.",
              "view_download_watermark": "Os funcionários podem baixar uma cópia com marca d'água sem fazer login.",
              "view_only": "Os funcionários podem ver após o login.",
              "view_watermark": "Os funcionários podem ver uma cópia com marca d'água sem fazer login."
            },
            "require_user_info": {
              "view_download": "Qualquer pessoa pode fazer download sem fazer login se fornecer nome e email.",
              "view_download_watermark": "Qualquer pessoa pode fazer download de uma cópia com marca d'água sem fazer login se fornecer nome e email.",
              "view_only": "Qualquer pessoa pode ver sem fazer login se fornecer nome e email.",
              "view_watermark": "Qualquer pessoa pode ver uma cópia com marca d'água sem fazer login se fornecer nome e email."
            }
          }
        },
        "analyzing_file_content": "Analisando o conteúdo do arquivo...",
        "apply_recommended_options": "Aplicar opções recomendadas",
        "applying_recommended_options": "Aplicando opções recomendadas",
        "create_secure_link": "Criar um link seguro",
        "data_found": "Dados encontrados:",
        "expiry_tooltip": {
          "after_one_day": "O link expirará após um dia.",
          "after_one_week": "O link expirará após uma semana.",
          "after_six_months": "O link expirará após seis meses.",
          "after_three_months": "O link expirará após três meses.",
          "after_x_days": "O link expirará após {{days}} dias.",
          "after_year": "O link expirará após um ano.",
          "never": "O link nunca expirará."
        },
        "feedback": {
          "helpful": "Útil",
          "not_helpful": "Não é útil",
          "was_this_helpful": "Isso foi útil?"
        },
        "file_may_contain_personal_information": "Este arquivo pode conter informações pessoais.",
        "file_may_contain_sensitive_information": "Este arquivo pode conter informações confidenciais.",
        "pii_marker_type": {
          "ADDRESS": "Endereço",
          "AGE": "Idade",
          "AWS_ACCESS_KEY": "Chave de acesso da AWS",
          "AWS_SECRET_KEY": "Chave secreta da AWS",
          "BANK_ACCOUNT_NUMBER": "Número da conta bancária",
          "BANK_ROUTING": "Roteamento bancário",
          "CA_HEALTH_NUMBER": "Número de saúde do Canadá",
          "CA_SOCIAL_INSURANCE_NUMBER": "Número da segurança social do Canadá",
          "CREDIT_DEBIT_CVV": "CVV de crédito/débito",
          "CREDIT_DEBIT_EXPIRY": "Vencimento de crédito/débito",
          "CREDIT_DEBIT_NUMBER": "Número do cartão de crédito/débito",
          "DATE_TIME": "Data e horário",
          "DRIVER_ID": "ID do motorista",
          "EMAIL": "Email",
          "INTERNATIONAL_BANK_ACCOUNT_NUMBER": "Número de conta bancária internacional (IBAN)",
          "IN_AADHAAR": "Número do cartão Aadhaar da Índia",
          "IN_NREGA": "Número NREGA da Índia",
          "IN_PERMANENT_ACCOUNT_NUMBER": "Número de conta permanente da Índia (PAN)",
          "IN_VOTER_NUMBER": "Número do eleitor da Índia",
          "IP_ADDRESS": "Endereço IP",
          "LICENSE_PLATE": "Placa",
          "MAC_ADDRESS": "Endereço MAC",
          "NAME": "Nome",
          "PASSPORT_NUMBER": "Número do passaporte",
          "PASSWORD": "Senha",
          "PHONE": "Telefone",
          "PIN": "PIN",
          "SSN": "Número da segurança social (SSN)",
          "SWIFT_CODE": "Código SWIFT",
          "UK_NATIONAL_HEALTH_SERVICE_NUMBER": "Número do serviço nacional de saúde do Reino Unido",
          "UK_NATIONAL_INSURANCE_NUMBER": "Número de seguro nacional do Reino Unido",
          "UK_UNIQUE_TAXPAYER_REFERENCE_NUMBER": "Número de referência exclusivo do contribuinte do Reino Unido",
          "URL": "URL",
          "USERNAME": "Nome do usuário",
          "US_INDIVIDUAL_TAX_IDENTIFICATION_NUMBER": "Número de identificação fiscal individual dos EUA (ITIN)",
          "VEHICLE_IDENTIFICATION_NUMBER": "Número de identificação do veículo (VIN)"
        },
        "recommended_tag": "Recomendados",
        "skip": "Pular",
        "view_details": "Exibir detalhes",
        "we_are_still_working_on_it": "Ainda estamos trabalhando nisso..."
      },
      "subject": "Assunto",
      "title": "Compartilhar",
      "to": "Para",
      "toast": {
        "connector_filebox_recipients": "Este arquivo será copiado na Caixa de Arquivos. Talvez os destinatários não tenham acesso imediato.",
        "multiple_source_error": "Todos os itens devem ser da mesma fonte de dados.",
        "scan_warning": "Há um arquivo grande nesse compartilhamento. Você pode enviar seu link, mas o download poderá não estar disponível por alguns minutos enquanto nossa verificação de vírus estiver sendo efetuada.",
        "send_success": "Item(ns) enviado(s) com sucesso.",
        "share_request_success": "Solicitação enviada com sucesso",
        "share_send_success": "Compartilhamento enviado com sucesso",
        "upload_error": "Pelo menos um arquivo não foi carregado.",
        "upload_in_progress": "Há um upload em andamento. Deixe a janela aberta."
      },
      "upload_location": "Local de upload",
      "view": "Visualizar",
      "view_access_expires": "O acesso à exibição expira em"
    },
    "shared_folders": "Pastas compartilhadas",
    "treeview": {
      "cancel": "Cancelar",
      "current_location": "(Localização atual)",
      "folder_created": "pasta criada",
      "folder_name": "Nome da pasta",
      "folder_name_length_error": "O nome da pasta não pode exceder {{value}} caracteres.",
      "save": "Salvar",
      "untitled": "Sem título"
    },
    "upload": {
      "add_more": "Adicionar mais",
      "browse_files": "Navegar arquivos",
      "byte_units": {
        "B": "B",
        "EB": "EB",
        "GB": "GB",
        "KB": "KB",
        "MB": "MB",
        "PB": "PB",
        "TB": "TB",
        "YB": "YB",
        "ZB": "ZB"
      },
      "cancel": "Cancelar",
      "clear_all": "Limpar tudo",
      "drag_drop": "Arraste arquivos aqui",
      "drop_files_here": "Coloque os arquivos aqui",
      "edit": "Editar",
      "failed": "Falha",
      "file_name": "Nome do arquivo",
      "folder_warning": "Parece que um ou mais arquivos que você arrastou podem ser pastas. No momento não há suporte para o upload de pastas.",
      "from_computer": "Do computador",
      "from_sharefile": "Do ShareFile",
      "item_details": "Detalhes do item",
      "item_failed_to_upload": "Falha ao carregar o item",
      "items_selected": "item",
      "more_than_one_item_selected": "itens",
      "overwrite_same_name": "Substituir arquivos que têm o mesmo nome.",
      "prevent_folders": "O compartilhamento de pastas não está disponível com estar opção. Use os arquivos separadamente.",
      "save": "Salvar",
      "upload": "Upload",
      "upload_to": "Carregar em \"{{folderName}}\"",
      "uploaded": "Carregado"
    },
    "validation": {
      "enter_required_value": "Este campo é obrigatório."
    },
    "virus": {
      "contact_admin": "Entre em contato com o administrador se você achar que isso é um erro.",
      "file_marked_as_false_positive_title": "Conteúdo malicioso detectado",
      "file_marked_as_false_positive_warn": "Detectamos conteúdo malicioso nesse arquivo. Seu administrador restaurou o acesso, mas não podemos garantir que seja seguro abri-lo.",
      "malicious_file": "Este arquivo foi identificado como malicioso e pode conter um vírus.",
      "malicious_file_block": "Detectamos conteúdo malicioso e restringimos o acesso a este arquivo. Recomendamos que você o exclua.",
      "malicious_file_block_action": "Você selecionou um arquivo com conteúdo malicioso.",
      "malicious_file_block_archive": "Detectamos conteúdo malicioso e restringimos o acesso a este arquivo.",
      "malicious_file_title": "Arquivo malicioso detectado",
      "malicious_file_warn": "Detectamos conteúdo malicioso neste arquivo. Recomendamos que você o exclua.",
      "malicious_file_warn_action": "Você selecionou um arquivo com conteúdo malicioso. Recomendamos que você o exclua.",
      "malicious_file_warn_archive": "Detectamos conteúdo malicioso nesse arquivo.",
      "unscanned_file_block": "Este arquivo está sendo verificado quanto a conteúdo malicioso. Atualize para obter o status mais recente.",
      "unscanned_file_block_action": "Você selecionou um arquivo que está sendo verificado quanto a conteúdo malicioso. Tente novamente mais tarde.",
      "unscanned_file_block_title": "Verificação de arquivos em andamento"
    },
    "yes": "Sim",
    "you": "Você"
  }
}];